/* Pagina do evento (page.evento) - o NUCLEO: o boot, a vista do convidado e o
 * que ela usa (a parte de quem esta logado mora no mw-evento-org.js; ver "DOIS
 * ARQUIVOS DESDE A R29", no fim deste cabecalho).
 *
 * Carrega SO em /pages/evento, com teto proprio em scripts/check-js-budget.mjs:
 * o numero e a derivacao vivem la (e em docs/eventos/handoff/APLICACAO-EVENTOS.md),
 * e nao se repetem aqui, porque numero repetido envelhece (este cabecalho disse
 * "64KB" ate a R29, com o teto ja em 78). O nucleo global da loja nao muda uma
 * linha por causa deste arquivo.
 *
 * O QUE ESTE ARQUIVO DECIDE (plano de eventos, 5.1 "Modos e precedencia"):
 * a MESMA URL serve para criar, abrir, listar e (na P4b) responder ao convite.
 * Nada disso da para decidir no servidor - o token do convite vive no
 * fragmento, que nunca chega la. Ordem, sem heuristica de referrer:
 *
 *   ?novo=1 > ?e=<id> > ?lista=1 > ?volta=1 > sessionStorage.mw_evento_c >
 *   mw_evento_porta|chave sem parametro > sem parametro = Meus eventos
 *
 * O token do convite vive em CLOSURE: o boot le e apaga o sessionStorage, e so
 * regrava no pagehide. Assim ele sobrevive a reload, back e volta do login sem
 * ficar legivel durante a vida da pagina.
 *
 * A vista do CONVIDADO (banda de RSVP, .ics, estados de vinculo, saidas da
 * LGPD, barra inferior condicional) vive no bloco "VISTA DO CONVIDADO" e monta
 * SEMPRE por POST /convite/ver, pelos dois ramos ({c} do link e {e} da conta):
 * o GET /:id nao devolve nem a linha da propria pessoa nem o estado do vinculo.
 *
 * Toda string sai do JSON #mw-evento-i18n: nenhuma frase nasce aqui.
 *
 * DOIS ARQUIVOS DESDE A R29 (plano R29, secao 3A). Este e o NUCLEO: o que o
 * convidado deslogado alcanca (boot, a vista do convidado, presentes, Curador,
 * as telas de estado e os ajudantes comuns). A parte de quem esta logado (o
 * organizador, "Meus eventos", criar, cancelar e excluir) mora em
 * assets/mw-evento-org.js, uma fabrica que recebe os nomes daqui no objeto X e
 * devolve o que este arquivo chama de volta (bloco "O MODULO DO ORGANIZADOR", no
 * fim). A costura e provada pelo gate scripts/check-evento-divisao.mjs. */
(function () {
  'use strict';

  var root = document.querySelector('[data-mw-evento]');
  if (!root) return;

  var API = '/apps/curador/eventos';
  /* A PONTE i18n VEM EM TRES BLOCOS, e a divisao e por LOGIN, nunca por modo
     (D-T8, com a premissa corrigida): a section NAO sabe o modo - cliente
     logado abrindo evento de terceiro e CONVIDADO, e esse caminho existe de
     proposito. O que sustenta a divisao e que toda superficie de organizador
     exige login. Comum e convidado saem sempre; o bloco do organizador so
     dentro de `{% if customer %}`. */
  /* O `| t` da Shopify escapa para HTML o texto de toda chave sem `_html`: as
     aspas chegam nestes blocos como &quot; (e ' & < > como &#39; &amp; &lt;
     &gt;). O texto vai para a tela por textContent, que nao desfaz entidade, e
     o cliente via o &quot; cru (R30, ponto 2). O desent desfaz na leitura, numa
     passada so e so em string, entao &amp;quot; vira &quot; e nunca aspas.
     Decodificar aqui e seguro porque nada destes blocos vai para innerHTML e
     nenhum tem chave _html. O gate scripts/check-i18n-entidade.mjs guarda as
     duas metades: chave com esses caracteres so em bloco lido com desent, e o
     leitor do bloco chamando o desent. O modulo do organizador recebe o T
     pronto pelo X e nao le bloco nenhum. */
  function desent(k, v) {
    return typeof v == 'string' ? v.replace(/&(quot|#39|#x27|lt|gt|amp);/g, function (m, e) {
      return { quot: '"', lt: '<', gt: '>', amp: '&' }[e] || "'";
    }) : v;
  }
  var T = {};
  ['', '-org', '-conv'].forEach(function (s) {
    var no = document.getElementById('mw-evento-i18n' + s);
    if (!no) return;
    try {
      var o = JSON.parse(no.textContent, desent);
      for (var k in o) T[k] = o[k];
    } catch (e) {}
  });
  /* O GATE MECANICO da divisao, e ele e parte da decisao. Chave classificada no
     bloco errado nao da erro nenhum: devolve `undefined`, a tela fica com um
     buraco, e isso so acontece quando um TERCEIRO abre o link - tarde demais. O
     leitor registra toda chave PEDIDA E NAO ENCONTRADA; o array existe sempre
     (vazio quando nao falta nada), porque o assert do harness afirma que ele
     esta vazio. O que o leitor devolve nao muda em nada. */
  var FALTAM = (window.__mwEvI18nFaltando = []);
  if (window.Proxy) T = new Proxy(T, {
    get: function (o, k) {
      /* a chave VAZIA nao e chave: `pintarServico` usa '' no lugar da frase que
         aquele estado do vinculo nao tem, e `T['']` e a forma de dizer isso */
      if (k && typeof k === 'string' && !(k in o) && FALTAM.indexOf(k) < 0) FALTAM.push(k);
      return o[k];
    }
  });

  var LOGADO = root.getAttribute('data-logado') === 'true';
  var LIGADO = root.getAttribute('data-eventos-on') === 'true';
  var LOGIN = root.getAttribute('data-login-url') || '';
  var URLEV = root.getAttribute('data-evento-url') || '/pages/evento';
  var URLCONTATO = root.getAttribute('data-contato-url') || '/pages/contact';
  var URLLOJA = root.getAttribute('data-loja-url') || '/';
  var URLPRIV = root.getAttribute('data-privacidade-url') || '';
  var UNDO = (parseInt(root.getAttribute('data-undo'), 10) || 7) * 1000;
  var palco = root.querySelector('[data-mwev-palco]');
  /* a regiao viva da resposta (R30, parte L; decisao 91): FORA do palco, que o
     trocar() refaz a cada resposta (nascendo de novo ja com o texto, ela nao
     seria lida). Nula com a section antiga (F8, entre o passo 3 e o 4): ai
     nenhuma frase dela e lida da ponte. */
  var viva = root.querySelector('[data-mw-rsvp-status]');
  /* O MODULO DA ENTREGA no endereco de quem recebe (R31, onda C):
     assets/mw-evento-entrega.js, carregado com defer ANTES deste arquivo (a
     ordem das tags), le a ponte dele e desenha a caixa no Curador. Nulo com a
     section de antes da onda C (sem a tag): ai nada da entrega aparece, e
     nenhuma ponte nova e lida (a publicacao em partes, plano 6.4). Lido por
     propriedade, como o MWEvLista: nao e nome livre. */
  var ENT = window.MWEvEntrega || null;
  /* O MODULO DO PRESENTE de quem comprou (R32): assets/mw-evento-presente.js,
     com defer ANTES deste arquivo. Ele pinta a faixa "Seu presente para Ana esta
     garantido" com o recado (9.2 e 9.3), as tres opcoes rapidas do Curador e o
     "Nova conversa" que desliga o vinculo com o evento (9.4). Aqui ficam so os
     ganchos: o `PRE.faixa(eo)` do pintarConvite e o `PRE.chips(st)` do
     semearCurador. Nulo com a section de antes da R32 (sem a tag): nada disso
     aparece, e nenhuma ponte nova e lida. Lido por propriedade, como o ENT. */
  var PRE = window.MWEvPresente || null;

  /* ---------------- helpers de template e DOM ---------------- */
  function tpl(n) { return root.querySelector('template[data-tpl="' + n + '"]'); }
  function clone(n) { var t = tpl(n); return t ? t.content.firstElementChild.cloneNode(true) : null; }
  function q(no, sel) { return no ? no.querySelector(sel) : null; }
  function qa(no, sel) { return no ? Array.prototype.slice.call(no.querySelectorAll(sel)) : []; }
  function slot(no, n) { return q(no, '[data-slot="' + n + '"]'); }
  function setText(no, n, txt) { tc(slot(no, n), txt); }
  function cond(no, n, mostrar) { var e = q(no, '[data-slot-if="' + n + '"]'); hd(e, !mostrar); return e; }
  function campo(no, f) { return q(no, '[data-field="' + f + '"]') || q(no, '[data-f="' + f + '"]'); }
  function acao(no, a) { return q(no, '[data-a="' + a + '"]'); }
  /* mk('button', ...) ja sai com type='button': botao sem type dentro de form
     submete, e todos os botoes deste arquivo nascem com a mesma linha depois. */
  function mk(tag, cls, txt) {
    var n = document.createElement(tag);
    if (tag === 'button') n.type = 'button';
    if (cls) n.className = cls;
    tc(n, txt);
    return n;
  }
  function S(e, n, v) { if (e) e.setAttribute(n, v); }
  function rmA(e, n) { if (e) e.removeAttribute(n); }
  /* os dois atributos ARIA que a pagina escreve o tempo todo */
  function aria(e, txt) { S(e, 'aria-label', txt); }
  function press(e, ligado) { S(e, 'aria-pressed', ligado ? 'true' : 'false'); }
  /* Os quatro abaixo existem por PESO, nao por elegancia: sao 62 listeners, 58
     `hidden`, 40 `textContent` e 12 `value` neste arquivo. O guarda de nulo
     dentro deles apaga outras tantas linhas de `if (x)` no caminho, e por isso
     quase nenhuma chamada precisa checar o elemento antes de escrever. */
  function on(e, nome, fn) { if (e) e.addEventListener(nome, fn); }
  /* ATRIBUTO, nunca a propriedade. `hidden` e definido em HTMLElement e NAO em
     SVGElement: `svg.hidden = true` cria uma propriedade JS solta que o CSS
     `[hidden]` nunca ve. Os dois carets do acordeao sao SVGs (r06 4.2 pede dois
     icones distintos, nunca um girado), entao o caret ficava PRESO no de
     fechado - o cartao abria, os nomes apareciam e a seta continuava apontando
     para a direita. `aria-expanded` estava certo o tempo todo, no botao, que e
     por isso que nenhuma guarda pegou: so o olho pega. */
  function hd(e, oculto) { if (!e) return; if (oculto) e.setAttribute('hidden', ''); else e.removeAttribute('hidden'); }
  function tc(e, txt) { if (e) e.textContent = txt == null ? '' : txt; }
  /* linha que SOME quando o texto e vazio: frase de estado que nao existe nao
     pode deixar um paragrafo em branco ocupando espaco na tela */
  function txtOuSome(no, n, txt) { var e = slot(no, n); tc(e, txt); hd(e, !txt); }
  /* clique numa acao do template: o par acao()+'click' e o gesto mais repetido
     da pagina inteira. */
  function clique(no, a, fn) { var b = acao(no, a); on(b, 'click', fn); return b; }
  /* Os tres <dialog> da pagina (dialogo, sheet da linha, sheet do card) abrem e
     fecham igual. O close() lanca em navegador sem showModal e o remove() tem
     que rodar do mesmo jeito. */
  function abrirModal(d) {
    on(d, 'close', function () { d.remove(); });
    document.body.appendChild(d);
    /* sem showModal (Safari abaixo de 15.4, o iPad do dono com iOS 12) o dialogo
       abre sem ser modal, em vez de lancar TypeError e nao abrir (R25) */
    /* sem HTMLDialogElement o <dialog> e elemento desconhecido e caia no fim do
       body, abaixo do rodape: o data-sem-modal o prende na tela (CSS da section) */
    if (d.showModal) d.showModal(); else { d.setAttribute('open', ''); d.setAttribute('data-sem-modal', ''); }
  }
  function fecharModal(d) { try { d.close(); } catch (e) {} d.remove(); }
  /* Storage sempre dentro de try: em aba privada o proprio getItem lanca, e
     nenhum destes valores vale derrubar a tela. `loc` escolhe o localStorage;
     valor `undefined` le, `null` apaga. */
  function mem(loc, chave, valor) {
    try {
      var s = loc ? localStorage : sessionStorage;
      if (valor === undefined) return s.getItem(chave);
      if (valor === null) s.removeItem(chave);
      else s.setItem(chave, valor);
    } catch (e) {}
    return null;
  }
  function memJson(loc, chave) {
    try { return JSON.parse(mem(loc, chave) || 'null'); } catch (e) { return null; }
  }
  function fmt(str, map) {
    return String(str || '').replace(/%(\w+)/g, function (_, k) { return map && map[k] != null ? map[k] : ''; });
  }
  /* plural sem tabela: as duas chaves ja vem escolhidas por quem chama */
  function pl(um, muitos, n, map) {
    map = map || {};
    map.n = n;
    return fmt(n === 1 ? um : muitos, map);
  }
  function inicial(nome) { return String(nome || '?').trim().charAt(0).toUpperCase(); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  /* Botao inerte com motivo: aria-disabled em vez de disabled porque o leitor de
     tela precisa ALCANCAR o botao para ouvir por que ele nao serve agora. */
  function inerte(btn, motivo) {
    if (!btn) return;
    if (motivo) { S(btn, 'aria-disabled', 'true'); S(btn, 'title', motivo); }
    else { rmA(btn, 'aria-disabled'); rmA(btn, 'title'); }
  }
  function bloqueado(btn) { return btn && btn.getAttribute('aria-disabled') === 'true'; }
  function trocar(no) {
    if (!palco) return;
    tc(palco, '');
    if (no) palco.appendChild(no);
  }

  /* ---------------- datas ---------------- */
  /* "Sab, 17 de outubro" (ano so quando diferente do corrente). formatToParts e
     nao um template proprio: o "de" e a abreviacao do dia da semana sao da
     locale, nao nossos. */
  function fDia(iso) {
    if (!iso) return '';
    var p = String(iso).split('-');
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    if (isNaN(d.getTime())) return '';
    var o = { weekday: 'short', day: 'numeric', month: 'long' };
    if (+p[0] !== new Date().getFullYear()) o.year = 'numeric';
    var partes = new Intl.DateTimeFormat('pt-BR', o).formatToParts(d);
    var wd = '', s = '';
    for (var i = 0; i < partes.length; i++) {
      var t = partes[i];
      if (t.type === 'weekday') {
        wd = t.value.replace(/\.$/, '');
        wd = wd.charAt(0).toUpperCase() + wd.slice(1);
        continue;
      }
      if (t.type === 'literal' && !s) continue; /* o separador logo apos o dia da semana */
      s += t.value;
    }
    return wd ? wd + ', ' + s : s;
  }
  /* "13h" / "13h30": o minuto zero nao se escreve em pt-BR falado */
  function fHora(h) {
    if (!h) return '';
    var p = String(h).split(':');
    var m = p[1] || '00';
    return String(+p[0]) + (T.q_h || 'h') + (m === '00' ? '' : m);
  }
  function fQuando(ev) {
    if (!ev.data) return T.q_def;
    var s = fDia(ev.data);
    if (ev.hora) s += ', ' + fHora(ev.hora);
    /* termino so com hora (o PUT devolve dataFim null): vale no dia do evento,
       ou no seguinte quando `horaFim <= hora` (derivarEndsAt); o dia so aparece
       quando nao e o do evento, como no termino com data */
    if (ev.dataFim || ev.horaFim) {
      var p = ev.data.split('-');
      var df = ev.dataFim || (ev.hora && ev.horaFim <= ev.hora ? isoDe(new Date(p[0], p[1] - 1, +p[2] + 1)) : ev.data);
      var fim = df === ev.data ? fHora(ev.horaFim) : fDia(df) + (ev.horaFim ? ', ' + fHora(ev.horaFim) : '');
      if (fim) s += ' ' + (T.q_ate || '') + ' ' + fim;
    }
    return s;
  }
  function isoDe(d) {
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function fCurta(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
  }

  /* ---------------- rede ---------------- */
  /* O `v=2` entra AQUI, e so aqui (decisao D-T2). A secao 6.3 do plano lista os
     shims rota a rota porque e o SERVIDOR que precisa servir as duas versoes; o
     tema nao precisa da simetria. Ligar por rota criaria o pior estado possivel:
     a lista de eventos em v=1 e o detalhe em v=2, com dois vocabularios de
     contagem na mesma sessao.
     O discriminador vai na QUERY e nunca no corpo: GET e DELETE nao tem corpo,
     os schemas zod sao `strip` e o PUT do evento recusa chave desconhecida no
     topo. A assinatura do App Proxy e calculada sobre o querystring que o tema
     monta, entao `?v=2` atravessa sem tocar em `verifyProxySignature`.
     AUSENTE = 1, SEMPRE. E isso que protege a aba antiga e o JS em cache. */
  function req(metodo, caminho, corpo, ka) {
    var o = { method: metodo };
    if (ka) o.keepalive = true;
    if (corpo) {
      o.headers = { 'Content-Type': 'application/json' };
      o.body = JSON.stringify(corpo);
    }
    return fetch(API + caminho + (caminho.indexOf('?') < 0 ? '?' : '&') + 'v=2', o).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        j._ok = r.ok;
        j._status = r.status;
        j._retry = r.headers.get('Retry-After');
        return j;
      });
    });
  }

  /* Catalogo fechado de erros (painel/src/lib/eventos/respostas.ts) -> chave de
     locale. Codigo que nao esta aqui cai na mensagem de rede: melhor generica e
     verdadeira do que uma frase inventada para um codigo que ninguem previu. */
  var ERRO = {
    conta_desligada: 'e_conta', eventos_desligados: 'e_desl_c', indisponivel: 'e_rede',
    organizador_bloqueado: 'e_blq_c', corpo_grande: 'f_corpo', tipo_invalido: 'e_rede',
    corpo_invalido: 'e_rede', convite_invalido: 'f_conv', nao_encontrado: 'e_404',
    campo_longo: 'f_long', caracteres: 'f_car', marca: 'f_marca', url: 'f_url', pix: 'f_pix',
    versao: 'f_ver', evento_incompleto: 'f_inc', email_duplicado: 'ct_dup',
    /* os tres que nasceram com o convite em grupo. Sem eles, o teto de nomes, o
       teto do convite e a vaga tomada cairiam todos em `e_rede` - uma mensagem
       falsa ("a conexao falhou") cuja acao sugerida ("tente de novo") nao
       resolve nenhum dos tres. */
    muitos_nomes: 'ad_tnomes', teto_convite: 'ad_tconv', vaga_indisponivel: 'cv_vind',
    vazio: 'ad_nome',
    organizador_sem_email: 'e_semmail', reply_to_nao_aceito: 'f_reply',
    status_nao_pendente: 'a_lst', sou_eu: 'h_soueu_erro', status_travado: 'f_trav',
    homenageado_travado: 'm_home', prazo_fechado: 'f_pfech', cancelar_primeiro: 'ex_bc',
    rsvp_encerrado: 'f_pfech', evento_cancelado: 'f_ecanc', outra_conta: 'e_outra',
    prazo_aberto: 'e_rede', teto: 'f_teto',
    campo_nao_permitido: 'e_rede', data_passada: 'q_passada',
    teto_eventos: 'e_teto', evento_realizado: 'e_real', fora_da_janela: 'e_rede',
    ja_pedido: 'f_ja', muitas_chamadas: 'e_aguard', origem_invalida: 'e_rede',
    /* rotas POR LINHA (convite, lembrar, pedir-nova-resposta): o servidor so
       responde ok quando a linha entrou na fila, e cada recusa e fato do
       proprio organizador, com frase propria. O `teto` acima e so o agregado
       do dia; o do destino tem codigo separado. */
    ja_lembrado_hoje: 'a_lteto', teto_destino: 'p_teto', inelegivel: 'p_inel',
    ja_enviado: 'a_i_geral', reenvio_indisponivel: 'a_i_geral',
    /* R31 (parte OCASIOES): o teto de "Pra quem e" do casal (decisao 101) e o
       aniversario sem aniversariante (decisao 112); vem com {limite} e {minimo} */
    limite_homenageados: 'h_lim', falta_homenageado: 'a_i_home',
    /* SESSAO, nao conexao (R29): o App Proxy sem cliente logado e a assinatura
       recusada sao 401, e "A conexao falhou" mandava tentar de novo o que so
       um login resolve. A frase mora no bloco -org (so o organizador tem
       sessao a perder); fora dele o msgErro cai no e_rede, como antes. */
    nao_logado: 'e_sexp', assinatura_invalida: 'e_sexp'
  };
  function msgErro(j) {
    /* reenvio cedo demais vem com `horas` (inteiro, minimo 1) ate liberar */
    if (j && j.erro === 'reenvio_cedo') return pl(T.a_i_rec1, T.a_i_recn, +j.horas || 1, { horas: j.horas });
    /* o 401 sem codigo e a mesma sessao; os outros status seguem o mapa */
    var k = ERRO[j && j.erro] || (j && j._status === 401 ? 'e_sexp' : '');
    /* o e_sexp mora no bloco -org, que so sai para quem esta logado: sem ele o
       Proxy do T registraria a chave como faltando (e a guarda i18n-sem-buraco
       acusaria); o deslogado fica no e_rede de sempre */
    if (k === 'e_sexp' && !LOGADO) k = '';
    /* campo_longo: o servidor nao manda o teto; os de validacao.ts por campo
       (TETOS_CAMPO), que sao tambem o maxlength dos campos. O email e o
       telefone do contato entraram na R29: ate ali o 400 deles dizia 80. */
    if (k === 'f_long') return fmt(T.f_long, { limite: j.limite || { nome: 80, subtitulo: 120, localTexto: 200, recado: 2000, email: 200, telefone: 20 }[j.campo] || 80 });
    /* os dois tetos do convite vem com o numero no corpo: o do parser (8 nomes
       por digitada) e o do convite inteiro. As saidas sao diferentes - um manda
       incluir o resto depois, o outro manda abrir outro convite -, e por isso
       sao duas frases e nao uma. */
    if (k === 'ad_tnomes' || k === 'ad_tconv') return fmt(T[k], { teto: j.teto });
    /* pontes novas da R31: com a section antiga (a publicacao em partes) o
       codigo cai na frase de rede, como no JS de antes (plano 4.0 item 14) */
    if (k === 'h_lim' || k === 'a_i_home') return k in T ? fmt(T[k], { limite: j.limite, minimo: j.minimo }) : T.e_rede;
    return (k && T[k]) || T.e_rede;
  }
  /* `aoClicar` transforma o PROPRIO texto do toast em link, sem rotulo extra ao
     lado (5.1: o erro de rascunho incompleto leva ao campo que falta). Rotulo
     separado exigiria uma frase nova, e frase nova nao nasce aqui. */
  function bad(txt, aoClicar) { toast(txt, { erro: true, aoTexto: aoClicar || null }); }
  /* Corpo de acesso das rotas que atendem os DOIS ramos (/sugestoes e todas as
     de /convite): o token quando o convite chegou pelo link, o id do evento
     quando a pessoa entrou pela conta. O organizador nunca tem token em
     closure, entao para ele isto e sempre { e }. */
  function corpoAcesso(extra) {
    var c = tokenConvite ? { c: tokenConvite } : { e: st.id };
    for (var k in extra) c[k] = extra[k];
    return c;
  }
  /* Chamada cujo erro SEMPRE vira toast. `especial` mapeia codigo do servidor
     para a frase propria daquele caso; o que nao estiver la cai em msgErro. */
  function pede(metodo, caminho, corpo, ok, especial) {
    return req(metodo, caminho, corpo).then(function (j) {
      if (!j._ok) return bad((especial && especial[j.erro]) || msgErro(j));
      if (ok) ok(j);
    });
  }
  /* Rede caida no meio de uma acao. O `pede` ja cuida do erro que o servidor
     RESPONDEU; o que sobra aqui e a promessa rejeitada (o fetch que nem saiu).
     Sem este handler ela vira `unhandled rejection` no console, contra o "cai
     no estado desligado sem erro no console" do plano. */
  function quedaDeRede() { bad(T.e_rede); }

  /* ---------------- toast ---------------- */
  var toastEl = null, toastT = 0;
  function limparToast(rodarExpira) {
    if (toastT) { clearTimeout(toastT); toastT = 0; }
    if (toastEl) {
      var f = toastEl._expira;
      toastEl.remove();
      toastEl = null;
      document.body.classList.remove('mwev-toast-cur');
      if (rodarExpira && f) f();
    }
  }
  function toast(txt, o) {
    o = o || {};
    limparToast(true);
    var n = clone('toast');
    if (!n) return;
    if (o.erro) { n.setAttribute('data-erro', '1'); S(n, 'aria-live', 'assertive'); S(n, 'role', 'alert'); }
    setText(n, 'txt', txt);
    if (o.aoTexto) {
      var alvoTxt = slot(n, 'txt');
      tc(alvoTxt, '');
      var lkTxt = mk('button', 'mwev-txtbtn', txt);
      on(lkTxt, 'click', function () { limparToast(false); o.aoTexto(); });
      if (alvoTxt) alvoTxt.appendChild(lkTxt);
    }
    var b = acao(n, 'toast-acao');
    if (o.rotulo) {
      hd(b, false);
      tc(b, o.rotulo);
      on(b, 'click', function () { limparToast(false); if (o.acao) o.acao(); });
    }
    clique(n, 'toast-fechar', function () { limparToast(true); });
    n._expira = o.aoExpirar || null;
    document.body.appendChild(n);
    toastEl = n;
    /* com o Curador aberto (de 792px em diante; o toast da compra espera o
       drawer fechar em toda largura, `toastCompra`) o toast vai para o espaco
       livre ao lado do painel (CSS da section) */
    if (curadorAberto()) document.body.classList.add('mwev-toast-cur');
    toastT = setTimeout(function () { limparToast(true); }, o.ms || UNDO);
  }

  /* ---------------- dialogos ----------------
     <dialog> nativo com showModal(): Esc, foco preso e aria-modal saem de graca.
     "Nao" leva autofocus (APG): a acao com consequencia nunca nasce focada. */
  function dialogo(o) {
    var d = clone('dialogo');
    if (!d) return;
    setText(d, 'titulo', o.titulo);
    var corpo = slot(d, 'corpo');
    (o.corpo || []).forEach(function (p) { corpo.appendChild(mk('p', null, p)); });
    var sim = acao(d, 'dlg-sim'), nao = acao(d, 'dlg-nao');
    tc(sim, o.sim);
    tc(nao, o.nao);
    if (o.perigo) sim.classList.add('mwev-btn-perigo');
    if (o.check) {
      cond(d, 'check', true);
      setText(d, 'checktxt', o.check);
      var cx = campo(d, 'entendi');
      S(sim, 'aria-disabled', 'true');
      on(cx, 'change', function () {
        if (cx.checked) rmA(sim, 'aria-disabled'); else S(sim, 'aria-disabled', 'true');
      });
    }
    if (o.soFechar) hd(sim, true);
    /* `campo` (F10): o pedido do nome de quem organiza. Com ele o "sim" NAO
       fecha: quem fecha e o aoSim, depois de o servidor aceitar o nome, e a
       recusa fica escrita embaixo do campo. Enter no campo e o "sim". */
    var inp = o.campo && cond(d, 'campo', true) && campo(d, 'nomeOrg');
    on(sim, 'click', function () {
      if (bloqueado(sim)) return;
      if (!inp) fecha();
      if (o.aoSim) o.aoSim(fecha, inp);
    });
    on(inp, 'keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); sim.click(); }
    });
    on(nao, 'click', function () { fecha(); if (o.aoNao) o.aoNao(); });
    function fecha() { fecharModal(d); }
    abrirModal(d);
    /* o autofocus do template e do "Voltar"; no pedido do nome a tarefa e o campo */
    if (inp) inp.focus();
    return d;
  }

  /* ---------------- estado ---------------- */
  var st = {
    modo: '', id: '', papel: '', ev: null, versao: 0,
    /* `org` e o bloco `organizador` da resposta ({ nome, email,
       replyToAceitoEm, replyToPermitido }). Ele NAO vive dentro de `evento`:
       o aceite do Reply-To e do cliente, nao do evento. */
    org: null,
    /* A LISTA E DE CONVITES, nunca mais de pessoas (r06). Cada item tem
       `pessoas[]` dentro, um link, um contato, e o status DERIVADO que o
       servidor calcula (`status` + `faltam` + `faltamMais`, decisao E-d). */
    convites: [], presentes: null, limites: null, filtro: '', lchip: '',
    /* Acordeoes recolhidos, por id de convite. Default ABERTO (handoff r06 4.2),
       e o mapa vive no `st` e nao na vista: `recarregar()` remonta a arvore
       inteira a cada acao, e sem isto todo cartao aberto fechava a cada lembrete
       enviado e a cada status marcado. */
    recolhidos: {},
    /* As familias FECHADAS na lista do CONVIDADO (R30, decisao 77), por id de
       convite. Todas comecam abertas, varias ficam abertas ao mesmo tempo e nao
       ha "Abrir tudo". So em memoria, como o mapa do organizador: sobrevive a
       `pintarLista` e morre com a pagina. */
    convFech: {},
    /* A BARRA DA LISTA DO CONVIDADO (R31, decisao 94): a busca (`cb`), o filtro
       de resposta (`cf`: '', 'confirmado', 'recusado' ou 'pendente'), a ordem
       (`co`: '' = A a Z, 'vai' = primeiro quem confirmou que vai) e as familias
       que a pessoa fechou durante a busca (`cbf`, zerado a cada tecla). So em
       memoria, de proposito: sobrevivem a vista refeita depois de cada resposta
       e morrem no recarregar (nada fica no aparelho). */
    cb: '', cf: '', co: '', cbf: {},
    /* O SINAL DE SALVO DE CADA LINHA DA FAIXA (R31, decisao 116), por id de
       pessoa: `sv` = o "Salvo" de passagem na tela (o temporizador dele) e `er`
       = o toque que nao salvou (a resposta, que o "Tentar de novo" repete). So
       em memoria, como o `cb`: sobrevivem a vista refeita depois da fila e
       morrem com a pagina. `mp` = a copia em memoria das marcas do painel
       depois da resposta (marcaPos). */
    sv: {}, er: {}, mp: {},
    lista: null, passadosVisiveis: 12, carrinho: [], vista: null,
    /* vista do convidado (P4b): `eu` e a linha de quem esta olhando (a unica com
       status real), `vinc` e o estado do vinculo com a conta (D8) e
       `confirmados` a contagem que sobrevive a lista oculta. */
    eu: null, vinc: null, confirmados: 0,
    /* As tres marcas do envio da capa (R-61, R27) moram aqui desde a R29: quem
       as escreve e o envio da capa (assets/mw-evento-org.js) e quem as le e o
       pintarCapa/estadoCapa, que servem tambem a vista do convidado e ficaram
       neste arquivo. Variavel solta nao atravessa a divisao; `st` atravessa por
       referencia. */
    capaEnviando: false, capaErro: '', capaCancelada: false
  };
  var tokenConvite = null; /* fica em closure; volta ao sessionStorage no pagehide */

  /* Titulo pelo mapa `oc` do JSON (as 15 colecoes do menu 'ocasioes'), e nao
     pelas <option> do select: desde a R-33 o select so tem as 9 de festa, e o
     evento antigo com ocasiao de presente perderia o titulo no kicker, no cartao
     de Meus eventos e na fala do Curador. A chave sai normalizada (ocN, R31). */
  function tituloOcasiao(h) { return (T.oc || {})[ocN(h)] || ''; }

  /* ---------------- o convite, e as pessoas dentro dele ----------------
     Cinco leitores curtos em vez de `c.pessoas` espalhado: o shape v=2 e lido em
     mais de vinte sitios, e um `|| []` esquecido em qualquer um deles vira tela
     vazia em silencio - que e exatamente o risco que esta fase existe para
     fechar. */
  function pessoasDe(c) { return (c && c.pessoas) || []; }
  /* A vaga e um booleano disfarcado de numero ({0,1}); valor estranho vira 0. */
  function vagasDe(c) { return Math.max(0, parseInt(c && c.acompanhantesLiberados, 10) || 0); }
  /* Ligar a vaga converte um convite de uma pessoa em cartao de familia: ela e
     uma pessoa a ser nomeada, e o acordeao precisa existir para mostrar a linha
     dela. Mas ela NUNCA conta como pessoa no "+N" nem no total (decisao D-T4). */
  function ehGrupo(c) { return pessoasDe(c).length > 1 || vagasDe(c) > 0; }
  function primeiro(nome) { return String(nome || '').trim().split(/\s+/)[0] || ''; }

  /* ================================ AUTOSAVE ================================
     PUT /eventos/:id { campos, baseVersion, opId }. Semantica parcial: so os
     campos sujos viajam. A idempotencia vai NO CORPO (opId) porque o PUT
     atravessa o App Proxy e nao ha header custom para gastar num preflight. */
  var sv = {
    sujos: {}, base: {}, voo: false, seq: 0, ultima: 0,
    timer: 0, primeiro: 0, tentativa: 0, pillT: 0,
    /* `reap`: quantas vezes seguidas o 409 reaplicou sozinho o que nao tinha
       conflito. `esc`: as duas escolhas de um conflito real ainda sem resposta. */
    reap: 0, esc: null
  };

  function opId() {
    if (crypto && crypto.randomUUID) return crypto.randomUUID();
    return String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10);
  }
  on(window, 'pagehide', function () {
    flushSaida();
    mandarPendentesDelete();
    mandarExclusoes();
    mandarAvisosCancel();
    if (tokenConvite) mem(0, 'mw_evento_c', tokenConvite);
  });
  /* volta do bfcache: o boot nao roda de novo, e o token que o pagehide
     regravou ficava legivel no sessionStorage pela vida inteira da pagina */
  on(window, 'pageshow', function (e) { if (e.persisted && tokenConvite) mem(0, 'mw_evento_c', null); });
  on(document, 'visibilitychange', function () {
    if (document.visibilityState === 'hidden') flushSaida();
  });
  on(window, 'beforeunload', function (e) {
    if (!sujo()) return;
    e.preventDefault();
    e.returnValue = '';
  });
  on(window, 'online', function () { if (sujo()) { sv.tentativa = 0; flush(); } });

  /* ============================ VISTA DO EVENTO ============================ */
  function abrirEvento(id) {
    st.id = id;
    st.modo = 'evento';
    req('GET', '/' + id).then(function (j) {
      if (!j._ok) return telaErroResposta(j);
      /* a resposta inteira, para o que este arquivo nao guarda: a raiz da
         entrega (`entregaLigada`, `entregaEvento`, `enderecoDaSuaConta`,
         `entregasPendentes`), lida pelo assets/mw-evento-endereco.js pelo `st` */
      st.gj = j;
      st.papel = j.papel;
      st.ev = j.evento || {};
      st.versao = st.ev.versao || 0;
      st.org = j.organizador || {};
      /* A base do link do convite pela previa (R28): o painel manda no formato
         (`/apps/curador/convite/<id publico>`, so ao organizador e so em v=2) e
         o tema so acrescenta `#c=`. Ausente = o link antigo, que vale sempre. */
      st.up = j.urlPrevia;
      /* LEITURA ASSERTIVA, e ela e o coracao desta fase. Ate a r05 esta linha
         era `st.convidados = j.convidados || []`, e foi por isso que a ordem
         "leitor primeiro" e regra (decisao D-T1): com `v=2` no fetch e o leitor
         antigo, `j.convidados` chega `undefined`, o `|| []` engole, e a tela
         fica COERENTE E FALSA - contadores somem, filtros somem, a lista afirma
         "ninguem na lista ainda" e o formulario de adicionar abre sozinho. O
         organizador recadastra todo mundo, e cada re-adicao e um convite novo,
         com link novo e email real para terceiro. Um 500 seria melhor: ele cai
         em `telaErroResposta` e a pessoa sabe que deu errado. Entao e isso que
         um shape inesperado passa a fazer. O codigo `versao` ja existe na
         tabela ERRO acima. */
      if (!Array.isArray(j.convites)) return telaErroResposta({ erro: 'versao' });
      st.convites = j.convites;
      st.presentes = j.presentes || null;
      st.limites = j.limites || null;
      st.lixeiraDias = j.lixeiraDias;
      /* conta vinculada abrindo o proprio convite por ?e= (D8): o GET so diz o
         papel: a vista do convidado sempre sai de POST /convite/ver, que e quem
         devolve a linha da pessoa e o estado do vinculo */
      if (st.papel !== 'organizador') return verConvite();
      montarEvento();
      retomarDeletes();
      retomarPendente();
      abrirCanal();
      /* Gancho de UMA vez, consumido na vista recem-montada. Existe por um caso
         so: o 409 `acompanhante_nomeado` prova que esta aba esta desatualizada,
         entao o "sim" da confirmacao precisa de dados frescos para achar QUEM
         foi nomeado no meio do caminho antes de apagar e desligar. */
      if (st.aoRecarregar) { var depois = st.aoRecarregar; st.aoRecarregar = null; depois(); }
    }).catch(telaErroRede);
  }

  /* capa e <title>: identicos nas duas vistas, e por isso moram fora das duas */
  function pintarCapa(v, ev, nome) {
    document.title = fmt(T.doc, { evento: nome });
    var img = slot(v, 'capaimg');
    /* com upload em voo a previa MANDA na imagem: qualquer repintura disparada
       pelo autosave no meio do envio devolveria a capa velha e a previa sumiria
       sem ninguem ter cancelado nada */
    /* a copia desfocada das laterais (.mwev-capa-fundo, a irma seguinte da
       imagem nas duas vistas) e a MESMA url: nenhum download a mais */
    if (!st.capaEnviando) {
      hd(img, !ev.capaUrl);
      if (img && ev.capaUrl) { img.src = img.nextElementSibling.src = ev.capaUrl; img.alt = fmt(T.capa_alt, { evento: nome }); }
    }
    estadoCapa();
  }

  /* ---------------- capa: upload (P6) ----------------
     Os slots de edicao so existem no template do organizador; no do convidado
     cond() nao acha nada e as tres linhas viram no-op, que e por isso que isto
     mora junto do pintarCapa em vez de virar um quarto ramo de vista. */
  function estadoCapa() {
    var v = st.vista;
    if (!v) return;
    var tem = !!(st.ev && st.ev.capaUrl) || st.capaEnviando;
    /* Enquanto o estado nao e `pronta`, somem DOIS elementos, nao um (R-61): o
       alvo de upload (.mwev-capa-vazia) E a acao "Editar capa", que e irma do
       seletor de ocasiao na faixa de baixo, nao filha do alvo. Com elas no ar,
       a interface fica pedindo uma foto por cima de um envio que acabou de
       falhar. `pointer-events` nao resolve: o texto continua visivel.
       Envio CANCELADO ainda em voo tambem nao e `pronta` (R27): quando ele
       termina, o adotarCapa desfaz o que subiu com um DELETE, e um ajuste salvo
       pelo editor nesse meio tempo cairia nesse desfazer e APAGARIA a capa. */
    var pronta = !st.capaEnviando && !st.capaErro && !st.capaCancelada;
    cond(v, 'capavazia', pronta && !tem);
    cond(v, 'capacheia', pronta && tem);
    cond(v, 'capaenv', st.capaEnviando);
    cond(v, 'capaerro', st.capaErro);
    setText(v, 'capamotivo', st.capaErro);
    /* dentro do estado vazio, duas frases excludentes: derrubada pela moderacao
       ou nunca teve capa. O campo vem da projecao, com a MESMA formula da vista
       do convidado (capa denunciada e ja sem arquivo). */
    var derr = !tem && !!(st.ev && st.ev.capaDerrubada);
    cond(v, 'capaderrubada', derr);
    cond(v, 'capasemfoto', !tem && !derr);
  }

  /* O eixo e o BOOLEANO `homenageado`, nao mais a coluna de texto `papel`: em
     v=2 `papel` nem sai da projecao, e ler por ele devolveria lista vazia - o
     que apagaria os chips, quebraria o destino padrao do Curador e esconderia
     "Ver presentes nessa faixa" de uma vez so. Cada chip carrega o convite de
     onde a pessoa veio, porque "Sou eu" e do CONVITE e nao da pessoa. */
  function homenageados() {
    var saida = [];
    st.convites.forEach(function (c) {
      pessoasDe(c).forEach(function (p) { if (p.homenageado) saida.push({ p: p, c: c }); });
    });
    return saida;
  }
  /* O PERFIL DA OCASIAO (R31, parte OCASIOES, decisoes 99 a 104 e 112 a 115):
     quem e celebrado (`papel`), quem ganha "Presentear" (`presente`), o tom do
     Curador, o titulo da lista, o teto e o minimo de "Pra quem e" e a lista
     sempre visivel do amigo secreto. A fonte unica e o painel
     (painel/src/lib/eventos/perfis-ocasiao.json, `perfilPublico`), que o manda
     em `evento.perfil` (GET e convite/ver v=2; PUT 200 e o 409 de versao).
     SERVIDOR SEM PERFIL (o painel antigo, na janela da publicacao): `PF0`, o
     modo `legado`, que reproduz o de hoje: "Presentear" em toda linha, o botao
     do evento sem homenageado e o homenageado unico como destino padrao. So o
     `todos` EXPLICITO liga as regras do amigo secreto. */
  var PF0 = { papel: 'homenageado', presente: 'legado' };
  function perfil() { return (st.ev && st.ev.perfil) || PF0; }
  /* a ocasiao como CHAVE (R31, plano 4.0 item 13): minusculas e sem espaco nas
     pontas, como o `ocasiaoNormal` do servidor (visao.ts) */
  function ocN(h) { return String(h || '').trim().toLowerCase(); }
  function oc() { return ocN(st.ev && st.ev.ocasiao); }
  /* O rotulo de quem e celebrado ("aniversariante", "formandos"), pela ponte
     montada com o papel (`pp_<papel>` e `pp_<papel>_n`; o check-evento-perfis
     confere que cada papel do perfil tem as duas). Com a section antiga (a
     publicacao em partes) a ponte nao existe e vale o rotulo de hoje; o teste e
     por `in`, para o coletor nao anotar a chave como faltando. */
  function rotuloPapel(n) {
    var k = 'pp_' + (perfil().papel || 'homenageado') + (n > 1 ? '_n' : '');
    return k in T ? T[k] : T.pe_home;
  }
  /* a marca da linha: o papel, ou "organiza" na titular do convite de quem
     organiza o amigo secreto (`organiza` vem so com `participo`) */
  function marcaPapel(c, p) { return p.homenageado ? rotuloPapel(1) : perfil().participo && p.organiza && 'pe_org' in T ? T.pe_org : ''; }
  /* a marca na linha do convidado (cabecalhoNeutro e linhaPessoa): o dourado
     do homenageado (`data-home`) vale tambem para "organiza" (`data-org`, a
     mesma regra do css) */
  function pintarPapel(e, c, p) {
    var m = marcaPapel(c, p);
    S(e, 'data-home', p.homenageado ? 'true' : 'false');
    S(e, 'data-org', m && !p.homenageado ? 'true' : 'false');
    tc(e, m);
  }
  /* CASAL E CASA NOVA: um "Presentear" so para todos os homenageados, "pelo
     tipo" (decisao 99 e plano 4.0 item 5): com nomes, na primeira linha
     homenageada (ligarPresentear); sem nomes, o botao da secao de presentes. */
  function unidade() { return perfil().presente === 'unidade'; }
  /* a PRIMEIRA linha homenageada NA ORDEM DA TELA, a que leva o botao da
     unidade (plano 4.5). No convidado e a de `st.convites`: o servidor e o
     ordenarConv (assets/mw-evento-lista.js) mantem os homenageados na ordem de
     quem organiza (decisao 94).
     Em quem organiza manda o ordenar() do modulo (A a Z, ou quem respondeu
     primeiro), congelado em `st.vis` antes de cada cartao nascer: o convite fora
     dele (filtro, busca) vai para o fim, e no cartao o titular vem antes, como
     o cartao o desenha. Sem isso o botao caia no cartao do primeiro CRIADO, que
     na tela pode ser o segundo. O sort e estavel: sem `st.vis`, a ordem fica. */
  function primUn() {
    var ids = st.papel === 'organizador' && st.vis && st.vis.ids;
    function pos(x) { var i = ids ? ids.indexOf(x.c.id) : 0; return (i < 0 ? 1e6 : i) * 2 + (ids && !x.p.titular ? 1 : 0); }
    var h = homenageados().sort(function (a, b) { return pos(a) - pos(b); });
    return h.length ? h[0].p.id : '';
  }
  /* o nome da unidade onde a frase precisa de um (plano 4.0 item 5, o
     `nomeDaUnidade` do servidor): ate 3 primeiros nomes juntos ("Ana e Rui",
     "Ana, Rui e Bia"); com 4 ou mais, ou sem nomes, VAZIO, e quem chama usa a
     variante `_unidade` da chave, com %unidade ("o casal") */
  function nomeUnidade() {
    var ns = homenageados().map(function (h) { return { nome: primeiro(h.p.nome) }; }).filter(function (x) { return x.nome; });
    return ns.length < 4 ? juntar(ns) : '';
  }
  /* o texto do botao do evento: "Presentear o casal" na unidade, "Escolher um
     vinho para o evento" nas outras (decisao 115). VAZIO com a section antiga,
     sem as pontes: quem chama fica com o texto que o Liquid ja escreveu. */
  function rotuloEvento() {
    return unidade() && 'pr_un' in T ? fmt(T.pr_un, { unidade: T['un_' + oc()] || '' }) : 'pr_ev' in T ? T.pr_ev : '';
  }
  /* quem ganha "Presentear" na PROPRIA linha. A unidade fica de fora: o botao
     dela e o da primeira linha homenageada. */
  function podePresentear(p) { var m = perfil().presente; return m === 'todos' || m === 'legado' || (m === 'homenageados' && !!p.homenageado); }
  /* o aniversario sem aniversariante (decisao 112): os convites esperam */
  function faltaHome() { return (perfil().minimo || 0) > homenageados().length; }
  /* A borda entra na conta: com box-sizing border-box, height = scrollHeight
     deixava a caixa curta pela espessura das bordas e o fim do texto cortado. */
  function crescer(ta) {
    if (!ta || 'fieldSizing' in ta.style) return; /* field-sizing: content resolve no CSS */
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + ta.offsetHeight - ta.clientHeight + 'px';
  }
  /* sem field-sizing, a largura da tela muda o numero de linhas do nome */
  on(window, 'resize', function () {
    var n = st.vista && campo(st.vista, 'nome');
    if (n && n.tagName === 'TEXTAREA') crescer(n);
  });

  function incompleto() { return !st.ev.nome || !st.ev.ocasiao; }
  /* O aviso de rascunho incompleto leva ao campo que falta em vez de so dizer
     que falta (5.1). Nome primeiro: e o primeiro da ordem de leitura e o que
     costuma estar vazio. */
  function focarIncompleto() {
    var alvo = campo(st.vista, !st.ev.nome ? 'nome' : 'ocasiao');
    if (!alvo) return;
    try { alvo.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    alvo.focus();
  }
  /* RSVP fechado como o servidor o ve (5.7, R-13): o prazo efetivo ja venceu
     mesmo antes de o tick carimbar `prazoFechadoEm`, e o E8, o lembrete e o
     Reabrir seguem a mesma regra */
  function fechou() { return !!(st.ev.rsvpFechado || st.ev.prazoFechadoEm); }
  /* Amigo secreto em `oculto` (registro P0-13): nem o organizador sabe quem ja
     ganhou presente, entao o selo que a linha trouxer nao aparece nem vira o
     aviso de presente garantido ao remover */
  function seloDe(g) { return !!g.selo && !(st.presentes && st.presentes.modo === 'oculto'); }

  /* ============================ A BUSCA DAS DUAS LISTAS ============================
     Moraram no assets/mw-evento-org.js (R29) ate a R31 (parte LISTA, decisao
     94), quando a lista do CONVIDADO ganhou busca, filtros e ordem no molde da
     de quem organiza: o texto e o mesmo, e o modulo os recebe pelo X. O
     organizador acrescenta o email e o telefone (as agulhas de digitos, `ag`);
     o convidado busca so pelo nome.
     O separador de palavra da busca: espaco e a pontuacao do ASCII. Letra de fora
     do ASCII (depois de sair o acento) fica na palavra. */
  var SEP_BUSCA = /[\s!-\x2f:-@[-\x60{-~]/;
  function semAcento(s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
  function termos(s) { return semAcento(s).split(SEP_BUSCA).filter(Boolean); }
  /* o termo no COMECO de uma palavra: "ju" acha "Julia" e "Ana Julia", nunca "Maju" */
  function temPalavra(txt, t) {
    return semAcento(txt).split(SEP_BUSCA).some(function (w) { return w.indexOf(t) === 0; });
  }
  /* A ORDEM POR NOME das duas listas: o Collator do pt-BR, sem acento nem caixa
     contando ("Angela" junto do A). Ele vive em `st` porque o modulo tambem o
     usa e nome do X nao se reatribui (gate da divisao, prova 5b). */
  function compararNome(a, b) {
    st.col = st.col || new Intl.Collator('pt-BR', { sensitivity: 'base' });
    return st.col.compare(a || '', b || '');
  }
  /* Os trechos achados num texto, como pares [inicio, fim) do texto ORIGINAL: a
     comparacao e sem acento e sem caixa, e o mapa `m` guarda de que caractere
     original veio cada um da forma comparada. `ag` (so o organizador passa): o
     texto e um telefone, e o que se marca sao os digitos achados pelas agulhas
     da regra da busca por telefone (os nacionais: o 55 do pais fica fora),
     pulando o que nao e digito. */
  function trechos(txt, ts, ag) {
    var n = '', m = [], f = [], r = [], i, j, k, p;
    if (ag) {
      var d = '', md = [], pula = /^\+55/.test(txt) ? 2 : 0;
      for (i = 0; i < txt.length; i++) {
        if (!/\d/.test(txt.charAt(i))) continue;
        if (pula) pula--;
        else { d += txt.charAt(i); md.push(i); }
      }
      ag.forEach(function (t) {
        p = -1;
        while ((p = d.indexOf(t, p + 1)) >= 0) f.push([md[p], md[p + t.length - 1] + 1]);
      });
    } else {
      for (i = 0; i < txt.length; i++) {
        k = semAcento(txt.charAt(i));
        for (j = 0; j < k.length; j++) { n += k.charAt(j); m.push(i); }
      }
      m.push(txt.length);
      ts.forEach(function (t) {
        p = -1;
        while ((p = n.indexOf(t, p + 1)) >= 0) if (!p || SEP_BUSCA.test(n.charAt(p - 1))) f.push([m[p], m[p + t.length]]);
      });
    }
    f.sort(function (a, b) { return a[0] - b[0]; }).forEach(function (x) {
      var u = r[r.length - 1];
      if (u && x[0] <= u[1]) u[1] = Math.max(u[1], x[1]);
      else r.push(x);
    });
    return r;
  }
  /* Escreve `txt` no fim de `el`, com cada trecho achado pela busca num <mark>
     montado por DOM: o que a pessoa digitou nunca vira HTML. Sem termos, o texto
     entra inteiro, sem marca. */
  function marcarEm(el, txt, ts, ag) {
    if (!el) return;
    txt = String(txt || '');
    var i = 0;
    (ts.length ? trechos(txt, ts, ag) : []).forEach(function (f) {
      if (f[0] > i) el.appendChild(document.createTextNode(txt.slice(i, f[0])));
      el.appendChild(mk('mark', 'mwev-mark', txt.slice(f[0], f[1])));
      i = f[1];
    });
    if (i < txt.length) el.appendChild(document.createTextNode(txt.slice(i)));
  }

  /* DUAS listas, e a separacao e o custo real da privacidade (handoff r06 6.2):
     o organizador pinta CARTOES, com contato, status derivado nominal e acoes de
     gestao; o convidado pinta a versao neutra, uma linha por pessoa, sem nada
     disso. Enquanto era uma funcao so com um `if` no meio, qualquer campo novo
     pintado antes do desvio vazava para a pagina que um terceiro abre pelo
     WhatsApp. */
  function pintarLista() {
    var v = st.vista;
    var caixa = slot(v, 'lista');
    if (!caixa) return;
    tc(caixa, '');
    /* o titulo pelo perfil, nas DUAS vistas (R31, plano 4.5): "Participantes"
       no amigo secreto, o de hoje nas outras. Ponte nova: com a section antiga
       o slot nem existe e nada se le */
    var ct = slot(v, 'convtit');
    if (ct && 'cv_tit' in T) tc(ct, perfil().lista === 'participantes' ? T.cv_part : T.cv_tit);
    if (st.papel !== 'organizador') return listaDoConvidado(v, caixa);
    /* o ramo do ORGANIZADOR mora no assets/mw-evento-org.js (R29) */
    pintarListaOrg(v, caixa);
  }
  function ehHome(p) { return !!p.homenageado; }
  function temHome(c) { return pessoasDe(c).some(ehHome); }
  /* HOMENAGEADOS SEMPRE PRIMEIRO, nas duas vistas e dentro do convite de
     familia (R25, comentario C5 do dono, 2026-09-25). O sort e estavel: o resto
     segue a ordem (Convite.ordem, Convidado.ordem) do servidor, que os emails
     continuam usando para nomear quem falta. */
  function homePrimeiro(l, f) {
    return l.slice().sort(function (a, b) { return (f(a) ? 0 : 1) - (f(b) ? 0 : 1); });
  }
  /* "Rodrigo + 2" pela chave `titulo_grupo` ("%nome + %n"): o nome e o resto
     num trecho que nao quebra (.mwev-nq), para o "+ 2" nunca ficar sozinho na
     linha de baixo. O `%nome` de volta no lugar dele e so a marca de onde o nome
     entra: o fmt nao varre o valor de novo. Mora no nucleo desde a R30 (parte
     G): o cartao de familia do organizador e a familia fechada da lista do
     convidado usam o mesmo titulo. `marcar` (opcional) poe o nome no lugar: o
     organizador passa a marca da busca; sem ele, o nome entra como texto. */
  function tituloGrupo(el, nome, n, marcar) {
    var s = fmt(T.cv_tg, { nome: '%nome', n: n }), i = s.indexOf('%nome');
    var fim = s.slice(i + 5), sp = fim.length - fim.replace(/^ +/, '').length;
    el.appendChild(document.createTextNode(s.slice(0, i)));
    if (marcar) marcar(el); else el.appendChild(document.createTextNode(nome));
    el.appendChild(document.createTextNode(fim.slice(0, sp)));
    el.appendChild(mk('span', 'mwev-nq', fim.slice(sp)));
  }
  /* o mesmo titulo para o leitor de tela: "Rodrigo e mais 2 pessoas" */
  function faladoGrupo(nome, n) {
    return fmt(n === 1 ? T.cv_tgf1 : T.cv_tgf, { nome: nome, n: n });
  }

  /* A lista NEUTRA do convidado: um CABECALHO por convite com UM indicador, e as
     linhas de dentro so quando o convite tem mais de uma pessoa. Sem contato,
     sem autoria, sem "recebe o link", sem o rotulo nominal ("Falta Julia") de
     convite alheio, sem marcadores, sem copiar link, sem contadores e sem
     cobranca - a lista do handoff r06 6.2, que e requisito e nao preferencia.
     Desde a R31 (decisao 94 do dono) ela tem busca pelo NOME, filtros de
     resposta e duas ordens, no molde da lista de quem organiza: nada de busca
     por email ou telefone (o convidado nao recebe o contato dos outros) e
     nenhuma ordem por data (revelaria a ordem do convite e o horario das
     respostas). UM VOCABULARIO SO desde a F5 da R29: o cabecalho e a linha de
     dentro falam pela PESSOA (`pessoa.publico_*`). O indicador do convite
     (`convite.publico_*`, "1 vai", "2 vao") saiu com o rotuloPublico. */
  function listaDoConvidado(v, caixa) {
    /* O NOME UMA VEZ SO (R29, a regra da decisao 69 do dono, a mesma do cartao
       do organizador aberto): o cabecalho de uma familia e a PRIMEIRA pessoa do
       convite (o homenageado, quando ha um), falando por ela, e as linhas
       recuadas logo abaixo sao as outras. Ate a R29 o cabecalho dizia "Carol + 2"
       e a primeira linha repetia a Carol. Desde a R30 (decisao 77) a familia e
       um acordeao, no padrao do cartao do organizador: `familiaNeutra`. O
       convite de uma pessoa continua uma linha so. Com a section antiga (a
       publicacao em partes da F8), sem as pontes do titulo no bloco comum, nao
       ha acordeao nem coluna de topo: a lista sai como antes da R30. O teste e
       por `in`: ler `T.cv_tg` pelo coletor anotaria a chave como faltando.
       O VAO DA SETINHA (a coluna de topo) so quando a lista tem pelo menos uma
       familia (R30, F6): sem familia nao ha setinha com que alinhar, e o vao so
       comia 58 px de cada linha (a 375 px o status caia para baixo do nome).
       Sem familia, a linha de uma pessoa fica como era antes da R30. */
    var mde = tpl('cartao'), acc = !!(mde && 'cv_tg' in T);
    var vao = acc && st.convites.some(function (c) { return pessoasDe(c)[1]; });
    /* lista oculta: sobram os homenageados e a contagem, que nao nomeia
       ninguem (visao.ts ja cortou as linhas no servidor). Sem barra, e sem
       filtro ou busca que ninguem ve escondendo alguem. */
    var oculta = !listaVis();
    if (oculta) st.cb = st.cf = '';
    /* A BARRA (R31, decisao 94): a busca pelo nome, o filtro, a ordem do
       convidado e a contagem dos chips moram em assets/mw-evento-lista.js
       (`L`, no fim deste arquivo), que pinta a barra e devolve os convites que
       aparecem, ja na ordem. Sem ele (a section de antes, na publicacao em
       partes), a lista inteira na ordem do servidor, que ja a manda em A a Z,
       e a barra escondida, como ela nasce no markup. */
    var ts = termos(st.cb), vivos = st.convites.filter(function (c) { return pessoasDe(c).length; });
    var mostra = L ? L.lista(v, vivos, ts, !oculta) : vivos;
    mostra.forEach(function (c) {
      var ps = homePrimeiro(pessoasDe(c), ehHome);
      if (ps.length > 1) return familiaNeutra(caixa, c, ps, acc && mde, ts);
      var n = cabecalhoNeutro(c, ps, ts);
      if (vao) colunaDeTopo(n, mde, false);
      caixa.appendChild(n);
    });
    cond(v, 'listaoculta', oculta);
    setText(v, 'ocultaresumo', fmt(T.r_ocul, { n: st.confirmados }));
    /* o "da pra presentear qualquer pessoa da lista" so onde isso e verdade:
       no amigo secreto (`todos`, R31 plano 4.5) */
    /* a frase que oferece presentear qualquer pessoa nunca no cancelado nem para
       quem e so homenageado: ali nenhuma linha tem Presentear (revisao de desenho
       de 07/10) */
    setText(v, 'resumo', oculta ? '' : perfil().presente === 'todos' && !st.ev.cancelado && !st.ev.canceladoEm && !soHome() ? T.r_conv : T.r_conv0);
  }
  /* a resposta da pessoa no eixo dos chips: o convidado ve tres estados (D2),
     e o que nao e "vai" nem "nao vai" e quem falta, como na frasePublica. Os
     dois ficam aqui (a familia que abre durante a busca usa o filtro) e vao
     ao modulo da barra (`L`, no fim deste arquivo). */
  function stPub(p) { return /^(confirmado|recusado)$/.test(p.status) ? p.status : 'pendente'; }
  function passaConv(p, ts) {
    return (!st.cf || stPub(p) === st.cf) && ts.every(function (t) { return temPalavra(p.nome, t); });
  }
  /* O cabecalho de um convite na lista do convidado. Desde a R29 ele fala
     sempre de UMA pessoa, a primeira do convite, e com as frases de PESSOA
     (`pessoa.publico_*`: "vai estar la"), as mesmas das linhas de baixo: na
     familia pela resposta dela, no solo pela do convite (F5, M5; ate ali o solo
     dizia "1 vai"). Quem nao vai tem o nome apagado, como nas linhas (o
     `data-status` na raiz). Foto, "pra quem e", selo e Presentear sao os que a
     linha dessa pessoa teria. */
  function cabecalhoNeutro(c, ps, ts) {
    var n = clone('pessoa');
    var t = ps[0], solo = ps.length === 1, s = (solo ? c.status : t.status) || '';
    var rot = frasePublica({ status: s });
    S(n, 'data-status', s);
    /* o id da pessoa do cabecalho, como na linha de pessoa: o modulo do
       presente pinta nela a marca de quem voce presenteou (R32, 9.11 item 11) */
    S(n, 'data-cid', t.id);
    setText(n, 'inicial', inicial(t.nome));
    /* a foto da pessoa do cabecalho: ele e dela, no solo e na familia. Quem
       decide foto ou inicial e `fotoUrl`, nunca o vinculo. */
    var av = slot(n, 'avatarimg');
    if (av && t.fotoUrl) { av.src = t.fotoUrl; hd(av, false); }
    var avatar = q(n, '.mwev-avatar');
    S(avatar, 'data-status', s);
    /* mesmo `title` do cartao do organizador: nome + rotulo. O prefixo "Convite
       de" que a r06 2.1 pede nao existe na locale (nem aqui nem la), e frase
       nova nao nasce no JS. */
    S(avatar, 'title', t.nome + ' - ' + rot);
    /* so o nome, sem o "+N": as outras pessoas estao logo abaixo. Com a busca
       (R31), o trecho achado ganha a marca, como no cartao de quem organiza. */
    var nm = slot(n, 'nome');
    tc(nm, '');
    marcarEm(nm, t.nome, ts);
    /* "pra quem e" e o selo de presente sao da pessoa do cabecalho (o selo de
       cada outra mora na linha dela, correcao r06 2.6b). "recebe o link" nunca:
       e o metadado que vazava quem controla o RSVP alheio (2.6a). */
    pintarPapel(slot(n, 'papel'), c, t);
    S(slot(n, 'status'), 'data-status', s);
    setText(n, 'statustxt', rot);
    cond(n, 'selo', seloDe(t));
    /* as pessoas do MEU convite nao ganham o botao (ninguem se presenteia pela
       propria linha), como nas linhas de baixo; as excecoes (a familia no amigo
       secreto, a unidade e o homenageado da propria familia) estao no
       ligarPresentear */
    ligarPresentear(n, t, c.id === euConvite());
    return n;
  }
  /* A FAMILIA NA LISTA DO CONVIDADO (R30, ponto 10 e decisao 77 do dono): o
     esqueleto do cartao de familia do organizador (decisao 69), sem as acoes de
     gestao. Comeca ABERTA e pode ser fechada pela mesma setinha.
     - Aberta: o cabecalho e a pessoa do topo, com a resposta, a foto e o
       Presentear DELA, e as outras logo abaixo, cada uma com a sua. A pessoa do
       topo e a primeira na ordem do `homePrimeiro` (a do servidor, com o
       homenageado na frente), NUNCA o "titular": o convidado nao recebe esse
       eixo (visao.ts), que revelaria quem controla a resposta de cada familia.
     - Fechada: so "Rodrigo + 2" (o leitor de tela ouve "Rodrigo e mais 2
       pessoas"), sem resposta, sem foto e sem Presentear: fechado, o topo fala
       do convite, e nao de uma pessoa.
     O nome fica no MESMO LUGAR nos dois estados. O botao de abrir e fechar e so
     a setinha (o mesmo botao do molde do cartao, com os dois SVGs), com
     aria-expanded e aria-controls e nada interativo dentro (padrao Accordion do
     W3C APG): o Presentear e irmao dele, na tira da linha. A troca e no lugar,
     sem remontar a lista, e o foco fica no botao.
     Numa publicacao em partes (F8), com a section antiga as pontes do titulo
     ainda estao so no bloco do organizador: sem elas (`mde` nulo) a familia
     sai aberta e sem a setinha, como antes da R30. */
  /* A COLUNA DE TOPO da lista do convidado (R30, parte G), no padrao do cartao
     do organizador (r06:286): o cabecalho de familia comeca pela setinha e o de
     uma pessoa pelo vao da mesma largura (.mwev-caret-vazio; o vao so quando a
     lista tem familia, F6), os dois clonados
     do molde do cartao, e todas as iniciais de topo ficam na mesma coluna. A
     classe .mwev-linha-cab alinha o cabecalho pela linha de base (css). */
  function colunaDeTopo(n, mde, fam) {
    var e = vaoDoMolde(n, mde, fam);
    if (e) n.className += ' mwev-linha-cab';
    return e;
  }
  /* poe no comeco da linha a setinha (fam) ou o vao dela, clonados do molde do
     cartao. As pessoas de DENTRO da familia tambem ganham o vao (pedido do
     orquestrador na parte G): com o recuo de 10 px da .mwev-linha-mb, a inicial
     delas fica recuada sob a de quem abre a familia, e nao a esquerda dela. */
  function vaoDoMolde(n, mde, fam) {
    var e = q(mde.content, fam ? '[data-a="abrir"]' : '.mwev-caret-vazio');
    if (!e) return null;
    e = e.cloneNode(true);
    hd(e, false);
    n.insertBefore(e, n.firstChild);
    return e;
  }
  /* A BUSCA NA FAMILIA (R31): quando o achado e alguem de DENTRO, a familia
     fechada abre enquanto a busca dura, sem mexer no `convFech`; a que a pessoa
     fecha de novo durante a busca vai para `st.cbf`, que zera a cada tecla (o
     mesmo mecanismo do `bfech` do cartao de quem organiza). */
  function familiaNeutra(caixa, c, ps, mde, ts) {
    var n = cabecalhoNeutro(c, ps, ts), t = ps[0], mais = ps.length - 1;
    var corpo = mk('div', 'mwev-conv-fam');
    var forca = ts.length > 0 && ps.slice(1).some(function (p) { return passaConv(p, ts); });
    ps.slice(1).forEach(function (p) {
      /* o recuo do prototipo (r06:723, `recuo: grupo ? '10px'`): sem ele as
         pessoas de dentro de uma familia leem como convites separados */
      var l = linhaPessoa(c, p), ne = slot(l, 'nome');
      l.className += ' mwev-linha-mb';
      if (ts.length) { tc(ne, ''); marcarEm(ne, p.nome, ts); }
      corpo.appendChild(l);
    });
    caixa.appendChild(n);
    caixa.appendChild(corpo);
    var car = mde && colunaDeTopo(n, mde, true);
    if (!car) return;
    qa(corpo, '.mwev-linha').forEach(function (l) { vaoDoMolde(l, mde, false); });
    corpo.id = 'mwev-cf-' + c.id + '-pessoas';
    S(car, 'aria-controls', corpo.id);
    var nm = slot(n, 'nome'), vh = mk('span', 'mwev-vh');
    nm.parentNode.insertBefore(vh, nm.nextSibling);
    var av = q(n, '.mwev-avatar'), img = slot(n, 'avatarimg'), pa = slot(n, 'papel');
    var pres = acao(n, 'presentear'), presFora = !pres || pres.hidden;
    var s0 = t.status || '', rot = frasePublica({ status: s0 });
    function abertoAgora() { return !st.convFech[c.id] || (forca && !st.cbf[c.id]); }
    function pintar() {
      var aberto = abertoAgora(), s = aberto ? s0 : '';
      /* fechado, o aro e o nome ficam neutros: nenhuma resposta fala pela familia */
      S(n, 'data-status', s);
      S(av, 'data-status', s);
      if (aberto) S(av, 'title', t.nome + ' - ' + rot);
      else av.removeAttribute('title');
      hd(img, !(aberto && t.fotoUrl));
      tc(nm, '');
      if (aberto) {
        marcarEm(nm, t.nome, ts);
        nm.removeAttribute('aria-hidden');
      } else {
        tituloGrupo(nm, t.nome, mais, function (e) { marcarEm(e, t.nome, ts); });
        S(nm, 'aria-hidden', 'true');
      }
      tc(vh, aberto ? '' : faladoGrupo(t.nome, mais));
      hd(vh, aberto);
      tc(pa, aberto ? marcaPapel(c, t) : '');
      hd(slot(n, 'status'), !aberto);
      cond(n, 'selo', aberto && seloDe(t));
      hd(pres, !aberto || presFora);
      hd(corpo, !aberto);
      S(car, 'aria-expanded', aberto ? 'true' : 'false');
      aria(car, fmt(aberto ? T.cv_rec : T.cv_ab, { nome: t.nome }));
      /* dois SVGs distintos, nunca um girado (handoff r06 4.2) */
      hd(q(car, '[data-caret="aberto"]'), !aberto);
      hd(q(car, '[data-caret="fechado"]'), aberto);
    }
    on(car, 'click', function () {
      if (abertoAgora()) { st.convFech[c.id] = 1; if (forca) st.cbf[c.id] = 1; }
      else { delete st.cbf[c.id]; if (!forca) delete st.convFech[c.id]; }
      pintar();
    });
    pintar();
  }
  /* QUEM NAO RESPONDEU, na lista publica do convidado (F7, plano 2026-09):
     "falta responder" enquanto as respostas estao abertas; fechadas (prazo
     encerrado, ou evento realizado, que fecha o RSVP mesmo sem prazo, como em
     podeResp), "ficou sem resposta", a mesma chave da lista do organizador.
     Depois do prazo nao falta mais nada a ninguem: a porta fechou. */
  function pubFechou() { return !!(fechou() || st.ev.status === 'realizado' || st.ev.cancelado || st.ev.canceladoEm); }
  function pendPublico(t) { return pubFechou() ? T.l_nr : t; }

  /* A linha de UMA pessoa. Serve o interior do cartao (organizador) e a lista
     neutra (convidado); o que muda e o vocabulario e a presenca de acoes. */
  function linhaPessoa(c, p) {
    var n = clone('pessoa');
    var euOrg = st.papel === 'organizador';
    S(n, 'data-cid', p.id);
    setText(n, 'inicial', inicial(p.nome));
    /* foto de perfil so chega em linha VINCULADA (visao.ts nem projeta o campo
       nas outras): destinatario solto fica na inicial em serifa, que e o
       fallback e nao o padrao (HANDOFF-EVENTOS ponto 7) */
    var av = slot(n, 'avatarimg');
    if (av && p.fotoUrl) { av.src = p.fotoUrl; hd(av, false); }
    var avatar = q(n, '.mwev-avatar');
    S(avatar, 'data-status', p.status || '');
    /* o status na raiz pinta o nome de quem nao vai (r06, corNome) */
    S(n, 'data-status', p.status || '');
    var rot = euOrg ? rotuloPessoa(p) : frasePublica(p);
    /* title nominal (R-54). O avatar continua `aria-hidden`: nome e status ja
       estao escritos ao lado, em texto, e cor nunca e o unico portador. */
    S(avatar, 'title', p.nome + ' - ' + rot);
    setText(n, 'nome', p.nome);
    /* UM indicador por linha (r06 6.2), e ele mora na NOTA abaixo do nome, nas
       duas vistas, na cor da situacao (r06, linhaPessoa: `nota` com `corNota`).
       O selo mono ao lado do nome fica so para o cabecalho neutro, que usa o
       mesmo template. */
    hd(slot(n, 'status'), true);
    cond(n, 'selo', seloDe(p));

    /* a marca de papel: so "pra quem e". O "recebe o link" saiu com o comentario
       C16 do dono ("que link?"; plano 2026-09, V5) */
    pintarPapel(slot(n, 'papel'), c, p);

    /* A nota da linha. No organizador e a SITUACAO seguida da AUTORIA ("Vai ·
       respondeu em 20/09", r06: [st.rotulo].concat(ex).join(' · ')), e a
       autoria e construida sem genero: a forma antiga ("respondido pelo %nome")
       saia "respondido pelo Marina". No convidado e a frase de presenca, em tres
       estados. */
    var notaP = euOrg ? [rot, autoriaDe(p)].filter(Boolean).join(' · ') : rot;
    txtOuSome(n, 'presenca', notaP ? notaP.charAt(0).toUpperCase() + notaP.slice(1) : notaP);
    S(slot(n, 'presenca'), 'data-status', p.status || '');

    if (euOrg) {
      /* homenageado nao responde: ele nasce confirmado por construcao. O
         booleano vem A PARTE porque `cond()` devolve o elemento, nunca a
         visibilidade: ligar pelo retorno poria handler no botao escondido. */
      var marcar = !p.homenageado;
      cond(n, 'marcadores', marcar);
      if (marcar) ligarMarcadores(n, c, p);
      ligarPresentear(n, p, c.souEu || c.rasc);
      /* "tirar do convite" e outra acao que "apagar o convite": ela nao existe
         no titular (quem recebe o link) nem no homenageado, e some no convite de
         uma pessoa - ali tirar a unica pessoa E apagar o convite. */
      /* no rascunho, tirar alguem e apagar o nome no campo */
      var podeTirar = ehGrupo(c) && !p.titular && !p.homenageado && !c.rasc;
      var tirar = cond(n, 'tirar', podeTirar);
      if (podeTirar) {
        aria(tirar, fmt(T.pe_tirar, { nome: p.nome }));
        on(tirar, 'click', function () { removerPessoa(c, p); });
      }
    } else {
      /* "Presentear" na linha do convidado (handoff r06 6.2: ele ve nome,
         indicador e o botao). A F7 o escondeu em TODA linha do convidado ao
         reescrever esta funcao, e com isso sumiu o caminho de presentear pessoa
         a pessoa - que e o gancho comercial da tela. Volta como era antes dela,
         com a regra de "ninguem se presenteia pela propria linha" traduzida
         para o convite: as pessoas do MEU convite nao ganham o botao, fora as
         excecoes do ligarPresentear (a familia no amigo secreto, a unidade e o
         homenageado da propria familia). */
      ligarPresentear(n, p, c.id === euConvite());
    }
    return n;
  }

  function rotuloPessoa(p) {
    var s = p.status;
    if (s === 'confirmado') return T.l_conf;
    if (s === 'recusado') return T.l_nv;
    if (s === 'nao_respondeu') return T.l_nr;
    return T.l_falta;
  }
  /* A linha na vista do CONVIDADO fala de presenca, nao de organizacao, e em
     TRES estados: ele nao distingue "o prazo fechou" de "ainda nao respondeu"
     (D2), e a projecao dele ja chega assim. */
  function frasePublica(p) {
    if (p.status === 'confirmado') return T.pe_pv;
    if (p.status === 'recusado') return T.pe_pnv;
    return pendPublico(T.pe_pp);
  }
  /* Quem marcou, e quando. `respondidoPor` e o primeiro nome de quem respondeu
     PELA pessoa (resolvido na hora, nunca congelado); ausente com a propria
     pessoa respondendo. `statusOrigem` distingue a marcacao do organizador. */
  function autoriaDe(p) {
    if (!p.respondidoEm) return '';
    if (p.statusOrigem === 'organizador') return T.pe_pvc;
    var d = fCurta(p.respondidoEm);
    return p.respondidoPor ? fmt(T.pe_pou, { quem: p.respondidoPor, data: d }) : fmt(T.pe_psi, { data: d });
  }
  function ligarPresentear(no, p, souEu) {
    var pres = acao(no, 'presentear');
    /* O PERFIL (R31, decisao 99), nas duas vistas: "Presentear" so em quem o
       perfil deixa (podePresentear). Na UNIDADE (casal e casa nova) ha um botao
       so, na PRIMEIRA linha homenageada, com o texto da unidade ("Presentear o
       casal") no rotulo e no nome acessivel, e o toque semeia o evento (o
       servidor responde com `alvo.papel` unidade). Ele some tambem para quem e
       SO homenageado (euHome: ninguem presenteia o proprio casal; a familia
       dele, sim, abaixo). */
    var un = unidade(), prim = un && primUn() === p.id, rot = prim && rotuloEvento();
    if (rot) tc(pres, rot);
    aria(pres, rot || fmt(T.l_pres, { nome: p.nome }));
    /* ninguem se presenteia pela propria linha: o convite "Sou eu" e o
       organizador, e as pessoas do proprio convite saem na vista do convidado.
       O BOTAO DA UNIDADE e uma excecao, na vista do convidado (R31, adendo B4
       de 02/10): ele e do casal ou da casa nova, nao da pessoa da linha, e com
       nomes e a unica entrada de presente da pagina. Entao a mae da Ana, no
       convite "Ana e a mae", presenteia o casal pela linha da Ana, que e do
       proprio convite. Ele so some para quem e SO homenageado (soHome, pelo
       euHome); na vista de quem organiza vale a regra de sempre (o "Sou eu", o
       rascunho e o euHome). NO AMIGO SECRETO (`todos`, decisao 99: "todos os
       participantes") o convite de familia e a outra excecao: quem tirou
       alguem do proprio convite (em "Gil e Rosa", o Gil tirou a Rosa) precisa
       do Presentear dessa pessoa, e nao da para saber quem segura o celular,
       entao toda pessoa de um convite de familia ganha o botao, inclusive quem
       abriu. Ele fica escondido so no convite de uma pessoa (e claramente quem
       abriu) e, na vista de quem organiza, no "Sou eu" dele (`c.souEu`).
       O HOMENAGEADO DA PROPRIA FAMILIA e a terceira excecao, na vista do
       convidado (R31, decisao 96 e 4.0 item 2: "nao presentear a si mesmo" e
       uma regra so, o soHome; lacuna DEP-L1 da parte DEPOIS): no convite
       "Rodrigo, Carol e Julia" com a Julia homenageada, a linha dela tem o
       Presentear para quem nao e so homenageado. O painel DEPOIS tirou o
       "Escolher o presente" da faixa e o do fim da pagina, entao, no nivel 2
       (depois do "Agora nao", ou ao recarregar com ele), esta linha e a entrada
       de presente que sobra para ela. Quem e SO homenageado (soHome) segue sem.
       Com o evento cancelado nao ha presente a dar: o botao some de toda linha,
       nas duas vistas (R30, parte G). */
    var meu = souEu && !(st.papel !== 'organizador' && (prim || p.homenageado && !soHome() || perfil().presente === 'todos' && euPessoas().length > 1));
    if (meu || st.ev.cancelado || st.ev.canceladoEm || !(prim || (!un && podePresentear(p))) || (prim && euHome())) hd(pres, true);
    if (incompleto()) inerte(pres, T.m_inc);
    on(pres, 'click', function () {
      if (bloqueado(pres)) return bad(T.pr_inc, st.papel === 'organizador' ? focarIncompleto : null);
      semearCurador(prim ? 'evento' : p.id);
    });
  }

  /* ============================ PRESENTES ============================ */
  function pintarPresentes() {
    var v = st.vista, p = st.presentes;
    /* O BOTAO DO EVENTO (R31, decisoes 99 e 115): some com homenageado marcado
       (cada um tem o seu, ou o da unidade na primeira linha), para quem e
       homenageado (ninguem se presenteia), no evento cancelado e no amigo
       secreto (`todos`: cada linha tem o seu). Na unidade sem nomes ele e o
       "Presentear o casal", "pelo tipo". */
    var semEv = homenageados().length > 0 || euHome() || st.ev.cancelado || !!st.ev.canceladoEm || perfil().presente === 'todos';
    /* Na vista do CONVIDADO a secao some quando nao ha presente garantido (r06,
       `temPresentes`): lista sem item e contagem que so diria "nenhum". O modo
       oculto fica, porque a frase dele explica o que nao esta na tela.
       A EXCECAO (R31): quando o botao do evento (ou o da unidade sem nomes) vai
       aparecer, a secao fica mesmo vazia, com o titulo, a frase de vazio
       (`pr_nada`, a da contagem zerada) e o botao. Sem ela, o evento sem
       homenageado e o casal ou a casa nova sem nomes nao tinham nenhuma
       entrada de presente antes da resposta. O organizador nao muda: o vazio
       dele e o `presvazio`. */
    var vazio = !!p && st.papel !== 'organizador' && (p.modo === 'lista' ? !(p.itens || []).length
      : p.modo === 'contagem' && !p.quaseTodos && !p.contagem && !p.algum);
    /* O PRESENTE DE QUEM OLHA (`eu.presentesMeus`; R32, 9.2, decisao 126): chega
       na hora, sem o atraso da lista de todos, e a faixa dele (o modulo do
       presente, no slot `premeu`) fica no topo da secao. Com ele a secao nunca
       some, nem com a lista vazia: ate a R31 o `return` logo abaixo a tirava
       antes de a linha do comprador ser lida. */
    var meu = !!(st.eu && st.eu.presentesMeus || []).length;
    var nada = !p || (vazio && semEv && !meu);
    cond(v, 'presentes', !nada);
    /* vazia so pelo botao: com o painel depois da resposta na tela (data-n1),
       que ja oferece o mesmo botao, ela some (revisao de desenho da onda B) */
    var sP = q(v, '[data-slot-if="presentes"]');
    if (sP) sP.toggleAttribute('data-so-botao', vazio && !meu);
    if (nada) return;
    var grade = slot(v, 'presgrade');
    var contagem = slot(v, 'prescontagem');
    tc(grade, '');
    hd(contagem, true);
    setText(v, 'presnota', st.papel === 'organizador' ? T.pr_org : T.pr_conv);
    var itens = p.itens || [];
    if (p.modo === 'lista') {
      itens.forEach(function (it) {
        var c = clone('presente');
        setText(c, 'nome', it.nome);
        var foto = slot(c, 'foto');
        if (foto) {
          S(foto, 'role', 'img');
          aria(foto, fmt(T.pr_alt, { rotulo: it.nome }));
          if (it.img) foto.style.backgroundImage = 'url("' + it.img + '")';
        }
        grade.appendChild(c);
      });
    } else if (p.modo === 'contagem') {
      hd(contagem, false);
      /* `algum` e o unico campo que o modo BINARIO devolve (visao.ts): la nao vem
         `contagem`, de proposito, porque o homenageado nao pode saber quantos
         sao. Ler so `contagem` fazia o zero cair na frase do caso positivo, e um
         homenageado de evento sem presente nenhum lia que ja tinha presente
         garantido. A ordem aqui e do mais informativo para o menos. */
      tc(contagem, p.quaseTodos ? T.pr_quase
        : (p.contagem ? pl(T.pr_n1, T.pr_nn, p.contagem)
          : (p.algum ? T.pr_bin : T.pr_nada)));
      /* `contagem` chega ao organizador so quando ele e o homenageado "Sou eu"
         (visao.ts), entao la o modo ja prova o papel; ao convidado ela chega
         tambem por k-anonimato, e ai a nota continua sendo a de convidado */
      if (st.papel === 'organizador' || souHomenageado()) setText(v, 'presnota', T.pr_home);
    } else if (p.modo === 'oculto') {
      hd(contagem, false);
      tc(contagem, T.pr_ocul);
      setText(v, 'presnota', '');
    }
    /* O estado vazio `presvazio` e SO do organizador (R28): na vista do
       convidado a secao some sem presente (`nada`, acima), e quando fica, pelo
       botao do evento, o vazio dela e a frase da contagem zerada na nota
       (abaixo). Sobrou uma frase so, fixa, e ela mora no template do
       organizador. */
    cond(v, 'presvazio', p.modo === 'lista' && !itens.length);
    /* a secao vazia do convidado (a excecao acima), na ordem titulo, frase,
       botao: a frase de vazio no lugar da nota, logo abaixo do titulo, e
       nenhuma contagem. Com o presente do proprio comprador na tela (a faixa
       do `premeu`, R32; ate a R31 a linha `presmeu`), a frase diria o
       contrario dele e fica de fora. */
    if (vazio) {
      hd(contagem, true);
      setText(v, 'presnota', meu ? '' : T.pr_nada);
    }
    /* o botao do evento (a regra no topo). Sem as pontes (section antiga) fica
       o texto do Liquid. */
    var pe = acao(v, 'presentear-evento'), re = rotuloEvento();
    hd(pe, semEv);
    if (re) tc(pe, re);
    inerte(pe, incompleto() ? T.m_inc : null);
  }

  /* ============================ CURADOR SEMEADO ============================ */
  /* O ouvinte do carrinho nasce no boot, e nao no ligarCurador: o `mw:cart` do
     fetch inicial do mw-cart.js chega antes do GET do evento pelo App Proxy, e
     ouvido so depois da vista montada a contagem ficava sem base e o PRIMEIRO
     add nao mostrava o toast. A base sai do numero do carrinho no cabecalho,
     que o mw-cart.js reescreve ANTES de cada `mw:cart`: vale tambem quando o
     `mw:cart` inicial disparou antes deste script rodar. O toast continua so
     depois do ligarCurador, como antes (lista e criacao nao tem presente). */
  function ouvirCarrinho() {
    var cab = document.querySelector('[data-mw-cart-count]');
    var n0 = cab ? parseInt(cab.textContent, 10) : NaN;
    if (n0 >= 0) st.contagemCarrinho = n0;
    on(document, 'mw:cart', function (e) {
      var c = e.detail || {};
      var itens = c.items || [];
      st.carrinho = itens.map(function (i) { return i.handle; }).filter(Boolean);
      var n = c.item_count != null ? c.item_count : itens.length;
      if (st.curadorLigado && st.contagemCarrinho != null && n > st.contagemCarrinho && ctxAtual()) toastCompra();
      st.contagemCarrinho = n;
    });
  }
  function ligarCurador() {
    /* listeners de DOCUMENTO: religar a cada repintura (recarregar(), e na vista
       do convidado cada verConvite()) empilharia um handler por passada */
    if (st.curadorLigado) return;
    st.curadorLigado = 1;
    /* envelope do addVariant: a conversa LIVRE depois do seed vai ao endpoint
       real, cujos cards nao trazem props. Sem isto o presente comprado depois de
       uma pergunta perderia o vinculo com o evento. Zero bytes no core. */
    on(document, 'mw:drawer', function (e) {
      var d = e.detail || {};
      if (d.nome !== 'curador' || !d.aberto) return;
      envolverCarrinho();
    });
  }
  function ctxAtual() { return memJson(0, 'mw_evento_ctx'); }
  function envolverCarrinho() {
    if (!window.MWCart || window.MWCart._mwev) return;
    var orig = window.MWCart.addVariant;
    window.MWCart._mwev = 1;
    window.MWCart.addVariant = function (id, props) {
      var ctx = ctxAtual(), pp = ctx && ctx.pp && ctx.pp.props, k;
      if (ctx && ctx.claim) {
        props = props || { _curador: '1' };
        if (!props._mw_ev) props._mw_ev = ctx.claim;
        /* O "PRESENTE PARA" DA LINHA (R32, 9.9; decisao 135): o card da conversa
           livre nao traz as propriedades do destino, e elas vem prontas do
           /sugestoes (`pp.props`: o "Presente para", o `_mw_para` e o
           `_mw_recado_ate`; os nomes sao chaves de dado do contrato,
           painel/src/lib/eventos/presente-para.ts). So na linha que ainda nao
           tem o destino (`_mw_para`); o card do /sugestoes ja o traz. */
        if (pp && !props._mw_para) for (k in pp) props[k] = pp[k];
      }
      return orig.call(window.MWCart, id, props).then(function (r) {
        if (ctx && ctx.claim) {
          confirmarNoCurador();
          /* a caixa "Como o vinho chega ate Ana?" logo abaixo (R31, onda C), no
             modulo da entrega: ele recebe o que so este arquivo conhece (o
             destino, o corpo de acesso com o token em closure, o perfil e as
             pessoas do convite, que decidem a ordem dos botoes, e o vigia da
             gaveta, que a acao do aviso do pe arma de novo ao reabrir a caixa) */
          if (st.curadorEnt) ENT.escolha({ en: st.curadorEnt, c: corpoAcesso, pf: perfil(), eu: euPessoas(), vg: vigiarGaveta });
          /* O PRESENTE ESCOLHIDO (R31, parte DEPOIS): a marca do convite no
             aparelho, e o painel depois da resposta para de perguntar (nivel 2).
             "Escolhido" e "pos no carrinho", nao "pagou": o painel nunca diz
             garantido. O nivel troca quando a gaveta fecha (vigiarGaveta). */
          if (st.modo === 'convite' && euConvite()) {
            marcaPos('pp_', '1');
            st.pp = 1;
            vigiarGaveta();
          }
        }
        return r;
      });
    };
  }
  /* A confirmacao do add (5.1). E a unica frase que explica o que muda neste
     fluxo: o presente so vira garantido depois do pedido PAGO, ele entra na
     pagina do evento, e o endereco de entrega e o de quem recebe (R30, decisao
     83; a loja nao promete cartao nem embrulho). Ela entra como fala do
     Curador no MESMO caminho do seed (escreve o localStorage e reabre a
     conversa), com `ev: 1` porque carrega o primeiro nome de terceiro e
     `limparFalaDoEvento` limpa por essa marca.

     Sem nome nao ha frase: presente para o evento INTEIRO nao tem destinatario, e
     "no nome de ." seria pior que o silencio. E o que o prototipo faz (falaFinal
     so existe com `alvo`). Zero byte novo no core: o mw-curador.js so trocava o
     texto do botao e nao muda uma linha.
     COM A ENTREGA (R31, onda C; `st.curadorEnt`, ver semearCurador) a frase e
     a do modulo da entrega, que aponta a caixa logo abaixo (e da ao casal ou a
     casa nova sem nomes a deles); vazia no evento sem homenageado, que segue
     calado: a caixa tem titulo proprio. Sem a `cu_conf` (section antiga) o fmt
     da vazio e nada entra, como antes. */
  function confirmarNoCurador() {
    var nome = st.curadorNome, en = st.curadorEnt, tx = en && ENT.conf(en) || nome && fmt(T.cu_conf, { nome: nome });
    if (!tx) return;
    var conversa = memJson(1, 'mw_curador') || [];
    conversa.push({ de: 'c', texto: tx, ts: Date.now(), ev: 1 });
    mem(1, 'mw_curador', JSON.stringify(conversa));
    /* o mw-curador rele a conversa a CADA `mw:drawer` aberto; o evento vai
       direto em vez de MW.abrir porque o drawer JA esta aberto e abrir de novo
       devolveria o foco ao topo do painel no meio da leitura */
    document.dispatchEvent(new CustomEvent('mw:drawer', { detail: { nome: 'curador', aberto: true } }));
  }
  function curadorAberto() { return !!document.querySelector('[data-mw-drawer="curador"]:not([hidden])'); }
  /* Com o painel do Curador aberto o toast da compra espera o drawer fechar, EM
     TODA LARGURA (R30, F6): o card ja diz "NO CARRINHO" e a fala do Curador ja
     diz de quem e o endereco (decisao 83), e o aviso junto repetia a mesma frase
     no computador. Ate a F6 isso valia so abaixo de 792px. O core tira
     `html.mw-travado` no fechar(), em qualquer largura, e e isso que se observa
     (zero byte no core). Guardado ha mais de um minuto, o aviso ja nao conta
     nada e sai sem aparecer. */
  /* O ENDERECO DO PRESENTE (R30, decisao 83): o aviso diz de quem e o endereco.
     Com o nome de quem recebe (o primeiro nome que o /sugestoes devolveu, o
     mesmo da fala do Curador), a frase com o nome; presente para o evento
     inteiro, a frase sem nome. A frase sai na hora da compra e fica guardada
     para o aviso que espera o drawer fechar. Section antiga, sem a `t_check_n`:
     a frase sem nome, nunca um aviso vazio. A hora da compra vive em `st.ce`
     (R32, 9.4): o "Nova conversa" a zera (assets/mw-evento-presente.js), e o
     aviso com o nome que esperava o drawer fechar nao sai mais. */
  var obsCur = null, msgCompra = '';
  function toastCompra() {
    msgCompra = st.curadorNome && T.t_check_n ? fmt(T.t_check_n, { nome: st.curadorNome }) : T.t_check;
    st.ce = Date.now();
    vigiarGaveta();
  }
  /* O OBSERVADOR UNICO DO FECHAR DA GAVETA (R31, plano 4.0 item 8): o aviso da
     compra e o painel depois da resposta esperam a gaveta do Curador fechar
     pelo MESMO observador de `html.mw-travado`. Gaveta ja fechada (ou sem
     MutationObserver): tudo na hora. */
  function vigiarGaveta() {
    var html = document.documentElement;
    if (!curadorAberto() || !window.MutationObserver) return gavetaFechou();
    if (obsCur) return;
    obsCur = new MutationObserver(function () {
      if (html.classList.contains('mw-travado')) return;
      obsCur.disconnect();
      obsCur = null;
      gavetaFechou();
    });
    obsCur.observe(html, { attributes: true, attributeFilter: ['class'] });
  }
  /* Com o presente escolhido (`st.pp`), o painel repinta (nivel 2) e o foco vai
     ao titulo dele quando o botao tocado sumiu na repintura (o fechar da
     gaveta devolve o foco a quem a abriu). Um aviso de pe com acao que JA
     estava na tela segura o foco onde esta. O aviso da compra vem depois, e so
     se a compra tem menos de um minuto.
     COM A ENTREGA (R31, onda C, 4.7 passos 4 e 5) o aviso e o que o modulo da
     entrega devolve pelo estado da caixa (o texto em `t` e as opcoes do toast):
     fechada sem escolha, a pergunta com a acao que reabre a caixa; depois de
     "Vou levar no dia", o texto de levar. Nulo (o endereco saiu no meio), o
     aviso de sempre. O aviso COM PRAZO PROPRIO (`a.ms`, a pergunta com a acao)
     sai mesmo depois do minuto: ele nao conta a compra, oferece o que falta
     fazer (sem isso, quem leu as formas de frete por mais de um minuto e fechou
     a gaveta ficava sem caminho de volta para a caixa). */
  function gavetaFechou() {
    var ta = toastEl && acao(toastEl, 'toast-acao'), fa = document.activeElement, t,
      a = st.curadorEnt && ENT.aviso();
    if (st.pp && st.vista) {
      st.pp = 0;
      pintarPos();
      pintarGuardar();
      t = st.pv && slot(st.pv, 'postitulo');
      if (t && !(ta && !ta.hidden) && (!fa || fa === document.body || !fa.offsetWidth)) t.focus({ preventScroll: true });
    }
    if (a && a.ms || st.ce && Date.now() - st.ce < 60000) toast(a ? a.t : msgCompra, a || { rotulo: T.t_cart, acao: function () { if (window.MW) window.MW.abrir('cart'); } });
    st.ce = 0;
  }

  function semearCurador(destino) {
    /* a frase serve as duas vistas, mas o atalho para o campo que falta so
       existe no template do organizador: no do convidado ele apontaria para
       nada e o toast ofereceria uma acao morta */
    if (incompleto()) return bad(T.pr_inc, st.papel === 'organizador' ? focarIncompleto : null);
    pede('POST', '/sugestoes', corpoAcesso({ d: destino, carrinho: st.carrinho }), function (j) {
      /* zero rotulo so acontece com a Shopify fora na hora da carga do
         catalogo: abrir o Curador sem card nenhum, com uma fala que promete
         tres, e pior que o aviso de erro que a pagina ja usa */
      if (!(j.produtos && j.produtos.length)) return quedaDeRede();
      var alvo = j.alvo || {}, pf = perfil();
      var nome = alvo.primeiroNome || '';
      /* a faixa entra NO MEIO da frase ("combinada, ate R$ 150"; R31, adendo
         B1 item 8): a primeira letra minuscula aqui, sem mudar as chaves, que o
         campo da faixa mostra sozinhas */
      var faixa = fraseFaixa(j.faixa);
      faixa = faixa.charAt(0).toLowerCase() + faixa.slice(1);
      var ocasiao = tituloOcasiao(st.ev.ocasiao);
      /* "Sem sugestao" e o PADRAO do campo: sem faixa as falas de sempre saiam
         "Tres na faixa combinada, ." com o valor vazio. Sem faixa a ocasiao e o
         primeiro degrau da escada, entao ela e a fala do destino, e so a casa
         inteira ganha fallback proprio. */
      var sf = !faixa;
      /* A FALA PELO DESTINO E PELO PERFIL (R31, plano 4.5): a UNIDADE (casal e
         casa nova, o destino do evento) com os nomes juntos ou, com 4 ou mais
         ou sem nomes, a variante com %unidade; o evento sem homenageado (levar
         no dia ou mandar entregar); o AMIGO SECRETO (`todos`: a linha e quem a
         pessoa tirou, e o servidor a manda sempre `convidado`); o homenageado,
         no tom de quem recebe a turma (churrasco e jantar) ou no de hoje; o
         convidado comum. Cada fala com a versao `_sf`. As pontes novas sao
         testadas por `in`: com a section antiga vale a fala de hoje. */
      var un = destino === 'evento' && unidade() && 'cu_un' in T;
      var nu = un ? nomeUnidade() : '', und = un ? T['un_' + oc()] || '' : '';
      if (nu) nome = nu;
      var k = un ? (nu ? 'cu_un' : 'cu_unu')
        : destino === 'evento' ? 'cu_ev'
        : pf.presente === 'todos' && 'cu_tr' in T ? 'cu_tr'
        : alvo.papel !== 'homenageado' ? 'cu_conv'
        : pf.tom === 'anfitriao' && 'cu_anf' in T ? 'cu_anf' : 'cu_home';
      var texto = fmt(T[k + (sf ? '_sf' : '')], { nome: nome, faixa: faixa, ocasiao: ocasiao, alvo: nome, unidade: und });
      var fb = j.fallback;
      if (sf) { if (fb === 'catalogo') texto = T.cu_fb_c_sf; }
      else if (fb === 'vizinha') texto = fmt(T.cu_fb_v, { faixa: faixa });
      else if (fb === 'ocasiao') texto = fmt(T.cu_fb_o, { faixa: faixa, ocasiao: ocasiao });
      else if (fb === 'catalogo') texto = fmt(T.cu_fb_c, { faixa: faixa });
      /* A ENTREGA NO ENDERECO DE QUEM RECEBE (R31, onda C; 4.7 e adendo C4/C5).
         Com o `entrega` do /sugestoes E o modulo da entrega na pagina (`ENT`;
         sem ele nada muda), `st.curadorEnt` guarda o que a caixa precisa, so na
         memoria da pagina: o endereco, o nome do destino (a pessoa, ou os
         nomes da unidade; vazio no evento sem homenageado, e ai a caixa usa o
         "Quem recebe"), o substantivo da unidade sem nomes, o destino e o
         claim. A fala de abertura ganha a frase de entrega, que o modulo monta
         (adendo B1 item 10). Nao muda a conversa: so o texto da fala. */
      var en = ENT && j.entrega;
      st.curadorEnt = en && { ent: en, nome: nome, unidade: !nu && und, d: destino, k: j.claim };
      if (en) texto = ENT.fala(texto, st.curadorEnt, { c: corpoAcesso, pf: pf, eu: euPessoas(), vg: vigiarGaveta });
      /* a mensagem de quem abre a conversa: na unidade sem nome, "para o casal"
         (cu_uu, adendo B1 item 2, e o "para" da rodada copyB2: "pra o casal"
         saia sem a contracao); com nomes, a de pessoa com os nomes juntos */
      var pergunta = un && !nu ? fmt(T.cu_uu, { unidade: und }) : destino === 'evento' && !un ? T.cu_ue : fmt(T.cu_u, { nome: nome });
      var agora = Date.now();
      /* SUBSTITUI a conversa: dois "Presentear" seguidos nao empilham duas
         apresentacoes do mesmo assunto */
      mem(1, 'mw_curador', JSON.stringify([
        { de: 'u', texto: pergunta, ts: agora, ev: 1 },
        { de: 'c', texto: texto, ts: agora, produtos: j.produtos || [], ev: 1 }
      ]));
      /* `pp` (R32, 9.9): o `presentePara` do /sugestoes ({ valor, chave,
         recadoAte, props }), para o embrulho do addVariant por na linha o
         "Presente para" tambem depois de recarregar a pagina (envolverCarrinho).
         Ele traz o primeiro nome de quem recebe, como a propria linha do
         carrinho; o "Nova conversa" apaga o ctx inteiro (assets/
         mw-evento-presente.js). Sem ele (o servidor de antes), nada muda. */
      mem(0, 'mw_evento_ctx', JSON.stringify({ claim: j.claim, d: destino, pp: j.presentePara }));
      /* o primeiro nome do destino para as frases fica na MEMORIA da pagina:
         nome de terceiro parado no sessionStorage e o que `limparFalaDoEvento`
         existe para evitar. Vazio quando o presente e para o evento inteiro; na
         unidade com ate 3 nomes, os nomes juntos (plano 4.0 item 5: o aviso do
         pe e a confirmacao falam de "Ana e Rui"). */
      st.curadorNome = destino === 'evento' && !nu ? '' : nome;
      envolverCarrinho();
      if (window.MW) window.MW.abrir('curador');
      /* as tres opcoes rapidas no fim da conversa (R32, 9.4), no modulo do
         presente; ele recebe o `st` para o "Nova conversa" zerar o
         `curadorNome`, o `curadorEnt` e a hora da compra (`ce`) */
      if (PRE) PRE.chips(st);
    }).catch(quedaDeRede);
  }
  /* `j.faixa` de /sugestoes e `evento.faixa` do GET tem a MESMA forma
     ({ operador, min, max }); sem argumento vale a do evento aberto. */
  function fraseFaixa(f) {
    f = f || (st.ev && st.ev.faixa);
    if (!f) return '';
    if (f.operador === 'ate' && f.max) return fmt(T.fx_ate, { valor: f.max });
    if (f.operador === 'entre' && f.min && f.max) return fmt(T.fx_entre, { min: f.min, max: f.max });
    return '';
  }
  /* As opcoes rapidas do Curador (o `chipsRapidos` ate a R31) moram no
     assets/mw-evento-presente.js desde a R32 (9.4): elas ficam na conversa, a
     tocada marcada, e saem com o "Nova conversa" ou com outro Presentear. */

  /* ======================= VISTA DO CONVIDADO (P4b) =======================
     Quem chega aqui: o link do email/WhatsApp (token no fragmento, ja movido ao
     sessionStorage pelo inline do <head>), o retorno do login (?volta=1) e a
     conta vinculada abrindo ?e=<id> (o GET devolve `papel: 'convidado'`).

     A vista SEMPRE sai de POST /convite/ver, pelos dois ramos. O GET /:id nao
     serve: ele nao devolve a linha da propria pessoa (`eu`) nem o estado do
     vinculo, que e justamente o que esta tela decide.

     O token prova POSSE, nao identidade: por `{c}` nada aqui pede login e nada
     revela dado de terceiro (a projecao de visao.ts ja cortou no servidor). */

  /* resposta da rota <-> status da linha. Os dois nomes sao diferentes no
     servidor de proposito, entao a traducao mora num lugar so. */
  /* DUAS respostas (DF1): `nao_sei` saiu do dominio inteiro. Em v=2 o enum do
     servidor recusa com 400, entao a entrada que sobrasse aqui daria um erro
     garantido na cara de um terceiro. Quem nao clicou fica `pendente`. */
  var RSVP = { vou: 'confirmado', nao_vou: 'recusado' };
  var barra = null, barraFoco = false, barraFora = false;

  function respostaDoStatus(s) {
    for (var k in RSVP) if (RSVP[k] === s) return k;
    return '';
  }
  /* Toda rota do convidado e POST com o corpo de acesso, e toda queda de rede
     vira o mesmo toast. A excecao e `permitir`, que passa SEMPRE por `{e}`: ela
     apaga a recusa da propria CONTA, e o token nao prova conta nenhuma. */
  function pedeConv(rota, extra, ok, especial) {
    return pede('POST', '/convite/' + rota, corpoAcesso(extra), ok, especial).catch(quedaDeRede);
  }
  /* `st.eu` e o CONVITE de quem abriu o link, nunca mais uma pessoa
     (`{ conviteId, pessoas[], podeResponder, vagaLivre }`). Os tres leitores
     curtos existem pelo mesmo motivo dos de `pessoasDe`: o shape e lido em
     muitos sitios e um `|| []` esquecido vira tela vazia em silencio. */
  function euPessoas() { return (st.eu && st.eu.pessoas) || []; }
  function euConvite() { return (st.eu || {}).conviteId; }
  /* O HOMENAGEADO DO CONVITE, e a trava dele (D11) NAO PODE degradar para false
     em silencio. `p.homenageado` vem MASCARADO no amigo secreto (visao.ts so o
     projeta quando `homenageadoPublico(ocasiao)`), entao ele sozinho deixaria o
     homenageado sorteado responder o RSVP da propria festa. O eixo CRU e
     `podeResponder`, que o servidor calcula como `conviteAberto &&
     !ehHomenageadoLinha(p)`: com o convite aberto, quem nao pode responder e
     exatamente quem e homenageado. Os dois juntos cobrem tambem o convite ja
     fechado, onde ninguem pode responder e so a marca sobra. */
  function ehHomeEu(p) { return !!p.homenageado || (!!(st.eu || {}).podeResponder && !p.podeResponder); }
  function souHomenageado() { return euPessoas().some(ehHomeEu); }
  /* "NINGUEM SE PRESENTEIA" E UMA REGRA SO (R31, plano 4.0 item 2), e olha o
     convite INTEIRO: `soHome` = o convite de quem abriu e SO de homenageados.
     `souHomenageado` vale para qualquer convite que contenha o homenageado, e
     esconderia o presente dos outros da familia, que podem presentear o
     homenageado da propria familia (ligarPresentear); ela fica so no tipo do
     convite e na nota dos presentes. `euHome` e a mesma pergunta para as duas
     vistas: no organizador, o convite "Sou eu" com homenageado. */
  function soHome() { var ps = euPessoas(); return ps.length > 0 && ps.every(ehHomeEu); }
  function euHome() { return st.papel === 'organizador' ? st.convites.some(function (c) { return c.souEu && temHome(c); }) : soHome(); }
  /* A LISTA VISIVEL PARA O CONVIDADO numa leitura so (R31, adendo A1): a lista
     do convidado (listaDoConvidado, `oculta`) e o corpo do fim da pagina de
     quem e so homenageado (pintarFecho, f_hc/f_hco) leem daqui. No amigo
     secreto (`listaSempre` do perfil, decisao 113) a lista e sempre visivel,
     qualquer que seja o `listaVisivel` gravado: o servidor ja manda o valor
     efetivo, e o tema le o perfil tambem (os dois sobem em momentos diferentes). */
  function listaVis() { return !!(perfil().listaSempre || (st.ev && st.ev.listaVisivel)); }
  function temResposta(p) { return !!respostaDoStatus(p.status); }
  /* alguem do convite vai (o homenageado conta: ele nasce confirmado, D11). A
     regra do botao de presente do fecho e da banda. */
  function algumVai() { return euPessoas().some(function (p) { return p.status === 'confirmado'; }); }
  /* evento realizado fecha o RSVP mesmo sem prazo (a rota recusa), e a vista
     ainda diz podeResponder quando o prazo foi limpo */
  function podeResp() { return !!st.eu && !!st.eu.podeResponder && st.ev.status !== 'realizado'; }
  /* "A e B", "A, B e C", "A, B e mais 3" (5.1: acima de 4 vira contagem) */
  function juntar(lista) {
    var nomes = lista.map(function (c) { return c.nome; }).filter(Boolean);
    if (nomes.length < 2) return nomes[0] || '';
    if (nomes.length > 4) {
      return fmt(T.h_mais, { nomes: nomes.slice(0, 2).join(', '), contagem: nomes.length - 2 });
    }
    return fmt(T.h_dois, { nome1: nomes.slice(0, -1).join(', '), nome2: nomes[nomes.length - 1] });
  }

  function verConvite() {
    st.modo = 'convite';
    req('POST', '/convite/ver', corpoAcesso({})).then(function (j) {
      if (!j._ok) return telaErroResposta(j);
      /* o proprio dono abrindo o link que ele cunhou: `ver` resolve organizador
         antes do vinculo e nao ha convite para responder. O token deixa de valer
         como acesso daqui pra frente, senao /sugestoes sairia com a visao de
         convidado para o dono do evento. */
      if (j.papel === 'organizador') {
        tokenConvite = null;
        return abrirEvento(j.eventoId);
      }
      if (!aplicarConvite(j)) return;
      montarConvite();
      marcarInteracao();
      voltaLig();
      posResposta();
    }).catch(telaErroRede);
  }

  function aplicarConvite(j) {
    var v = j.vista || {};
    st.papel = 'convidado';
    st.ev = v.evento || {};
    st.id = st.ev.id || st.id;
    st.org = v.organizador || {};
    st.eu = v.eu || {};
    /* O GEMEO DO LEITOR DO ORGANIZADOR, e ele muda de shape no MESMO commit em
       que o `v=2` entra no fetch (decisao D-T1). Ate a r05 esta linha era
       `st.convidados = v.convidados || []`, e em v=2 `vista.convidados` nao
       existe mais: a resposta traz `convites[]`, cada um com as suas pessoas.
       Sem esta troca a lista do convidado sumiria em silencio, exatamente como a
       do organizador. Leitura assertiva pelo mesmo motivo: um shape inesperado
       tem que virar tela de erro, nunca lista vazia.
       `st.eu` e o objeto v=2 (`{ conviteId, pessoas[], podeResponder,
       vagaLivre }`), e a banda, o fecho, a lista neutra e a barra inferior ja
       falam o vocabulario de convite. */
    if (!Array.isArray(v.convites)) { telaErroResposta({ erro: 'versao' }); return false; }
    st.convites = v.convites;
    st.confirmados = v.confirmados || 0;
    st.presentes = v.presentes || null;
    /* os quatro sinalizadores do vinculo (`vinculado`, `podeVincular`,
       `recusado`, `outraConta`) vem na RAIZ da resposta de `ver`, nao dentro da
       vista: guardar `j` inteiro poupa copiar quatro campos para o mesmo lugar */
    st.vinc = j;
    /* A PRE-SELECAO MORREU (plano 2026-09, V7; decisao M10 do dono). O email
       novo leva um botao so, e o `&r=vou` dos emails antigos nao grava nem
       pre-marca mais nada: ele abre o convite no topo, como toda abertura pelo
       link (decisao 75). Quem tira o `r` do sessionStorage e o pegarToken(). */
    return true;
  }

  function montarConvite() {
    var v = clone('convite');
    if (!v) return telaDesligado();
    st.vista = v;
    /* a animacao de entrada (mwrise) so na PRIMEIRA montagem (R30, parte L): a
       vista e refeita a cada resposta, e a pagina inteira "subia de novo". A
       classe entra ANTES da troca, para a animacao nem comecar. */
    if (palco) palco.classList.toggle('mwev-montada', !!st.mt);
    st.mt = 1;
    trocar(v);
    ligarConvite(v);
    ligarCurador(v);
    pintarConvite();
    /* o foco volta ao botao que a pessoa tocou: a vista inteira foi refeita
       depois da resposta, e sem isto o teclado e o leitor de tela recomecavam
       do topo da pagina */
    var f = st.foco && q(v, st.foco);
    st.foco = '';
    if (f) f.focus({ preventScroll: true });
    /* A PAGINA NAO DESCE SOZINHA (R30, decisao 75 do dono, que reviu a 37): o
       convite abre no topo, na foto, e quem leva ate a resposta e o toque em
       "Responder ao convite" (a barra do celular e o atalho do computador). Ate
       a R30 a abertura pelo link rolava ate a banda aqui, e no celular a foto,
       o nome e a data sumiam para cima. */
  }

  function pintarConvite() {
    if (!st.vista) return;
    /* o evento cancelado (R31, decisao 95): so o atributo; o aviso do topo e a
       faixa de resposta que some sao do CSS (.mwev-ev[data-cancelado]) */
    st.vista.toggleAttribute('data-cancelado', !!st.ev.cancelado);
    pintarCabecalhoConv();
    pintarCamposConv();
    pintarRsvp();
    cond(st.vista, 'recado', !!st.ev.recado);
    setText(st.vista, 'recadoler', st.ev.recado);
    pintarLista();
    pintarPresentes();
    /* o painel depois da resposta (R31, parte DEPOIS) ANTES do fecho e do
       Guardar: os dois leem o que ele decidiu (`st.pe`, `st.pz`) */
    pintarPos();
    pintarFecho();
    pintarGuardar();
    pintarServico();
    /* O cartao de emails do convidado (R28) mora num modulo proprio,
       assets/mw-evento-emails.js, carregado antes deste: ele recebe a vista, a
       resposta do `ver`, o corpo de acesso (token ou id, que so este arquivo
       conhece) e o recarregar. Chamada direta, e nao CustomEvent: e o gancho
       mais barato e nao depende de construtor nenhum do Safari antigo. O mesmo
       objeto vai a linha do endereco de entrega do proprio homenageado
       (assets/mw-evento-endereco.js, R31 onda C), lida por propriedade.
       O MESMO objeto vai ao modulo da entrega (o pagamento com entrega aberto e
       nao pago, R31 onda C, 4.7 passo 6: `l`) e ao do presente (a faixa de quem
       comprou, R32, 9.2 e 9.3, que le o `eu.presentesMeus` e o modo dos
       presentes da resposta do `ver` em `j`): a unidade leva os nomes (ate 3,
       `n`) ou o substantivo (`u`). Cada modulo le so as chaves dele. */
    var eo = { v: st.vista, j: st.vinc, c: corpoAcesso, r: verConvite, l: st.eu.entregasPendentes, n: unidade() && nomeUnidade(), u: unidade() && T['un_' + oc()] };
    if (window.MWEvEmails) MWEvEmails(eo);
    if (window.MWEvEndereco) window.MWEvEndereco.conv(eo);
    if (ENT) ENT.pendente(eo);
    if (PRE) PRE.faixa(eo);
  }

  function pintarCabecalhoConv() {
    var v = st.vista, ev = st.ev;
    var nome = ev.nome || T.sem_nome;
    pintarCapa(v, ev, nome);
    /* o tipo do convite: "o evento e pra voces" quando o MEU convite tem dois
       ou mais homenageados (R31, parte OCASIOES; ponte nova com reserva) */
    var kh = euPessoas().filter(ehHomeEu).length > 1 && 'k_home_n' in T ? T.k_home_n : T.k_home;
    setText(v, 'kicker', fmt(souHomenageado() ? kh : T.k_conv, { ocasiao: tituloOcasiao(ev.ocasiao) }));
    setText(v, 'por', fmt(T.k_por, { organizador: st.org.nome || '' }));
    var sm = slot(v, 'saibamais');
    if (sm) sm.href = URLPRIV;
    setText(v, 'nome', nome);
    cond(v, 'sub', !!ev.subtitulo);
    setText(v, 'subtxt', ev.subtitulo);
    setText(v, 'ocasiaotxt', tituloOcasiao(ev.ocasiao));
    cond(v, 'capaderrubada', !!ev.capaDerrubada);
    /* denunciar so faz sentido com imagem na tela; depois da denuncia o
       "recebemos" fica no lugar do link, para o gesto nao parecer perdido */
    hd(acao(v, 'denunciar'), !ev.capaUrl || !!st.denunciado);
    hd(slot(v, 'denrecebido'), !st.denunciado);
    var lista = homenageados();
    cond(v, 'home', lista.length > 0);
    setText(v, 'hometxt', juntar(lista.map(function (h) { return h.p; })));
    /* o rotulo do bloco pelo papel (R31, decisao 100): "Aniversariante",
       "Formandos"; no papel `homenageado`, o "Pra quem e" de hoje. O slot so
       existe na section nova, que traz o h_lab: com a antiga nada se le. */
    var hl = slot(v, 'homelab'), pp = perfil().papel;
    if (hl && 'h_lab' in T) tc(hl, pp && pp !== 'homenageado' ? cap(rotuloPapel(lista.length)) : T.h_lab);
  }

  /* Os 4 campos em leitura. Campo vazio nao renderiza nem o rotulo (comentario
     5), e nenhum vira controle: quem edita e o organizador. */
  function pintarCamposConv() {
    var v = st.vista, ev = st.ev, fx = fraseFaixa(ev.faixa);
    [['cquando', ev.data, 'quandotxt', fQuando(ev)],
      ['conde', ev.localTexto, 'ondetxt', ev.localTexto],
      ['cprazo', ev.prazoRsvp, 'prazotxt', ev.prazoRsvp ? fDia(ev.prazoRsvp) : ''],
      ['cfaixa', fx, 'faixatxt', fx]].forEach(function (l) {
      cond(v, l[0], !!l[1]);
      setText(v, l[2], l[3]);
    });
  }

  /* ---------------- a banda de RSVP ---------------- */
  /* O PRAZO COMO DATA-ALVO (R32, 9.1; decisao 121): o "Pedir para reabrir"
     saiu (a rota parada fica so como referencia), porque quem chega depois do
     prazo responde ate o evento comecar. Com o prazo passado e a resposta
     aberta (`prazoPassou` do v=2; o `rsvpFechado` do v=2 e o fim da resposta, e
     com ele o `pode` ja e falso), a faixa fica igual a de antes do prazo, SEM a
     nota, e o fecho sem a linha de "ate o prazo" (9.11 item 1, a palavra do
     dono: "Vamos manter sem o texto de explicacao"). O aviso de que o prazo
     passou so vem DEPOIS de a pessoa marcar, na linha da faixa que o modulo do
     presente pinta (assets/mw-evento-presente.js). Sem o `prazoPassou` (o
     servidor de antes), a frase de sempre. */
  function dp(k) { return st.ev.prazoPassou ? '' : T[k]; }

  function pintarRsvp() {
    var v = st.vista, ev = st.ev;
    vigiarBanda(q(v, '.mwev-rsvp'));
    /* UMA LINHA POR PESSOA do convite (handoff 6.1). O homenageado nao entra:
       ele nasce confirmado e travado (D11), e quem diz isso e `ehHomeEu`. Sem
       ninguem para responder, a banda inteira some - era o que o `cond` antigo
       fazia com o convite de uma pessoa homenageada. */
    var ps = euPessoas();
    var alvos = ps.filter(function (p) { return !ehHomeEu(p); });
    cond(v, 'rsvp', alvos.length > 0);
    /* `st.td` (R30, parte L): quantos do convite responderam, SO quando todos
       responderam (0 enquanto falta alguem, e sem ninguem para responder) */
    st.td = 0;
    if (!alvos.length) return pintarBarra();

    var grupo = alvos.length > 1;
    var pode = podeResp();
    /* ATALHOS so com duas ou mais pessoas que podem responder AGORA: com uma, o
       atalho seria a propria linha repetida */
    cond(v, 'atalhos', pode && alvos.filter(function (p) { return p.podeResponder; }).length > 1);
    /* o convite de uma pessoa chama pelo PRIMEIRO nome de quem abriu o link,
       como o resto da casa fala com o cliente. A familia nao leva nome desde a F7
       (plano 2026-09): "Rodrigo, quem vai?" confundia quem abre o link da
       familia sem ser o Rodrigo. O nome e o de quem RESPONDE (R31, decisao
       96): numa familia com o homenageado primeiro, `ps[0]` era ele, e a
       pergunta saia com o nome de quem nao responde. */
    var pn = primeiro((alvos[0] || {}).nome);
    setText(v, 'rsvppergunta', grupo ? T.rs_pergg : pn ? fmt(T.rs_perg, { nome: pn }) : T.rs_perg0);

    /* o cancelado nao tem nota aqui desde a R31 (decisao 95): a faixa inteira
       some pelo CSS, e o aviso do topo diz o que houve */
    var nota = '';
    if (!pode) nota = T.rs_pfech;
    else if (ev.prazoRsvp || ev.data) nota = fmt(dp(grupo ? 'rs_notag' : 'rs_notas'), { prazo: fDia(ev.prazoRsvp || ev.data) });
    txtOuSome(v, 'rsvpnota', nota);

    /* As linhas, o rodape contador (rodapeRsvp) e o bloco da vaga. */
    var caixa = slot(v, 'rsvppessoas');
    tc(caixa, '');
    var vaiAlguem = false;
    alvos.forEach(function (p) {
      if (p.status === 'confirmado') vaiAlguem = true;
      caixa.appendChild(linhaRsvp(p, pode));
    });
    /* "Tudo respondido" so quando ninguem ficou sem resposta: com o prazo
       fechado e gente sem resposta, o rodape some (banca de clientes, F7). */
    st.td = rodapeRsvp(1) ? 0 : alvos.length;
    pintarVaga(v, ps.length > 1);

    /* A segunda linha da faixa (`rsvpsaida`, o "Pedido registrado" do "Pedir
       para reabrir") saiu com ele na R32 (9.1). */

    /* "Mudar" MORREU com a banda por pessoa, e o "Confirmar" da pre-selecao do
       email morreu com a V7: cada linha e um controle vivo o tempo todo (um
       toque grava, outro troca). */
    /* .ics so com data (sem ela nao ha o que por no calendario) e so quando
       alguem do convite vai: por no calendario um evento que a pessoa acabou de
       dizer que nao vai contradiz a propria resposta, e a linha de baixo ja
       oferece a saida */
    /* o "Escolher o presente" do pe da faixa (`rsvp-presentear`) saiu na R31
       (parte DEPOIS): o painel logo abaixo da faixa oferece o presente, e o
       botao saiu do markup no fechamento da R31 (Z0) */
    hd(acao(v, 'ics'), !(vaiAlguem && ev.data && !ev.cancelado));
    /* A BARRA OLHA OS BOTOES DE QUEM FALTA, o destino dela, e nao a faixa
       inteira (decisao 75, R30): com a pagina no topo, uma fresta do titulo da
       faixa no pe da tela escondia a barra sem mostrar botao nenhum. Os botoes
       so existem depois das linhas acima; sem eles, vale a faixa. */
    var bd = q(v, '.mwev-rsvp');
    vigiarBanda((bd && (q(bd, '[data-st="falta"] [data-r]') || q(bd, '[data-r]'))) || bd);
    pintarBarra();
  }

  /* A linha de UMA pessoa dentro da banda: nome, o que esta marcado e os dois
     botoes de 48px. `alvo` viaja em toda gravacao - sem ele o servidor grava no
     TITULAR, e em familia o filho responderia pela mae. */
  function linhaRsvp(p, pode) {
    var n = clone('rsvp-pessoa');
    var r = respostaDoStatus(p.status);
    setText(n, 'nome', p.nome);
    /* sem resposta e sem poder responder (prazo fechado): "ficou sem resposta",
       o mesmo texto da lista publica depois do prazo (F7) */
    setText(n, 'estado', r === 'vou' ? T.rs_pv : r === 'nao_vou' ? T.rs_pnv : pode ? T.rs_pf : T.l_nr);
    /* a cor do estado escrito, por status (V7): quem pinta e o stylesheet */
    S(n, 'data-st', r || 'falta');
    /* O SINAL DE SALVO (R31, decisao 116; os slots e o porque estao no template
       da linha): o check FICA em toda pessoa com resposta gravada, porque vem
       do status que o servidor devolveu (aparece tambem ao voltar a pagina, e
       nas linhas so de leitura); o "Salvo" de passagem, enquanto o temporizador
       do toque confirmado corre (`st.sv`), aqui sem a entrada em fade: a vista e
       refeita depois da fila, e o fade no clone novo piscaria (salvoRsvp). */
    cond(n, 'rsok', r);
    cond(n, 'rssv', r && st.sv[p.id]);
    /* prazo fechado, evento cancelado e homenageado viram LEITURA: nada de botao
       que erra ao ser clicado. O estado continua escrito ao lado do nome. */
    var podeP = pode && !!p.podeResponder;
    cond(n, 'btns', podeP);
    if (!podeP) return n;
    /* O ERRO NA LINHA (falhouRsvp): fica ate a pessoa tentar de novo ou trocar
       a resposta (enfileirarRsvp o apaga). O "Tentar de novo" repete o MESMO
       toque, e o foco vai ao botao da resposta que ele repete: o "Tentar de
       novo" some com o toque, e o foco nao pode cair no nada. O nome falado
       dele diz de quem e a linha ("Ana: Tentar de novo", o rs_baria). A ponte
       `rs_td` so e lida com o botao no template: a section antiga (entre os
       passos 3 e 4 da publicacao) nao tem nenhum dos dois, e a leitura sem o
       botao a anotaria como faltando (plano 4.0 item 14). */
    var er = st.er[p.id], sel = '[data-p="' + p.id + '"][data-r="' + er + '"]';
    cond(n, 'rserro', er);
    var bt = clique(n, 'rsvp-tentar', function () {
      enfileirarRsvp(er, p.id, sel);
      var b = q(st.vista, sel);
      if (b) b.focus({ preventScroll: true });
    });
    if (bt) aria(bt, fmt(T.rs_baria, { nome: p.nome, resposta: T.rs_td }));
    qa(n, '[data-r]').forEach(function (b) {
      var alvo = b.getAttribute('data-r');
      press(b, alvo === r);
      S(b, 'data-p', p.id);
      /* o rotulo do botao: a linha fala DE alguem ("Ana: Vai") */
      aria(b, fmt(T.rs_baria, { nome: p.nome, resposta: alvo === 'vou' ? T.rs_vai : T.rs_nvai }));
      /* O TOQUE GRAVA (V7). E POST de gente, nunca GET: nenhum scanner de
         email nem previa de link do WhatsApp aperta botao. */
      on(b, 'click', function () { enfileirarRsvp(alvo, p.id, '[data-p="' + p.id + '"][data-r="' + alvo + '"]'); });
    });
    return n;
  }

  /* "Todo mundo vai" / "Ninguem vai": a MESMA gravacao da linha, pessoa por
     pessoa, so para quem ainda nao esta com essa resposta. O homenageado fica
     fora (D11), e a autoria e a de sempre (DF2): o servidor grava quem
     respondeu pelo link. */
  function atalhoRsvp(r, b) {
    euPessoas().forEach(function (p) {
      if (ehHomeEu(p) || !p.podeResponder) return;
      if (p.status !== RSVP[r]) enfileirarRsvp(r, p.id, '[data-a="' + b.getAttribute('data-a') + '"]');
      /* quem ja estava com essa resposta salva e tinha um toque que nao salvou
         (o erro na linha): o atalho trocou a resposta dela tambem, e o erro sai */
      else if (st.er[p.id]) { delete st.er[p.id]; cond(linhaDe(p.id), 'rserro', 0); }
    });
  }

  /* A linha de uma pessoa na faixa, pelo id dela (os botoes levam `data-p`;
     a linha so de leitura nao tem botao, e nem toque). */
  function linhaDe(id) { var b = q(st.vista, '[data-p="' + id + '"]'); return b && b.closest('.mwev-rsvpp'); }

  /* O RODAPE DA FAIXA: quem falta, PELO NOME (R31, decisao 116; adendo B1
     item 5): "Falta a resposta de Julia. O que voce ja marcou esta salvo.", ate
     3 nomes e o "e mais %n" so a partir de 5 (nomesAte3), o nome inteiro so
     com dois primeiros nomes iguais entre quem falta (curtos). A contagem de
     antes (rs_rf1, rs_rfn), a reserva para a section sem o rs_rfm, saiu no
     fechamento da R31 (Z0): a section do ar ja tem o rs_rfm desde a onda B.
     Ele conta SO quem ainda pode responder: com o prazo fechado ninguem
     "falta", e a frase de cobranca viraria mentira. E so aparece depois da
     PRIMEIRA resposta GRAVADA do convite (F7, plano 2026-09): antes dela, "O
     que voce ja marcou esta salvo" falava de algo que ninguem marcou.
     E recalculado no toque, sem esperar a vista refeita (enfileirarRsvp), e de
     novo quando o servidor confirma (proximoRsvp): a linha com o toque ainda
     no ar (o botao com aria-busy) sai de quem falta, mas o "esta salvo" so
     acende com uma resposta que o servidor confirmou (o status em `st.eu`, que
     so muda com o OK; adendo B1 item 7), e o "Tudo respondido e salvo." so
     vem da vista inteira (`fim`, pelo pintarRsvp): no meio do toque ele diria
     salvo antes do servidor. Uma falha refaz o rodape pelo pararRsvp, so com
     o que ficou gravado. Devolve quantos ficaram sem resposta (o `st.td`). */
  function rodapeRsvp(fim) {
    var v = st.vista, pode = podeResp(), f = [], sem = 0, resp = 0;
    euPessoas().forEach(function (p) {
      if (ehHomeEu(p)) return;
      if (temResposta(p)) resp = 1;
      else if (!q(v, '[data-p="' + p.id + '"][aria-busy]')) {
        /* com o prazo fechado ninguem tem podeResponder: quem ficou sem
           resposta se conta pela RESPOSTA */
        sem++;
        if (pode && p.podeResponder) f.push(p);
      }
    });
    txtOuSome(v, 'rsvprodape', !resp ? '' : f.length ? fmt(T.rs_rfm, { nomes: nomesAte3(curtos(f)) }) : fim && !sem ? T.rs_rok : '');
    return sem;
  }

  /* O "SALVO" DE PASSAGEM (R31, decisao 116): o servidor confirmou o toque, e a
     linha da pessoa mostra o check e o "Salvo" por 3 s, com o fade de entrada
     e de saida do CSS (`data-entra`/`data-sai`; com "reduzir movimento" o CSS
     tira a animacao, e ele so aparece e some). O temporizador vive em `st.sv`,
     e a linha e procurada pelo id quando ele vence: a vista refeita depois da
     fila mostra o "Salvo" de novo (linhaRsvp) e e ele que some. Na saida, o
     `data-entra` sai e a largura e lida ANTES do `data-sai` entrar: com o mesmo
     nome de animacao nos dois, o navegador so recomeca a animacao se ela
     deixar de existir entre um e outro. */
  function salvoRsvp(id) {
    var l = linhaDe(id), e = cond(l, 'rssv', 1);
    cond(l, 'rsok', 1);
    /* o botao da pessoa deixa de parecer gravando no mesmo instante: num "Todo
       mundo vai" a fila ainda grava os outros e refaz a vista, e o "Salvo" ao
       lado de um botao apagado (aria-busy) dizia duas coisas */
    qa(st.vista, '[data-p="' + id + '"]').forEach(function (b) { rmA(b, 'aria-busy'); });
    rmA(e, 'data-sai');
    S(e, 'data-entra', '');
    clearTimeout(st.sv[id]);
    st.sv[id] = setTimeout(function () {
      var e = q(linhaDe(id), '[data-slot-if="rssv"]:not([hidden])');
      delete st.sv[id];
      if (!e) return;
      rmA(e, 'data-entra');
      S(e, 'data-sai', e.offsetWidth);
      setTimeout(function () { hd(e, 1); rmA(e, 'data-sai'); }, 200);
    }, 3000);
  }

  /* A VAGA de acompanhante na vista do convidado: um lugar a mais que o titular
     nomeia ao confirmar. NUNCA um campo numerico, em lugar nenhum (handoff 5):
     a vaga e uma pessoa a ser nomeada, nao um numero. */
  function pintarVaga(v, grupo) {
    var livre = !!(st.eu || {}).vagaLivre && podeResp();
    cond(v, 'rsvpvaga', livre);
    if (livre) setText(v, 'vagatxt', grupo ? T.cv_acg : T.cv_acs);
  }
  function incluirVaga() {
    var e = campo(st.vista, 'vagaNome');
    var nome = e && e.value.trim();
    if (!nome) return e && e.focus();
    if (st.vagaIndo) return;
    st.vagaIndo = 1;
    req('POST', '/convite/acompanhante', corpoAcesso({ nome: nome, chaveIdem: opId() })).then(function (j) {
      st.vagaIndo = 0;
      /* Os dois erros da rota NAO podem dividir a frase. O 409 e a vaga que
         alguem tomou (`cv_vind`); o 429 e a vaga RELIGADA no mesmo dia, e ali a
         verdade e o teto do dia (`f_teto`), nao "o lugar ja nao esta
         disponivel" - que culparia a pessoa por algo que ela nao fez. Os dois
         ja estao no mapa ERRO, cada um com a sua. */
      if (!j._ok) {
        bad(msgErro(j));
        /* a vaga sumiu entre a pintura e o clique: a tela tem que dizer como
           ela esta AGORA, senao o bloco segue oferecendo o que ja nao existe */
        if (j.erro === 'vaga_indisponivel') verConvite();
        return;
      }
      /* A rota devolve a linha pronta e `vagaLivre: false`, mas a vista inteira
         volta do servidor assim mesmo: a pessoa nova tambem entra na LISTA de
         convidados (o proprio convite aparece la), e costurar os dois lugares a
         mao e a classe de remendo que a F7 ja tirou daqui. */
      verConvite();
    }).catch(function () { st.vagaIndo = 0; quedaDeRede(); });
  }

  /* Destino do "Escolher o presente" da banda: o evento quando nao ha
     homenageado (ou na unidade), o homenageado quando ha um so. Com dois ou
     mais nao da para escolher por ninguem - e a lista tem o botao de cada um. */
  function destinoPadrao() {
    /* quem e SO homenageado nunca e destino de si mesmo (R31, decisao 96). Na
       familia com homenageado nada muda: quem responde e o resto da familia, e
       o presente para o homenageado dela e proposital (por isso soHome, e nao
       souHomenageado) */
    if (st.papel !== 'organizador' && soHome()) return '';
    /* o perfil (R31, decisoes 99 e 115): no amigo secreto (`todos`) cada linha
       tem o seu botao e nao ha destino unico; na unidade (casal e casa nova,
       "pelo tipo") o destino e o evento, com ou sem nomes. O `legado` (servidor
       sem perfil) segue a regra de antes. */
    var h = homenageados();
    if (perfil().presente === 'todos') return '';
    if (!h.length || unidade()) return 'evento';
    /* o destino e a PESSOA; `homenageados()` devolve o par pessoa+convite porque
       "Sou eu" e marca do convite, nao dela */
    return h.length === 1 ? h[0].p.id : '';
  }

  /* "Escolher o presente" da banda e o do estado vazio dos presentes apontam
     para o MESMO destino: nao ha duas escolhas a fazer na mesma tela */
  function presentearPadrao() { semearCurador(destinoPadrao()); }

  /* ---------------- o painel depois de responder (R31, parte DEPOIS) ----------------
     Decisoes 107 e 116 do dono (plano R31, secoes 2.9 e 4.6). Logo abaixo da
     faixa, ja na PRIMEIRA resposta de qualquer pessoa do convite, "vai" ou "nao
     vai", em no maximo dois niveis e sem modal:
     - NIVEL 1: o titulo (que confirma e ja diz que ficou salvo), o corpo pela
       ocasiao, de 1 a 3 botoes de presente (ou o da lista) e um "Agora nao";
     - NIVEL 2: so o titulo, e o "Guardar" logo abaixo (pintarGuardar). Vale
       depois do "Agora nao" (lembrado no aparelho ate a resposta mudar de lado:
       de "vai" para "nao vai" e a hora do "manda um presente"), com o presente
       ja escolhido (a marca `pp` do aparelho ou um pedido do proprio convite) e
       sem nada a oferecer.
     Quem nao ve o painel: quem e so homenageado, o evento cancelado e o que ja
     aconteceu. */

  /* Os botoes de presente, pelo perfil da ocasiao: a pessoa (`n`, o nome no
     botao: o primeiro, ou o inteiro com dois primeiros iguais), o evento (`d`
     'evento': o evento sem homenageado e a unidade, casal e casa nova, com ou
     sem nomes) ou a lista (`l`: 1 no amigo secreto, 2 com 4 ou mais
     celebrados). Quem e SO homenageado nao tem botao (ninguem se presenteia);
     numa familia, o homenageado da propria familia e botao como os outros
     (decisao 96; adendo B4 de 02/10). Sem texto aqui: o fecho e o Guardar leem
     esta lista tambem com a section antiga, que nao tem as pontes do painel. */
  function alvosPos() {
    if (st.ev.cancelado || soHome()) return [];
    var m = perfil().presente, h = homenageados(), ns = curtos(h);
    if (m === 'todos') return [{ l: 1 }];
    if (m === 'unidade' || !h.length) return [{ d: 'evento' }];
    if (h.length > 3) return [{ l: 2 }];
    return h.map(function (x, i) { return { d: x.p.id, n: ns[i].nome }; });
  }
  /* OS NOMES CURTOS de uma lista de pessoas, numa regra so (plano 4.6: "o
     primeiro nome; com dois iguais, o nome inteiro"): os botoes do painel, o
     titulo, o corpo e o rodape da faixa. O nome inteiro so quando o primeiro
     se repete NAQUELA lista: "Maria Clara" e "Maria Eduarda" nunca saem
     "Maria e Maria". Aceita pessoas ou os pares de `homenageados()` (`x.p`)
     e devolve [{ nome }], a forma do juntar() e do nomesAte3(). */
  function curtos(l) {
    var ps = l.map(function (x) { return x.p || x; }), ns = ps.map(function (p) { return primeiro(p.nome); });
    return ps.map(function (p, i) { return { nome: ns.indexOf(ns[i]) !== ns.lastIndexOf(ns[i]) ? p.nome : ns[i] }; });
  }
  /* ate 3 nomes; "e mais %n" so a partir de 5 (com 4, os 4 nomes), e com o
     corte os 3 nomes so com virgula (adendo B1 item 5: o juntar() poria "e"
     antes do ultimo nome e cortaria em 2). `l` = [{ nome }] */
  function nomesAte3(l) {
    return l.length > 4 ? l.slice(0, 3).map(function (x) { return x.nome; }).join(', ') + ' ' + fmt(T.rs_rfx, { n: l.length - 3 }) : juntar(l);
  }
  /* As regras (plano 4.6): `al` = quem do convite responde (o homenageado
     fora), `hdr` = o painel na tela, `n1` = o nivel 1. Escreve o que os outros
     leem depois dele: `st.pv` (a secao, quando na tela: o alvo da rolagem e da
     regiao viva), `st.n1`, `st.pz` (o painel na tela com o convite inteiro
     respondido: o fecho compacto e o rodape "Tudo respondido" fora) e `st.pe`
     (o que o Guardar e o fecho perguntam). Com a section antiga, sem o slot,
     nada aparece e `n1` e `st.pz` ficam falsos. */
  /* AS MARCAS DO PAINEL, por convite: `pn_` = o "Agora nao" (com o lado da
     resposta dele, 'v' ou 'n') e `pp_` = o presente escolhido. Vivem no
     aparelho (`mw_ev_pn_<convite>`, `mw_ev_pp_<convite>`) e TAMBEM em memoria
     (`st.mp`): com o storage bloqueado o mem() engole a excecao e le null, e
     sem a copia o "Agora nao" e o presente escolhido nao tirariam o nivel 1
     nesta visita. A memoria vence porque e a decisao mais nova. */
  function marcaPos(k, val) {
    k += euConvite();
    if (val) { st.mp[k] = val; mem(1, 'mw_ev_' + k, val); }
    return st.mp[k] || mem(1, 'mw_ev_' + k);
  }
  function pintarPos() {
    var v = st.vista, ev = st.ev, s = q(v, '[data-slot-if="pos"]');
    var al = euPessoas().filter(function (p) { return !ehHomeEu(p); });
    var vao = al.filter(function (p) { return p.status === 'confirmado'; });
    var nao = al.filter(function (p) { return p.status === 'recusado'; });
    var a = alvosPos(), as = vao.length ? 'v' : 'n', resp = al.some(temResposta);
    var hdr = al.length > 0 && resp && !ev.cancelado && ev.status !== 'realizado';
    var n1 = !!s && hdr && a.length > 0 && marcaPos('pn_') !== as && !marcaPos('pp_') && !((st.eu || {}).presentesMeus || []).length;
    st.pe = { h: hdr, s: !a.length, r: resp, a: as };
    st.n1 = n1;
    /* o nivel 1 que aparece fora de um lote de respostas (a pagina que ja abre
       com ele, a fila que parou num erro) ja apareceu na visita: o aviso dele
       na regiao viva nao vem mais (posResposta, bit 1 de `st.av`). A fila que
       parou num erro da o aviso ela mesma, se for a primeira vez (falhouRsvp) */
    if (n1 && !st.lt && !st.ps) st.av |= 1;
    st.pv = s && hdr ? s : 0;
    st.pz = !!st.pv && !faltaAlguem();
    hd(s, !st.pv);
    /* `data-n1` na raiz: o CSS tira o cartao de emails e o botao de presente
       da secao de presentes enquanto o nivel 1 oferece o mesmo */
    v.toggleAttribute('data-n1', n1);
    /* o "Tudo respondido e salvo." sai com o titulo do painel na tela, que ja
       diz isso; o "Falta a resposta de..." continua (sem falta, o rodape so
       pode ser aquela frase ou nada) */
    if (st.pz) hd(slot(v, 'rsvprodape'), 1);
    if (!st.pv) return;
    /* O TITULO: com alguem do convite indo, fala de quem vai; so com "nao vai",
       de quem nao vai. O convite de uma pessoa (a faixa a chama de "voce") com
       "voce"; a familia pelos primeiros nomes, e "voces" quando todos deram a
       mesma resposta. */
    var g = al.length > 1, l = vao.length ? vao : nao;
    var k = vao.length ? (!g ? 'vai' : vao.length === al.length ? 'todos' : vao.length > 1 ? 'vai_varios' : 'vai_um')
      : !g ? 'nao' : nao.length === al.length ? 'ninguem' : nao.length > 1 ? 'nao_varios' : 'nao_um';
    var nm = juntar(curtos(l));
    setText(s, 'postitulo', fmt(T['pos_titulo_' + k], { nome: nm, nomes: nm }));
    var cp = slot(s, 'poscorpo'), ac = slot(s, 'posacoes');
    hd(cp, !n1);
    hd(ac, !n1);
    qa(ac, '[data-cl]').forEach(function (b) { b.remove(); });
    if (!n1) return;
    /* O CORPO pela ocasiao: o amigo secreto sem nome nenhum; o evento sem
       homenageado (levar no dia ou mandar entregar); 4 ou mais celebrados, a
       lista; o churrasco e o jantar (tom anfitriao), a frase do dono para quem
       vai; a unidade com os nomes juntos ou, sem nomes e com 4 ou mais, a
       variante `_unidade` ("o casal"). Quem nao vai: `p_nao_g` quando mais de
       uma pessoa do convite RESPONDE (`g`, a mesma conta do titulo, com o
       homenageado fora) e `p_nao_s` quando so uma responde, inclusive no
       convite "Rodrigo e Julia homenageada": o titulo diz "voce" e o corpo
       acompanha (adendo B1 item 4: quem segura o celular pode nao ser quem
       disse nao). */
    var pf = perfil(), un = pf.presente === 'unidade', h = homenageados(), vai = vao.length > 0;
    var hn = curtos(h), nome = un ? nomeUnidade() : juntar(hn);
    var kc = pf.presente === 'todos' ? (vai ? 'p_todos' : 'p_todos_nao')
      : !un && !h.length ? (vai ? 'p_evento' : 'p_evento_nao')
      : !un && h.length > 3 ? 'p_lista'
      : (vai ? (pf.tom === 'anfitriao' && !un ? 'p_levar_home' : 'p_vai') : g ? 'p_nao_g' : 'p_nao_s') + (un && !nome ? '_unidade' : '');
    /* `un_<ocasiao>` so existe no casal e na casa nova: lida fora deles, o
       coletor da ponte a anotaria como faltando */
    setText(s, 'poscorpo', fmt(T['pos_' + kc], { nome: nome, nomes: nomesAte3(hn), unidade: un ? T['un_' + oc()] || '' : '' }));
    /* OS BOTOES: o do markup e o primeiro, e os outros sao copias dele (as da
       pintura anterior saem acima). A acao principal com alguem do convite
       indo; com ninguem indo, o secundario da casa (a regra do fecho). O toque
       e o ouvinte delegado do ligarConvite; com o evento incompleto, inerte. */
    var b0 = acao(ac, 'pos-presente'), bl = acao(ac, 'pos-lista'), cls = 'mwev-btn mwev-btn-' + (vai ? 1 : 2), x = a[0];
    hd(b0, !!x.l);
    hd(bl, !x.l);
    if (bl) bl.className = cls;
    tc(bl, x.l > 1 ? T.pos_cta_lista : x.l ? T.pos_cta_lista_todos : '');
    if (!x.l && b0) a.forEach(function (y, i) {
      var b = i ? b0.cloneNode(false) : b0;
      if (i) { S(b, 'data-cl', ''); ac.insertBefore(b, bl); }
      b.className = cls;
      S(b, 'data-d', y.d);
      tc(b, y.n == null ? rotuloEvento() : fmt(T.l_pres, { nome: y.n }));
      inerte(b, incompleto() ? T.m_inc : null);
    });
  }
  /* a lista, a pedido da pessoa (amigo secreto, 4 ou mais celebrados): a pagina
     rola ate a lista e o foco vai a busca, ou, sem a barra, ao titulo dela.
     Com 4 ou mais celebrados (`l: 2`) o corpo diz que eles estao no topo da
     lista: se a busca ou o filtro que a pessoa deixou (decisao 94, valem ate
     recarregar) escondem algum deles, os dois saem antes, como nas saidas do
     "ninguem encontrado", e a lista volta inteira. Sem esconder nenhum, ficam.
     A conta e por pessoa (`passaConv`): o celebrado que so aparece porque a
     familia passa tambem limpa, e limpar a mais nao esconde ninguem. No amigo
     secreto (`l: 1`) a busca fica: e com ela que a pessoa acha quem tirou. */
  function posLista() {
    var v = st.vista, cb = campo(v, 'cbusca'), ts = termos(st.cb);
    if ((alvosPos()[0] || 0).l > 1 && homenageados().some(function (x) { return !passaConv(x.p, ts); })) {
      st.cb = st.cf = '';
      st.cbf = {};
      if (cb) cb.value = '';
      pintarLista();
    }
    rolarAte(q(v, '.mwev-conv'), cb && cb.offsetWidth ? cb : slot(v, 'convtit'));
  }
  /* "Agora nao": lembrado no aparelho para a resposta de agora (`v` alguem do
     convite vai, `n` ninguem). O botao tocado some: o foco vai ao titulo do
     Guardar quando ele aparece (com a rolagem minima ate ele), senao ao titulo
     do painel, sem pulo (preventScroll). */
  function agoraNao() {
    var g = q(st.vista, '[data-slot-if="guardar"]'), t;
    marcaPos('pn_', st.pe.a);
    pintarPos();
    pintarGuardar();
    t = slot(g, 'guardartitulo');
    if (g && !g.hidden) rolarAte(g);
    t = g && !g.hidden && t && !t.hidden ? t : slot(st.pv, 'postitulo');
    if (t) t.focus({ preventScroll: true });
  }

  /* ---------------- fecho da vista do convidado (R-57) ----------------
     A ultima coisa da tela, e muda conforme a resposta. `recusou` e a variante
     que importa comercialmente: quem nao vai ainda pode presentear, e esta e a
     unica tela onde da para dizer isso sem soar cobranca.
     Evento CANCELADO nao tem fecho: "voce esta na lista" sobre um evento que
     nao vai acontecer e mentira, e o aviso do topo (.mwev-faixa.mwev-canc, R31)
     ja diz o que houve. */
  function pintarFecho() {
    var v = st.vista, sec = cond(v, 'fecho', !st.ev.cancelado);
    if (!sec) return;
    /* QUATRO situacoes (r06 2.3), e o kicker flexiona pelo TAMANHO DO CONVITE,
       nunca pelo numero de respostas: "RESPOSTAS REGISTRADAS" sobre "Pronto,
       voce esta na lista" e o mesmo erro de escopo ja corrigido no kicker de
       eventos desligados. O homenageado entra na conta (status `confirmado` por
       construcao), senao um convite so dele cairia em "fica pra proxima".
       `nao_respondeu` conta como falta de resposta, como antes. */
    var ps = euPessoas(), grupo = ps.length > 1, pode = podeResp();
    /* "Este link e so seu" e falso no convite de familia: a frase e do tamanho do
       convite. E so para quem esta DESLOGADO (R30, parte E): logado, a conta ja
       existe, e o bloco "Guardar" oferece usa-la. Deslogado, a frase some
       tambem enquanto o bloco "Guardar" esta na tela (R30, F6: os dois recados
       se contradiziam). Quem esconde e o CSS (`.mwev-guardar:not([hidden]) ~`),
       que acompanha o bloco em toda repintura dele. */
    cond(v, 'semconta', !grupo && !LOGADO);
    cond(v, 'semcontag', grupo && !LOGADO);
    var falta = ps.some(function (p) { return !temResposta(p); });
    var vai = algumVai();
    /* O CONVITE SO DE HOMENAGEADOS (R31, decisao 96): ele nao responde, entao o
       fim da pagina nao fala em resposta registrada nem oferece presente para
       ele mesmo (o fecho-cta some pelo destinoPadrao, que e vazio para ele).
       Sem kicker; o titulo diz que ele nao precisa responder e o corpo fala da
       lista acima, ou, com a lista escondida, de quem acompanha as respostas.
       As pontes novas tem reserva (plano 4.0 item 14): com a section antiga, o
       titulo de antes (a mesma conta de sempre, o plural da familia de
       homenageados inclusive) e o corpo vazio, nunca o "da para responder". */
    var so = soHome();
    /* O FECHO COMPACTO (R31, parte DEPOIS): com o painel depois da resposta na
       tela e o convite inteiro respondido (`st.pz`), ou sem presente nenhum a
       oferecer, sobram o contato e a frase do `semconta`: o titulo do painel ja
       confirma, e o presente esta nele. O convite so de homenageados fica com o
       titulo e o corpo dele (acima). Sem o titulo na tela, a secao perde o nome
       que apontava para ele. O fecho de antes da resposta, o da familia que
       ainda responde e o do evento que ja aconteceu ficam como estao. */
    var cp = !so && !!(st.pz || st.pe && st.pe.s);
    var kick = slot(v, 'fechokicker');
    txtOuSome(v, 'fechokicker', so || cp ? '' : falta ? (grupo ? T.f_fk : T.f_pk) : (grupo ? T.f_qk : T.f_sk));
    S(kick, 'data-cor', falta ? 'falta' : 'ok');
    setText(v, 'fechotitulo', so && 'f_ht' in T ? T.f_ht : falta ? (grupo ? T.f_ft : T.f_pt) : vai ? (grupo ? T.f_qt : T.f_ct) : T.f_nt);
    hd(slot(v, 'fechotitulo'), cp);
    if (cp) rmA(sec, 'aria-labelledby');
    else S(sec, 'aria-labelledby', 'mwev-h-fecho');
    /* O CORPO, que ate a r05 era a frase fixa da reversibilidade. Ele so promete
       "da para mudar" enquanto o prazo esta aberto (com ele passado, nenhuma
       linha: o dp, R32); o do convite que ninguem vai nao depende do prazo,
       porque fala de presente e nao de resposta. */
    /* a lista visivel vem do listaVis(), a mesma leitura da lista do convidado
       (listaDoConvidado, `oculta`): a onda B muda so o helper (o amigo secreto
       de lista sempre visivel, decisao 113) e os dois lugares acompanham */
    txtOuSome(v, 'fechocorpo', cp ? '' : so
      ? (listaVis() ? ('f_hc' in T ? T.f_hc : '') : ('f_hco' in T ? T.f_hco : ''))
      : falta || vai
      ? (pode ? (grupo ? (falta ? T.f_fc : dp('f_qc')) : dp('f_rev')) : '')
      : (grupo ? T.f_ng : T.f_ns));
    /* COM RESPOSTA FALTANDO A ACAO E RESPONDER (banca de clientes da F7, plano
       2026-09): o de presente, logo abaixo de "Voce ainda nao respondeu", foi
       lido por 4 de 4 convidados como o jeito de responder ou como compra
       obrigatoria. O "Responder ao convite" so existe enquanto alguem ainda
       PODE responder (a mesma regra da barra). A falta de resposta so esconde o
       presente enquanto alguem ainda pode responder: com o prazo fechado e
       alguem que vai, o presente aparece. Quando ninguem vai ele vira o
       secundario da casa. */
    hd(acao(v, 'fecho-responder'), !faltaAlguem());
    /* o atalho do topo (R30, decisao 75): a mesma regra, perto do titulo. Quem o
       mostra so de 1024 px para cima e o CSS; abaixo disso quem leva a resposta
       e a barra do celular. Section antiga sem ele: acao() nulo, hd() nao faz nada. */
    hd(acao(v, 'topo-responder'), !faltaAlguem());
    var cta = acao(v, 'fecho-cta');
    tc(cta, vai ? T.f_ca : T.f_ra);
    if (cta) cta.className = 'mwev-btn mwev-btn-' + (vai ? 1 : 2);
    /* sem destino unico (dois ou mais homenageados) nao da para escolher por
       ninguem: a lista de convidados tem o botao de cada um */
    hd(cta, so || cp || faltaAlguem() || !destinoPadrao());
    var lk = slot(v, 'fechocontato');
    /* `ref` = os IDS (evento e, quando a projecao traz, o do convidado). NUNCA o
       token do convite, e este e o unico ponto do cliente onde ele existe. O token
       e credencial ao portador: quem o tem responde o RSVP e fala pelo convidado.
       Em `?ref=` ele sairia do nosso dominio (a pagina de contato guarda o valor num
       campo oculto que vai no email do formulario) e entraria em log da Shopify e no
       historico do navegador, contra a mesma regra que mantem o RSVP no fragmento.
       Os ids resolvem o que o contexto precisa resolver, que e o atendimento nao
       comecar perguntando "qual evento?", e nao dao poder a quem os ve. O painel faz
       igual em `lib/eventos/contato.ts`. */
    if (lk) {
      /* em v=2 quem identifica quem escreve e o CONVITE, nao mais uma linha:
         `st.eu.id` deixou de existir e sem esta troca o `ref` degradava para o
         id do evento sozinho, e o atendimento voltava a perguntar "qual
         convite?". Continua um ID, nunca o token. */
      var refc = euConvite() ? st.id + ':' + euConvite() : st.id;
      lk.href = URLCONTATO + '?assunto=evento&origem=convite-convidado&ref=' + encodeURIComponent(refc);
    }
  }

  /* A IDA ATE A RESPOSTA, so a PEDIDO da pessoa (R30, decisao 75 do dono, que
     reviu a 37; WCAG 3.2.5): o toque em "Responder ao convite" da barra do
     celular, do fecho e do atalho do topo. Ate a R30 a mesma conta rodava
     sozinha na abertura pelo link (plano 2026-09, V2) e ao tocar de novo no
     mesmo link; as duas sairam, e o convite abre no topo. A rolagem e suave,
     como o dono pediu ("rolar com scroll suave e nao pular para a ancora"), e
     so salta direto com "reduzir movimento" no aparelho. A conta e
     feita aqui, e nao com scrollIntoView, porque o que precisa ficar INTEIRO e
     DESCOBERTO sao os botoes Vai / Nao vai, e o cabecalho grudado da loja fica
     por cima do topo da tela. O fixo de baixo, a barra do celular, some com a
     banda na tela e nao entra na conta.
     Cabendo do topo da banda ate o ultimo botao, o fim dessa faixa encosta no
     limite de baixo, e o maximo de titulo e informacao fica acima dela. Nao
     cabendo (familia grande em tela baixa), encosta no limite de baixo o ultimo
     botao que cabe com o topo da banda a vista: pergunta, atalhos e as
     primeiras pessoas ficam na tela, o resto vem na rolagem. Se ja esta tudo na
     tela, nada rola.
     O LANCADOR DO CURADOR NAO ENTRA NA CONTA: desde a F10 (decisao 50 do dono)
     ele nao aparece nesta pagina (CSS da section). Ate a F7 a conta parava os
     botoes acima dele; na F7 ele saia de cena so com a banda na tela.
     `focar` e o do "Responder ao convite" (barra, fecho e topo): o foco vai ao
     primeiro botao de quem ainda NAO respondeu (sem ninguem faltando, ao
     primeiro botao da banda), e a rolagem estende o que for preciso para ele
     ficar na tela - numa familia grande ele pode estar la embaixo. */
  /* deslocamento vertical de um transform em curso: a banda entra subindo 24px
     (mwrise), e a conta e sobre onde ela PARA, nao sobre o meio da subida -
     senao o topo da banda acabava embaixo do cabecalho */
  function trY(e) {
    try { return new DOMMatrixReadOnly(getComputedStyle(e).transform).m42 || 0; } catch (x) { return 0; }
  }
  /* a faixa de cima que o cabecalho preso da loja cobre, com 12px de folga, e o
     modo da rolagem ("reduzir movimento" no aparelho = salto direto). Servem ao
     irAteBanda e ao rolarAte (o "Guardar", R30 parte E). */
  function topoLivre() {
    var cab = document.querySelector('.mw-header');
    cab = cab && cab.closest('.shopify-section');
    return (cab && /sticky|fixed/.test(getComputedStyle(cab).position) ? cab.getBoundingClientRect().height : 0) + 12;
  }
  function modoRola() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  function irAteBanda(focar) {
    var b = q(st.vista, '.mwev-rsvp');
    if (!b || b.hidden) return;
    var bs = qa(b, '[data-r]').filter(function (e) { return e.offsetWidth; });
    /* a barra do celular sai ANTES da conta: ela some com a banda na tela, e
       medida aqui ainda na tela roubaria a faixa de baixo. O observador da
       banda a devolve sozinho se ela sair da tela. */
    barraFora = false;
    avaliarBarra();
    var fc = focar && (bs.filter(function (e) { return e.closest('[data-st="falta"]'); })[0] || bs[0]);
    var dy = trY(b), vv = window.visualViewport;
    var y = window.scrollY, topoB = b.getBoundingClientRect().top - dy;
    var alto = Math.min(innerHeight, vv ? vv.height : innerHeight);
    var topo = topoLivre();
    var fundo = alto - 12;
    /* o ULTIMO botao que ainda cabe com o topo da banda a vista encosta no limite
       de baixo: com a banda inteira, e o ultimo de todos; sem, o seguinte fica
       fora da tela, nunca pela metade na borda de baixo. Nem o primeiro
       cabendo, o topo da banda encosta no cabecalho. */
    var fim = 0, alvo = topoB + y - topo;
    bs.forEach(function (e) {
      var f = e.getBoundingClientRect().bottom - dy;
      if (f - topoB <= fundo - topo) { fim = f; alvo = f + y - fundo; }
    });
    var rola = fim > fundo || topoB < topo || !fim, fy = rola ? Math.max(0, alvo) : y;
    /* o botao a focar passou do limite de baixo depois da conta: ele encosta la */
    var fb = fc ? fc.getBoundingClientRect().bottom - dy + y : 0;
    if (fb - fy > fundo) { fy = fb - fundo; rola = true; }
    if (rola) window.scrollTo({ top: fy, behavior: modoRola() });
    if (fc) fc.focus({ preventScroll: true });
  }

  /* A FILA DA RESPOSTA (V7): cada toque entra numa fila e sai UM POST por vez,
     com `aria-busy` no botao enquanto ele nao volta. Um toque novo na MESMA
     pessoa troca o que ainda nao saiu (o ultimo toque vence). Quando a fila
     esvazia, a vista inteira volta do servidor UMA vez - familia de 10 no
     atalho = 10 POSTs + 1 recarga, dentro do teto de 30 por minuto do link - e
     o foco volta ao botao tocado (`st.foco`, lido no montarConvite).
     `alvo` e o `Convidado.id` de QUEM esta respondendo, e ele e obrigatorio em
     familia: ausente, o servidor grava no TITULAR (rsvp/route.ts), entao o filho
     que marca "Nao vou" derrubava a resposta da mae. O servidor so aceita um
     alvo de dentro do convite que o token abriu; id de fora recebe o mesmo 404
     opaco de token invalido. */
  var filaRsvp = [];
  function enfileirarRsvp(r, alvo, foco) {
    /* O LOTE (R30, parte L): as gravacoes ate a fila esvaziar. Guarda as frases
       do leitor de tela, se faltava alguem ANTES dele (`st.td` da ultima
       pintura, que e o que o servidor confirmou) e se o botao Guardar ja estava a
       vista. O gesto (`st.gs`) zera a cada toque de resposta, e o toque cancela
       a rolagem que ainda esperava a pausa do lote anterior (`st.tr`). */
    st.gs = 0;
    clearTimeout(st.tr);
    if (!st.lt) st.lt = { m: [], f: !st.td, g: st.pv || st.gc };
    filaRsvp = filaRsvp.filter(function (x) { return x.alvo !== alvo; });
    filaRsvp.push({ r: r, alvo: alvo });
    st.foco = foco;
    S(q(st.vista, foco), 'aria-busy', 'true');
    /* A ESCOLHA APARECE NA HORA (o cursor de espera nao existe no celular): o
       botao tocado ja sai marcado, o outro da linha desmarca, e a linha ganha o
       estado escrito e a cor do status - com `aria-busy`, que o stylesheet apaga
       um pouco, ate o POST voltar. `st.eu` so muda com a resposta do servidor,
       entao a falha repinta a banda como ela estava. */
    var l = linhaDe(alvo);
    qa(st.vista, '[data-p="' + alvo + '"]').forEach(function (b) {
      var sim = b.getAttribute('data-r') === r;
      press(b, sim);
      if (sim) S(b, 'aria-busy', 'true');
      else rmA(b, 'aria-busy');
    });
    /* O SINAL DE SALVO SO DO QUE O SERVIDOR CONFIRMOU (R31, decisao 116): o
       estado escrito ja mostra a resposta nova, entao o check e o "Salvo" da
       resposta anterior saem ate o OK (salvoRsvp); o erro na linha de um toque
       anterior sai tambem (a pessoa tentou de novo ou trocou a resposta), e o
       rodape ja tira a pessoa de quem falta. */
    clearTimeout(st.sv[alvo]);
    delete st.sv[alvo];
    delete st.er[alvo];
    if (l) {
      S(l, 'data-st', r);
      setText(l, 'estado', r === 'vou' ? T.rs_pv : T.rs_pnv);
      ['rsok', 'rssv', 'rserro'].forEach(function (k) { cond(l, k, 0); });
    }
    rodapeRsvp();
    if (!st.rsvpIndo) proximoRsvp();
  }
  function proximoRsvp() {
    var x = filaRsvp.shift();
    /* A VISTA INTEIRA VOLTA DO SERVIDOR, e continua sendo de proposito: a
       resposta de uma pessoa mexe no status DERIVADO do convite, na contagem de
       confirmados, na projecao de presentes e no fecho. O que a pessoa ve e o
       que ficou gravado. */
    if (!x) { st.rsvpIndo = 0; st.ps = st.lt; st.lt = 0; return verConvite(); }
    st.rsvpIndo = 1;
    req('POST', '/convite/rsvp', corpoAcesso({ alvo: x.alvo, resposta: x.r, chaveIdem: opId() })).then(function (j) {
      if (!j._ok) {
        /* o prazo fechou ou o evento caiu com esta pagina aberta: a resposta NAO
           entrou, e a tela precisa dizer o que vale agora - por isso recarrega */
        var m = j.erro === 'prazo_fechado' ? T.rs_eprz : j.erro === 'evento_cancelado' ? T.rs_ecanc : '';
        if (!m) return falhouRsvp(x, msgErro(j));
        filaRsvp = [];
        st.rsvpIndo = st.lt = 0;
        bad(m);
        return verConvite();
      }
      /* o que o servidor acabou de gravar ja vale na linha: se a fila parar no
         meio, a banda repintada diz a verdade de quem ja respondeu */
      euPessoas().forEach(function (p) {
        if (p.id !== x.alvo) return;
        /* a frase do leitor de tela (R30, parte L): "salva" na primeira resposta
           da pessoa, "atualizada" na troca */
        if (viva) st.lt.m.push(fmt(temResposta(p) ? T.rs_sa : T.rs_sg, { nome: p.nome, resposta: x.r === 'vou' ? T.rs_pv : T.rs_pnv }));
        p.status = RSVP[x.r];
      });
      /* o sinal na linha e o rodape ja com a resposta confirmada, antes da
         vista refeita (R31, decisao 116). Com um toque mais novo da mesma
         pessoa ainda na fila, a linha ja mostra a resposta nova, que nao foi
         confirmada: o sinal espera o OK dela. */
      if (!filaRsvp.some(function (y) { return y.alvo === x.alvo; })) salvoRsvp(x.alvo);
      rodapeRsvp();
      proximoRsvp();
    }).catch(function () { falhouRsvp(x, T.e_rede); });
  }
  /* O TOQUE QUE NAO SALVOU (rede, teto de chamadas, erro do servidor que nao
     muda o evento; R31, decisao 116 e adendo B1 item 7): o erro aparece NA
     PROPRIA LINHA ("Nao salvou." e o "Tentar de novo"), junto do dedo, e nao
     mais no aviso do pe da tela (NN/g: "in close proximity to that element";
     plano R31, 2.9). Vale para o toque que falhou e para os da fila que nem
     sairam (num "Todo mundo vai", cada linha que nao gravou diz isso). O botao
     volta ao que estava (pararRsvp, que refaz as linhas e o rodape so com o
     que o servidor confirmou). O leitor de tela ouve a mesma frase, com o nome
     de cada linha, pela regiao viva de sempre, depois das respostas que este
     lote ja tinha gravado (a pintura depois da fila nao vem: o lote morre
     aqui). Com a section antiga (sem o rs_el, e sem o erro no template da
     linha), o aviso do pe de antes. */
  function falhouRsvp(x, m) {
    var l = [x].concat(filaRsvp), t = st.lt ? st.lt.m : [], bd = q(st.vista, '.mwev-rsvp');
    var f = bd && bd.contains(document.activeElement) && st.foco, a1 = st.av & 1;
    filaRsvp = [];
    st.rsvpIndo = st.lt = 0;
    if (!('rs_el' in T)) { bad(m); return pararRsvp(); }
    l.forEach(function (y) {
      st.er[y.alvo] = y.r;
      euPessoas().forEach(function (p) { if (p.id === y.alvo) t.push(fmt(T.rs_baria, { nome: p.nome, resposta: T.rs_el })); });
    });
    pararRsvp();
    /* O FOCO VOLTA AO BOTAO TOCADO (plano 4.6: o foco nao se move pela
       resposta): o pararRsvp refez as linhas, e o botao que tinha o foco saiu
       da pagina com elas (o foco caia no body, e o teclado e o leitor de tela
       recomecavam do topo). So quando o foco estava na faixa (a pessoa nao foi
       para outro lugar enquanto o POST voltava), e sem pulo; o botao ja esta
       de volta ao que estava, e o "Tentar de novo" fica na mesma linha, logo
       depois dos dois botoes, na ordem do Tab. */
    f = f && q(st.vista, f);
    if (f && !bd.contains(document.activeElement)) f.focus({ preventScroll: true });
    /* O AVISO DO PAINEL num lote que parou no meio (plano 4.6: o pos.aviso_abaixo
       na primeira vez que o nivel 1 aparece na visita): com uma resposta gravada
       antes do erro, o pararRsvp pode mostrar o nivel 1 pela primeira vez, e a
       pintura dele ja marca o aviso como dado (bit 1 de `st.av`, lido antes) */
    if (st.n1 && !a1) t.push(T.pos_ab);
    if (viva) {
      tc(viva, '');
      setTimeout(function () { tc(viva, t.join(' ')); }, 50);
    }
  }
  /* erro que nao muda o evento (rede, teto de chamadas): sem recarregar a vista,
     que bateria no mesmo muro e trocaria a pagina pela tela de erro */
  function pararRsvp() {
    qa(st.vista, '[aria-busy]').forEach(function (e) { rmA(e, 'aria-busy'); });
    st.foco = '';
    pintarRsvp();
    pintarPos();
    pintarGuardar();
  }

  /* ---------------- .ics gerado no cliente (3.13) ----------------
     O convite nunca vira evento no servidor de ninguem. Com hora, o instante ja
     veio derivado do servidor (startsAt/endsAt) e sai em UTC, que dispensa o
     bloco VTIMEZONE; sem hora vira evento de dia inteiro, a forma do RFC 5545
     para data civil. */
  function icsCarimbo(iso) { return String(iso).replace(/[-:]/g, '').replace(/\.\d+/, ''); }
  function icsDia(d, mais) {
    var p = String(d).split('-');
    var x = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + (mais || 0)));
    return x.toISOString().slice(0, 10).replace(/-/g, '');
  }
  /* escape do RFC 5545: virgula, ponto-e-virgula e barra sao separadores de
     campo na linha e literais no texto */
  function icsTxt(s) {
    return String(s || '').replace(/\\/g, '\\\\').replace(/([,;])/g, '\\$1').replace(/\r?\n/g, '\\n');
  }
  function baixarIcs() {
    var ev = st.ev;
    if (!ev.data) return;
    var nome = ev.nome || T.sem_nome;
    var L = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Montzel//EV//PT', 'BEGIN:VEVENT',
      'UID:' + ev.id, 'DTSTAMP:' + icsCarimbo(new Date().toISOString())];
    if (ev.hora && ev.startsAt) {
      L.push('DTSTART:' + icsCarimbo(ev.startsAt));
      if (ev.endsAt) L.push('DTEND:' + icsCarimbo(ev.endsAt));
    } else {
      L.push('DTSTART;VALUE=DATE:' + icsDia(ev.data));
      L.push('DTEND;VALUE=DATE:' + icsDia(ev.dataFim || ev.data, 1));
    }
    L.push('SUMMARY:' + icsTxt(nome));
    if (ev.localTexto) L.push('LOCATION:' + icsTxt(ev.localTexto));
    L.push('END:VEVENT', 'END:VCALENDAR');
    /* NFD + corte das marcas combinantes: sem isso a letra acentuada nao casa
       [a-z0-9] e "Aniversario" baixaria como anivers-rio.ics */
    var arq = nome.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'ics';
    var url = URL.createObjectURL(new Blob([L.join('\r\n')], { type: 'text/calendar;charset=utf-8' }));
    var a = mk('a');
    a.href = url;
    a.download = arq + '.ics';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }

  /* ---------------- guardar o convite na conta (R30, parte E) ----------------
     Decisoes 78 e 89 do dono. O bloco aparece logo depois da resposta, para
     logado e deslogado, e so para quem abriu pelo LINK (sem token nao ha o que
     ligar), com alguem do convite ja respondido e fora do evento cancelado.
     O homenageado ve o bloco como todo mundo (decisao 92, 2026-09-30): o
     outbox so o poupa do pedido de nova resposta, e o lembrete, o aviso de
     mudanca e o cancelamento chegam a ele. Quatro estados, e quem decide e a
     resposta do `ver`:
     - o botao: logado com `podeVincular` ou `recusado` (o toque e explicito e o
       vincular apaga a recusa); deslogado com o convite livre. Ate a F8 o `ver`
       do ar nao manda `livre`, e a ausencia vale como livre;
     - `guardaroutro`: o convite ja esta na conta de OUTRA pessoa (`livre` falso
       e o `guardadoPor` presente, vazio quando a conta nao tem nome). Sem o
       campo (o `ver` de antes da F8), nenhuma frase;
     - `guardarok`: a conta acabou de ligar, pelo toque ou pela volta do login.
       Ele vale MESMO sem resposta e para o homenageado: quem entrou pelo convite
       antes de responder, ou o homenageado pelo "Entrar", ligou de verdade, e o
       texto dele nao promete aviso. A rolagem e o foco acontecem UMA vez
       (`gOk` 2 -> 1); nenhuma resposta depois rola por causa dele;
     - nada: o convite ja estava ligado a conta de quem ve (o rodape diz).
     Toda busca de slot tolera nulo: o JS novo roda com a section antiga entre
     o passo 3 e o 4 da publicacao (F8). */
  function pintarGuardar() {
    var v = st.vista, vc = st.vinc || {}, g = cond(v, 'guardar', 0);
    /* `st.gc` (R30, parte L): o botao ou o link "Guardar" a vista, ou 0 */
    st.gc = 0;
    if (!g) return;
    var gp = vc.guardadoPor, ps = euPessoas();
    var ok = !!st.gOk && !!vc.vinculado;
    var outro = !vc.vinculado && vc.livre === false && typeof gp === 'string';
    var cta = !ok && !outro && (LOGADO ? !!(vc.podeVincular || vc.recusado) : vc.livre !== false);
    if (!ok) st.gOk = 0;
    /* O NIVEL 2 DO PAINEL DEPOIS DA RESPOSTA (R31, parte DEPOIS; plano 4.6): o
       bloco espera o painel (`st.pe`, do pintarPos, que vem antes). Aparece com
       o painel na tela sem o nivel 1 (o "Agora nao", o presente ja escolhido),
       sem painel e sem nada a oferecer (o convite so do homenageado, decisao
       92), no evento que ja aconteceu com resposta e, sempre, na confirmacao
       da conta. A linha verde da confirmacao da resposta (`guardarconf`,
       decisao 91) saiu: o titulo do painel ja confirma. */
    var e = st.pe || {};
    if (st.ev.cancelado || !tokenConvite || !(ok || ps.some(temResposta) && (outro || cta)
      && (e.h && !st.n1 || !e.h && e.s || st.ev.status === 'realizado' && e.r))) return;
    hd(g, 0);
    hd(slot(g, 'guardartitulo'), !cta);
    /* o corpo nao promete avisos a quem ninguem do convite vai: esse convite nao
       recebe lembrete (decisao 9) */
    txtOuSome(g, 'guardarcorpo', cta ? (!algumVai() ? T.gd_cn : ps.length > 1 ? T.gd_cg : T.gd_cs) : '');
    hd(slot(g, 'guardaracoes'), !cta);
    hd(acao(g, 'guardar'), !LOGADO);
    var a = slot(g, 'guardarentrar');
    hd(a, LOGADO);
    if (a && !LOGADO) a.href = LOGIN + encodeURIComponent(URLEV + '?volta=1');
    hd(slot(g, 'guardarnota'), !cta || LOGADO);
    txtOuSome(g, 'guardaroutro', outro ? (gp ? fmt(T.gd_out, { nome: gp }) : T.gd_out0) : '');
    if (cta) st.gc = LOGADO ? acao(g, 'guardar') : a;
    var n = slot(g, 'guardarok');
    hd(n, !ok);
    /* a confirmacao chega de uma vista inteira refeita: a pagina rola SUAVE ate
       o TOPO do bloco (o dono pediu que nada pule; F6: mirando a frase, a linha
       verde de cima ficava atras do cabecalho, ou a frase a 10 px da borda de
       baixo) e o foco vai para a frase sem outro pulo */
    if (ok && st.gOk > 1) {
      st.gOk = 1;
      setTimeout(function () { rolarAte(g, n); }, 0);
    }
  }
  /* o minimo de rolagem para o elemento ficar inteiro entre o cabecalho preso e
     a barra de baixo. `foco` e o elemento que recebe o foco, com preventScroll
     (a parte L rola sem mover o foco); com ele, a rolagem que precisar
     acontecer poe o TOPO de `e` logo abaixo do cabecalho, com a folga do
     topoLivre: o bloco inteiro descoberto e folga embaixo (R30, F6; a
     confirmacao da conta). Devolve o quanto rolou (0 = ja estava inteiro). */
  function rolarAte(e, foco) {
    if (!e || !e.offsetWidth) return;
    var r = e.getBoundingClientRect(), vv = window.visualViewport;
    var topo = topoLivre();
    var fundo = Math.min(innerHeight, vv ? vv.height : innerHeight) - 12 - (barra && !barra.hidden ? barra.offsetHeight : 0);
    var dy = r.top < topo || foco && r.bottom > fundo ? r.top - topo : r.bottom > fundo ? Math.min(r.bottom - fundo, r.top - topo) : 0;
    if (dy) window.scrollTo({ top: Math.max(0, window.scrollY + dy), behavior: modoRola() });
    if (foco) foco.focus({ preventScroll: true });
    return dy;
  }
  /* DEPOIS DA RESPOSTA (R30, parte L; decisao 91 do dono). Roda depois da vista
     refeita pela fila, e so no lote que gravou tudo OK (erro zera o lote):
     - a regiao viva, fora do palco, diz cada resposta gravada: esvaziada e
       escrita logo depois (50 ms), para o leitor de tela ouvir a troca. Na
       primeira vez que o botao Guardar aparece depois de uma resposta, ela avisa
       que ele esta logo abaixo;
     - a rolagem suave ate o botao Guardar, UMA vez na visita, so quando este
       lote levou o convite de "falta alguem" a "todos responderam" (o ultimo
       nome, ou "Todo mundo vai" / "Ninguem vai"; mudar a resposta depois nao
       rola) e sem gesto da pessoa entre o toque e o OK, nem na pausa. Rola o
       minimo (rolarAte): com o botao ja inteiro na tela nada rola, e a
       confirmacao fica logo acima dele. O foco NAO se move (WCAG 3.2.2): fica
       no botao tocado. A pausa deixa o olho registrar o botao marcado.
     Desde a R31 (parte DEPOIS; decisoes 107 e 116) o alvo e o PAINEL depois da
     resposta (`st.pv`), e o Guardar so sem ele (a section antiga). A regra de
     quando rolar nao muda: o painel aparece ja no primeiro toque, sem rolar, e
     a pagina so desce quando o convite inteiro respondeu. A regiao viva avisa
     o painel (`pos_ab`) na primeira vez que o NIVEL 1 aparece na visita (bit 1
     de `st.av`; o lote guardar so se a secao estava na tela nao basta: na
     troca de lado depois do "Agora nao", a secao ja estava, no nivel 2, e o
     nivel 1 aparece pela primeira vez); quando o primeiro a aparecer e o
     nivel 2, o aviso e o do botao Guardar, se ele estiver la (bit 2). */
  function posResposta() {
    var p = st.ps, b = st.pv || st.gc, ab, t;
    st.ps = 0;
    if (!p) return;
    ab = st.n1 ? !(st.av & 1) && T.pos_ab : st.gc && !p.g && !st.av && T.gd_ab;
    if (viva) {
      t = p.m.join(' ');
      if (ab) t += ' ' + ab;
      tc(viva, '');
      setTimeout(function () { tc(viva, t); }, 50);
    }
    st.av |= st.n1 ? 1 : ab ? 2 : 0;
    if (p.f && st.td && b && !st.ro && !st.gs) st.tr = setTimeout(function () { if (!st.gs && rolarAte(b)) st.ro = 1; }, 500);
  }
  /* o gesto da pessoa (rolar, tocar, tecla) cancela a rolagem ate o Guardar; a
     rolagem do proprio tema nao e gesto */
  ['pointerdown', 'wheel', 'touchmove', 'keydown'].forEach(function (n) { document.addEventListener(n, function () { st.gs = 1; }, true); });
  /* A marca da volta do login: o toque no "Guardar" deslogado e no "Ja tem
     conta? Entrar" do rodape grava o id do convite. Entrar pela pagina do
     convite sempre guarda o convite (palavra do dono: "ao fazer login ou criar
     conta"). Ela vive na sessao da aba, como o token, e morre na leitura. */
  function marcarLig() {
    var id = euConvite();
    if (id) mem(0, 'mw_ev_lig', id);
  }
  /* o boot le a marca antes da vista e a apaga na hora: so quem esta logado a
     usa, e so no mesmo convite (voltaLig) */
  function lerLig() {
    var m = mem(0, 'mw_ev_lig');
    if (m) mem(0, 'mw_ev_lig', null);
    st.ligVolta = LOGADO ? m : '';
  }
  /* depois da vista pintada: o convite ainda livre liga SOZINHO, sem outro toque;
     o que ja estava ligado a conta (pelo email) so mostra a confirmacao; o que
     outra pessoa guardou no meio fica com a frase `guardaroutro` do pintarGuardar */
  function voltaLig() {
    var m = st.ligVolta, vc = st.vinc || {};
    st.ligVolta = '';
    if (!m || m !== euConvite()) return;
    if (vc.podeVincular || vc.recusado) return ligarConta();
    if (vc.vinculado) {
      st.gOk = 2;
      pintarGuardar();
    }
  }
  /* `vincular` so existe pelo token e e ato EXPLICITO: abrir um link
     encaminhado nao pode ligar a conta de quem abriu a um nome escolhido por
     outra pessoa (D8). O toque no "Guardar" e o consentimento, sem janela de
     confirmacao (o dono pediu o minimo de toques); a volta do login liga porque
     o toque veio antes dela. Na corrida com outra conta a rota responde 409
     (`outra_conta`): o estado proprio sai do `ver`, e nao o toast de erro. */
  function ligarConta() {
    if (st.ligVoo || !tokenConvite) return;
    var b = acao(st.vista, 'guardar');
    var fim = function () { st.ligVoo = 0; rmA(b, 'aria-busy'); };
    st.ligVoo = 1;
    S(b, 'aria-busy', 'true');
    req('POST', '/convite/vincular', corpoAcesso({})).then(function (j) {
      fim();
      if (!j._ok && !j.outraConta && j.erro !== 'outra_conta') return bad(msgErro(j));
      if (j._ok) st.gOk = 2;
      verConvite();
    }).catch(function () { fim(); quedaDeRede(); });
  }

  /* ---------------- rodape de servico ---------------- */
  /* estado do vinculo -> [frase, rotulo do botao, acao]. A ORDEM das chaves e a
     precedencia: "ligado a outra conta" vence tudo (nao ha o que fazer por aqui).
     O "pode vincular" (o texto dourado "Ligar este convite a minha conta") saiu
     na R30, parte E: quem liga e o bloco "Guardar", logo depois da resposta. */
  var VINC = {
    outraConta: ['vc_outra', 'vc_deso', 'desvincular'],
    vinculado: ['vc_lig', 'vc_desl', 'desvincular'],
    recusado: ['vc_rec', 'vc_perm', 'permitir']
  };
  function pintarServico() {
    var v = st.vista, vc = st.vinc || {}, l = ['', '', ''];
    for (var k in VINC) {
      if (vc[k]) { l = VINC[k]; break; }
    }
    /* a reserva da section anterior a R30 (sem o bloco "Guardar", com o texto
       dourado `vc_ligar` e a ajuda `vincajuda`) saiu no fechamento da R31 (Z0) */
    var txt = T[l[0]] || '';
    var rotulo = T[l[1]] || '';
    st.vincAcao = l[2];
    txtOuSome(v, 'vinctxt', txt);
    var b = acao(v, 'vinculo');
    tc(b, rotulo);
    hd(b, !rotulo);
    /* deslogado o convite abre igual; "Ja tem conta? Entrar" volta para ca por
       ?volta=1 (o token vai ao sessionStorage no pagehide) e, desde a R30, liga
       o convite na volta (marcarLig) */
    var entrar = slot(v, 'entrar');
    hd(entrar, LOGADO);
    if (entrar && !LOGADO) entrar.href = LOGIN + encodeURIComponent(URLEV + '?volta=1');
    cond(v, 'vinculo', !!(txt || rotulo) || !LOGADO);
  }

  function acaoVinculo() {
    var a = st.vincAcao;
    if (a === 'desvincular') {
      return pedeConv('desvincular', {}, function (j) {
        /* "permitir de novo" so vale quando a conta era a titular (a rota grava
           a recusa e devolve `recusa`); desligar OUTRA conta so solta a linha */
        if (j.recusa) toast(T.vc_ok);
        if (tokenConvite) return verConvite();
        /* pela conta ({e}) o vinculo era o unico acesso e o `ver` responderia
           404: a pessoa volta para Meus eventos */
        history.replaceState(null, '', URLEV + '?lista=1');
        /* a barra mora no root, fora do palco: a lista nao a leva junto */
        sumirBarra();
        modoLista();
      });
    }
    /* `permitir` apaga a recusa pela PROPRIA conta: ela passa por `{e}`, nunca
       pelo token (o organizador possui os tokens e nao escreve em conta alheia) */
    if (a === 'permitir') {
      return pede('POST', '/convite/permitir', { e: st.id }, verConvite).catch(quedaDeRede);
    }
    /* o `vincular` mora no ligarConta(), do bloco "Guardar" (R30, parte E) */
  }

  function denunciarCapa() {
    dialogo({
      titulo: T.dn_conf,
      sim: T.dn_link,
      nao: T.ex_no,
      aoSim: function () {
        pedeConv('denunciar-capa', {}, function () {
          st.denunciado = 1;
          pintarCabecalhoConv();
        });
      }
    });
  }

  /* ---------------- saidas da secao 4 (LGPD) ---------------- */
  function sairDoEvento() {
    pedeConv('sair', { escopo: 'evento' }, function () {
      txtOuSome(st.vista, 'saidaok', T.pv_sok);
      hd(acao(st.vista, 'sair'), true);
    });
  }

  /* PARADO por decisão do dono de 2026-09-23 (docs/eventos/DECISOES-DO-DONO.md):
     o convidado não remove os próprios dados pela tela; se um dia pedir, reativar
     aqui e em painel/src/lib/eventos/remocao-ampla.ts (REMOCAO_PELO_CONVIDADO_ATIVA).

     O DEFEITO QUE FICA REGISTRADO JUNTO (convite de familia): a Ana convida
     "Rodrigo, Carol e Julia" num convite so, com o email do Rodrigo. O Rodrigo
     abre o link ja conectado a conta, o convite se liga a conta dele, e ele pede
     "Remover meus dados". Devia sair so o Rodrigo; saiam os tres, e o link parava
     de abrir para a Carol e a Julia - remover o titular derrubava o link dos
     outros. Reativar exige consertar isso no painel antes.

     Para reativar: tirar este comentario, voltar o `clique(v, 'remover',
     removerDados)` no ligarConvite() e o botao `data-a="remover"` no bloco de
     emails do template `convite` (sections/mw-evento.liquid). As chaves
     (pv_rm, pv_rmc, rm_*) continuam na ponte i18n e no locale. Os comentarios
     de dentro viraram `//` para este bloco poder ficar comentado inteiro.

  function removerDados() {
    dialogo({
      titulo: T.pv_rm,
      corpo: [T.pv_rmc],
      sim: T.pv_rm,
      nao: T.ex_no,
      perigo: true,
      aoSim: function () {
        pedeConv('remover-dados', {}, function (j) {
          // o token morreu com a linha: nada de regravar no pagehide, e nada de
          // deixar a vista antiga na tela
          tokenConvite = null;
          mem(0, 'mw_evento_c', null);
          sumirBarra();
          var corpo = j.amplo ? (j.parcial ? T.rm_parc : T.rm_amplo) : (j.canal ? T.rm_canal : T.rm_sem);
          // qualquer um dos quatro desfechos manda a pessoa ao canal permanente,
          // que desde a R-38 (nenhum email no site) e o formulario de contato: a
          // frase e o link para ele vao juntos, em vez de ficar so na promessa
          var lk = mk('a', 0, T.rm_ctl);
          lk.href = URLCONTATO;
          slot(telaAviso(T.rm_t, corpo + ' ' + T.rm_ctt + ' ', { rotulo: T.en_volta, href: URLLOJA }), 'corpo').appendChild(lk);
        });
      }
    });
  }
  */

  /* "Convite aberto" e o unico carimbo que o organizador LE, e ele so pode
     nascer de gente: um pre-fetch de scanner de email nao dispara pointerdown,
     keydown nem scroll. Uma vez por carregamento. */
  function marcarInteracao() {
    /* `st.abriu`: undefined = ainda nao registrou os listeners; 0 = registrados
       e esperando; 1 = ja avisou. Os tres listeners sao `once` e se removem
       sozinhos, mas o primeiro a bater tem que calar os outros dois. */
    if (st.abriu != null) return;
    st.abriu = 0;
    var opt = { once: true, capture: true };
    function bateu() {
      if (st.abriu) return;
      st.abriu = 1;
      req('POST', '/convite/ver', corpoAcesso({ interacao: true })).catch(function () {});
    }
    /* A rolagem conta desde a R30 (decisao 75): a pagina nao rola mais sozinha
       na abertura, entao o scroll e de gente. Ate ali, aberta pelo link, so
       clique e tecla contavam, porque a propria pagina descia ate a banda. O
       reload de tocar de novo no mesmo link pode restaurar a rolagem e contar
       como abertura: e o mesmo convite, aberto de novo por quem tem o link. */
    ['pointerdown', 'keydown', 'scroll'].forEach(function (n) { document.addEventListener(n, bateu, opt); });
  }

  /* ---------------- barra inferior condicional ---------------- */
  /* UM OBSERVADOR SO, na banda, para a barra do celular: com a banda na tela a
     barra some; fora da tela, ela volta. Trocado apenas quando a banda e outro
     no. Na F7 (plano 2026-09) este mesmo observador tambem tirava o lancador do
     Curador de cena com a banda na tela; desde a F10 (decisao 50 do dono) o
     lancador nao aparece nesta pagina (CSS da section), e essa metade saiu.
     O MESMO observador vigia o "Responder ao convite" do fecho, com o mesmo
     limiar: com ele na tela a barra tambem some, porque no fim da pagina os dois
     botoes iguais ficavam um em cima do outro. Escondido (`hidden`), ele nunca
     cruza a tela, entao nao segura a barra. */
  var bandaIO = null, bandaAlvo = null, fechoNaTela = false, bandaNaTela = false;
  function vigiarBanda(alvo) {
    if (alvo === bandaAlvo || !window.IntersectionObserver) return;
    if (bandaIO) bandaIO.disconnect();
    bandaAlvo = alvo;
    fechoNaTela = false;
    bandaNaTela = false;
    bandaIO = alvo && new IntersectionObserver(function (ents) {
      /* so chegam as entradas que MUDARAM: cada uma atualiza a sua metade */
      ents.forEach(function (e) {
        if (e.target !== alvo) fechoNaTela = e.isIntersecting;
        else bandaNaTela = e.isIntersecting;
      });
      barraFora = !bandaNaTela;
      avaliarBarra();
    });
    if (!bandaIO) return;
    bandaIO.observe(alvo);
    var fr = acao(st.vista, 'fecho-responder');
    if (fr) bandaIO.observe(fr);
  }
  /* alguem do convite ainda pode responder e nao respondeu: a regra da barra e
     do "Responder ao convite" do fecho */
  function faltaAlguem() {
    return podeResp() && euPessoas().some(function (p) { return p.podeResponder && !temResposta(p); });
  }
  function responder() { irAteBanda(true); }
  function sumirBarra() {
    if (barra) { barra.remove(); barra = null; }
    document.body.classList.remove('mwev-com-barra');
  }
  function avaliarBarra() {
    if (!barra) return;
    hd(barra, !(barraFora && !barraFoco && !fechoNaTela));
    document.body.classList.toggle('mwev-com-barra', !barra.hidden);
  }
  function pintarBarra() {
    /* so enquanto falta ALGUEM do convite responder: quem ja marcou todo mundo
       nao precisa de atalho para a banda, e o homenageado nunca tem banda */
    if (!faltaAlguem()) return sumirBarra();
    if (!barra) {
      barra = clone('barra');
      if (!barra) return;
      clique(barra, 'barra-cta', responder);
      root.appendChild(barra);
    }
    /* quem diz se a banda esta fora da tela e o observador de vigiarBanda;
       sem IntersectionObserver o `barraFora` fica falso e a barra nunca aparece */
    avaliarBarra();
  }

  /* ---------------- listeners da vista ---------------- */
  function ligarConvite(v) {
    /* os `[data-r]` moraram aqui ate a r05, quando eram DOIS botoes fixos no
       template. Agora eles nascem por PESSOA, dentro de `linhaRsvp`, e sao
       ligados la - ligar daqui pegaria zero botao na primeira pintura. */
    clique(v, 'rsvp-todos', function () { atalhoRsvp('vou', this); });
    clique(v, 'rsvp-ninguem', function () { atalhoRsvp('nao_vou', this); });
    clique(v, 'vaga-incluir', incluirVaga);
    clique(v, 'ics', baixarIcs);
    clique(v, 'fecho-cta', presentearPadrao);
    /* o painel depois da resposta (R31, parte DEPOIS): um ouvinte so, na secao,
       porque os botoes de presente nascem e somem a cada pintura */
    on(q(v, '[data-slot-if="pos"]'), 'click', function (e) {
      var b = e.target.closest('[data-a]'), a = b ? b.getAttribute('data-a') : '';
      if (a === 'pos-presente') semearCurador(b.getAttribute('data-d'));
      if (a === 'pos-lista') posLista();
      if (a === 'pos-depois') agoraNao();
    });
    clique(v, 'fecho-responder', responder);
    clique(v, 'topo-responder', responder);
    clique(v, 'denunciar', denunciarCapa);
    clique(v, 'vinculo', acaoVinculo);
    clique(v, 'guardar', function () { ligarConta(); });
    on(slot(v, 'guardarentrar'), 'click', marcarLig);
    on(slot(v, 'entrar'), 'click', marcarLig);
    clique(v, 'sair', sairDoEvento);
    clique(v, 'presentear-evento', function () { semearCurador('evento'); });
    if (L) L.ligar(v);
    if (st.convLigado) return;
    st.convLigado = 1;
    /* TOCAR DE NOVO NO MESMO LINK com a pagina aberta nao desce mais ate a
       resposta (R30, decisao 75). Aqui havia um ouvinte de hashchange que
       chamava irAteBanda(); ele saiu inteiro. O que acontece e do inline do
       layout (layout/theme.liquid): o boot apagou o token do sessionStorage
       (pegarToken), o inline o acha "novo" e recarrega a pagina, que abre onde
       o navegador restaurar a rolagem, sem descida automatica. */
    /* a barra some quando o teclado do celular sobe. So campo de texto conta:
       com botao, ela sumiria no foco do proprio clique. */
    on(document, 'focusin', function (e) {
      var t = (e.target || {}).tagName;
      if (t !== 'INPUT' && t !== 'TEXTAREA' && t !== 'SELECT') return;
      barraFoco = true;
      avaliarBarra();
    });
    on(document, 'focusout', function () { barraFoco = false; avaliarBarra(); });
  }

  /* ============================ MEUS EVENTOS ============================ */
  function modoLista(faixaTeto) {
    st.modo = 'lista';
    if (!LOGADO) return porta('lista');
    req('GET', '').then(function (j) {
      if (!j._ok) return telaErroResposta(j);
      st.lista = j;
      montarLista(faixaTeto);
    }).catch(telaErroRede);
  }

  /* Exclusao adiada, a metade que o BOOT le (a outra, `exJan` com o DESFAZER
     correndo, mora no assets/mw-evento-org.js desde a R29): `exFeito` marca o
     evento que esta aba ja excluiu (o ?e= dele vai para a lista) e atravessa por
     referencia no objeto X; `exBoot` e a trava da retomada no boot. */
  var exFeito = {}, exBoot = 0;
  /* evento excluido nao tem mais pagina (GET /:id filtra `excluidoEm`) */
  function irLista() { location.replace(URLEV + '?lista=1'); }

  /* ============================ TELAS DE ESTADO ============================ */
  function telaAviso(titulo, corpo, cta) {
    var n = clone('aviso');
    setText(n, 'titulo', titulo);
    setText(n, 'corpo', corpo);
    var a = slot(n, 'cta');
    if (cta && a) { hd(a, false); tc(a, cta.rotulo); a.href = cta.href; }
    trocar(n);
    return n;
  }
  function telaErroRede() {
    var n = clone('aviso');
    setText(n, 'titulo', T.e_desl_t);
    setText(n, 'corpo', T.e_rede);
    S(n, 'role', 'alert');
    var b = acao(n, 'recarregar');
    hd(b, false);
    on(b, 'click', function () { boot(); });
    trocar(n);
  }
  function telaErroResposta(j) {
    var e = j && j.erro;
    /* 401 fora do modo criar = a conta caiu com um evento ou convite aberto
       (?e= de bookmark cai em modo 'evento', nunca em 'convite'): a porta certa
       e a de "Meus eventos". A de criar conta a metrica da D12 e, depois do
       codigo, criaria um evento vazio no lugar do que a pessoa abriu. */
    if (j._status === 401 || e === 'nao_logado') {
      return porta(st.modo === 'novo' ? 'novo' : 'lista');
    }
    if (e === 'conta_desligada') return telaAviso(T.e_desl_t, T.e_conta);
    if (e === 'eventos_desligados') {
      /* R-52: o servidor manda o ALCANCE da queda no corpo (`escopo`). Com
         `criacao` as rotas de USO nem respondem 503 (`acesso.ts`), entao quem chega
         nesta tela por esse caminho e o organizador tentando criar: a mensagem tem
         que dizer que so a criacao caiu, senao ele acha que perdeu os eventos.
         Escopo ausente ou desconhecido cai na queda INTEIRA, o lado seguro, pelo
         mesmo motivo do fallback do Liquid na pagina publica. */
      var so = j && j.escopo === 'criacao';
      return telaAviso(so ? T.e_dcr_t : T.e_dtu_t, so ? T.e_dcr_c : T.e_dtu_c, {
        rotulo: T.e_dvinhos,
        href: '/collections/vinhos',
      });
    }
    if (e === 'organizador_bloqueado') {
      return telaAviso(T.e_blq_t, T.e_blq_c, { rotulo: T.e_blq_t, href: URLCONTATO });
    }
    if (e === 'convite_invalido') return telaAviso(T.e_tok_t, T.e_tok_c);
    if (e === 'nao_encontrado') return telaAviso(T.menu, T.e_404, { rotulo: T.ml_vt, href: URLEV + '?lista=1' });
    if (e === 'organizador_sem_email') return telaAviso(T.e_desl_t, T.e_semmail);
    if (e === 'evento_cancelado') return telaAviso(T.e_desl_t, T.e_canc);
    /* 429 NAO e queda de rede, e dizer que e faz duas mentiras de uma vez: a
       conexao nao falhou, e "tente de novo" - a acao que a tela de rede sugere -
       e justamente o que re-arma o teto. A frase certa ja existia e ja estava
       mapeada para os outros caminhos (`muitas_chamadas: 'e_aguard'`); so o boot
       do convidado caia no `else`. Medido na validacao em producao, quando o
       harness gastou o teto de 30 chamadas por minuto do mesmo convite. */
    if (e === 'muitas_chamadas') return telaAviso(T.e_desl_t, T.e_aguard);
    return telaErroRede();
  }
  /* Queda pelo interruptor do TEMA: o servidor nao chega a responder, entao o
     alcance vem do atributo. Mesmo par de mensagens e mesma saida comercial do
     caminho do 503, senao a mesma queda diz duas coisas diferentes conforme
     qual das duas chaves foi desligada. */
  function telaDesligado() {
    var so = root.getAttribute('data-eventos-escopo') === 'criacao';
    telaAviso(so ? T.e_dcr_t : T.e_dtu_t, so ? T.e_dcr_c : T.e_dtu_c, {
      rotulo: T.e_dvinhos,
      href: '/collections/vinhos',
    });
  }

  /* Porta de login. `alvo` decide o return_to e a copy: criar, listar ou voltar. */
  function porta(alvo) {
    var n = clone('porta');
    var lista = alvo === 'lista';
    setText(n, 'titulo', lista ? T.en_lt : T.en_t);
    setText(n, 'corpo', lista ? T.en_lc : T.en_c);
    var volta = lista ? '?lista=1' : '?novo=1';
    slot(n, 'cta').href = LOGIN + encodeURIComponent(URLEV + volta);
    trocar(n);
    if (!lista) {
      /* metrica da porta (D12): so aqui, no modo criar. A porta de "Meus
         eventos" e o item de menu mediriam curiosidade, nao perda na criacao. */
      mem(0, 'mw_evento_porta', '1');
      req('POST', '/porta', {}).catch(function () {});
    }
  }

  /* ============================ CRIAR ============================
     UM request so (R-36): POST /eventos { chaveCriacao, origem? }. Desde o R25
     (2026-09-25) a pagina publica nao recolhe mais campo nenhum: o "Criar o
     evento" de la e um link para ?novo=1&o=landing, e o evento nasce vazio na
     pagina completa. O servidor segue aceitando nome, ocasiao e data opcionais
     (e `pulados`), so que o tema nao manda mais. A origem da metrica da D12:
     'porta' quando a porta de login foi vista nesta aba, senao 'landing' quando
     o link da pagina publica trouxe o `o=landing`.
     `mw_evento_chave` e `mw_evento_porta` so saem no 2xx. 401 volta a porta de
     criar (o telaErroResposta decide); 5xx, 429 e rede caem na tela de erro, cujo
     "Tentar de novo" roda o boot, que volta aqui com a MESMA chave (o servidor
     devolve o mesmo evento se o primeiro POST tiver entrado). */
  function modoNovo() {
    st.modo = 'novo';
    if (!LOGADO) return porta('novo');
    var chave = mem(0, 'mw_evento_chave') || '';
    if (!chave) mem(0, 'mw_evento_chave', chave = opId());
    var origem = mem(0, 'mw_evento_porta') === '1' ? 'porta' : /[?&]o=landing/.test(location.search) ? 'landing' : null;
    var corpo = { chaveCriacao: chave };
    if (origem) corpo.origem = origem;
    req('POST', '', corpo).then(function (j) {
      if (!j._ok) {
        if (j.erro === 'teto_eventos') return modoLista(true);
        return telaErroResposta(j);
      }
      ['chave', 'porta'].forEach(function (k) { mem(0, 'mw_evento_' + k, null); });
      location.replace(URLEV + '?e=' + j.id);
    }).catch(telaErroRede);
  }

  /* ============================ BOOT ============================ */
  function pegarToken() {
    var c = mem(0, 'mw_evento_c');
    if (c) mem(0, 'mw_evento_c', null);
    /* Desde a V7 o `r` nao pre-seleciona mais nada: link antigo com `&r=vou`
       abre no topo, como qualquer abertura pelo link (R30). O inline do layout
       ainda grava o valor que chega (mexer nele e mexer no core), e ele morre
       aqui, sem ser lido. A marca do token que o prendia (marcaTk) saiu junto. */
    mem(0, 'mw_evento_r', null);
    return c;
  }

  /* A fala semeada no Curador carrega o PRIMEIRO NOME de um convidado, e `ev: 1`
     e a marca dela. Ela vive no localStorage e o drawer do Curador abre em
     QUALQUER pagina da loja: sem esta limpeza o nome de terceiro reaparece longe
     da pagina que o originou. Sem `mw_evento_ctx` na sessao nao ha presente em
     curso, entao essas mensagens perderam o motivo de existir (5.1). O resto da
     conversa (a do Curador comum) fica intocado. */
  function limparFalaDoEvento() {
    if (memJson(0, 'mw_evento_ctx')) return;
    var conversa = memJson(1, 'mw_curador');
    if (!conversa || !conversa.length) return;
    var resto = conversa.filter(function (m) { return !(m && m.ev); });
    if (resto.length === conversa.length) return;
    mem(1, 'mw_curador', resto.length ? JSON.stringify(resto) : null);
  }

  function boot() {
    limparFalaDoEvento();
    var qs = new URLSearchParams(location.search);
    var temChave = !!mem(0, 'mw_evento_chave');
    var temPorta = mem(0, 'mw_evento_porta') === '1';

    if (!LIGADO) return telaDesligado();
    /* exclusao que a aba anterior nao terminou (pagehide sem resposta, processo
       morto pelo SO): sai antes de qualquer GET, e a tela ja vem sem ela */
    /* sem o modulo do organizador (`O`: a tag nao veio ou o arquivo nao
       carregou) a retomada espera a proxima carga: a marca continua no
       localStorage, e o resto do boot segue (R29) */
    var px = O && LOGADO && !exBoot && memJson(1, 'mw_evento_exc');
    if (px && px.length) {
      exBoot = 1;
      return Promise.all(px.map(function (id) { return excluirJa(id, avisoAntes(id)); })).then(boot, boot);
    }
    ouvirCarrinho();

    if (qs.has('novo')) return modoNovo();
    if (qs.get('e')) return exFeito[qs.get('e')] ? irLista() : abrirEvento(qs.get('e'));
    if (qs.has('lista')) {
      mem(0, 'mw_evento_c', null);
      mem(0, 'mw_evento_r', null);
      tokenConvite = null;
      return modoLista();
    }
    if (qs.has('volta')) {
      /* retorno do login: consome o token guardado antes da porta e a marca do
         "Guardar" (R30, parte E) */
      lerLig();
      tokenConvite = pegarToken();
      if (tokenConvite) return verConvite();
      return modoLista();
    }
    tokenConvite = pegarToken();
    /* a volta pelo Google pode perder o ?volta=1 (a marca-retorno traz a pessoa
       de volta pelo link): a marca do mesmo convite, logado, liga do mesmo jeito */
    if (tokenConvite) lerLig();
    /* aberta pelo link do convite: a vista monta no topo, na foto, como na
       volta do login (R30, decisao 75; ate ali ela descia ate a resposta) */
    if (tokenConvite) return verConvite();
    /* plano B do spike de ?novo=1: se a query nao sobreviver ao redirect do
       login, a presenca de chave/porta vale como intencao de criar. Sempre
       DEPOIS do token, para quem abriu um convite na mesma aba cair no convite. */
    if (temChave || temPorta) return modoNovo();
    return modoLista();
  }

  /* ========================= O MODULO DO ORGANIZADOR =========================
     Desde a R29 (plano R29, secao 3A) a parte de quem esta LOGADO mora em
     assets/mw-evento-org.js: a vista do organizador, "Meus eventos", criar,
     cancelar e excluir. Ele e uma FABRICA (window.MWEvOrg), carregada com defer
     ANTES deste arquivo e so dentro de {% if customer %}: o convidado deslogado,
     que chega pelo link do WhatsApp, nunca baixa uma linha dela.

     A COSTURA, em tres pecas, e o gate scripts/check-evento-divisao.mjs prova as
     tres:
     - X, abaixo: os nomes DESTE arquivo que o modulo usa. Ele os recebe no
       prologo (var st = X.st, ...), e a copia e dele: por isso nenhum nome de X e
       reatribuido dentro de funcao aqui (estado que os dois lados escrevem vive
       em `st`, que atravessa por referencia).
     - O: o que a fabrica devolve. Os encaminhadores de uma linha logo abaixo sao
       as funcoes do modulo que ESTE arquivo chama; os pontos de chamada nao
       mudaram uma letra.
     - Logado e o modulo nao carregou: `O` e null, o encaminhador lanca dentro da
       promessa de quem o chamou (abrirEvento, modoLista) e a tela cai no erro de
       rede com "Tentar de novo", que ja existia. */
  function retomarPendente() { return O.retomarPendente.apply(null, arguments); }
  function abrirCanal() { return O.abrirCanal.apply(null, arguments); }
  function retomarDeletes() { return O.retomarDeletes.apply(null, arguments); }
  function montarEvento() { return O.montarEvento.apply(null, arguments); }
  function pintarListaOrg() { return O.pintarListaOrg.apply(null, arguments); }
  function ligarMarcadores() { return O.ligarMarcadores.apply(null, arguments); }
  function removerPessoa() { return O.removerPessoa.apply(null, arguments); }
  function montarLista() { return O.montarLista.apply(null, arguments); }
  function avisoAntes() { return O.avisoAntes.apply(null, arguments); }
  function excluirJa() { return O.excluirJa.apply(null, arguments); }
  /* Os seis dos listeners da pagina (pagehide, visibilitychange, beforeunload,
     online), que rodam em TODA vista, a do convidado inclusive: sem o modulo
     nao ha autosave, fila de DELETE, aviso nem exclusao em curso, e eles nao
     fazem nada. */
  function sujo() { return O && O.sujo.apply(null, arguments); }
  function flush() { return O && O.flush.apply(null, arguments); }
  function flushSaida() { return O && O.flushSaida.apply(null, arguments); }
  function mandarPendentesDelete() { return O && O.mandarPendentesDelete.apply(null, arguments); }
  function mandarAvisosCancel() { return O && O.mandarAvisosCancel.apply(null, arguments); }
  function mandarExclusoes() { return O && O.mandarExclusoes.apply(null, arguments); }

  /* O objeto compartilhado: montado no fim, com todo var ja inicializado e o T
     ja trocado pelo Proxy. As chaves sao o prologo do modulo, uma a uma. */
  var X = {
    API: API, T: T, LOGIN: LOGIN, URLEV: URLEV, clone: clone, q: q, qa: qa, slot: slot,
    setText: setText, cond: cond, campo: campo, acao: acao, mk: mk, S: S, rmA: rmA,
    aria: aria, press: press, on: on, hd: hd, tc: tc, txtOuSome: txtOuSome,
    clique: clique, abrirModal: abrirModal, fecharModal: fecharModal, mem: mem,
    memJson: memJson, fmt: fmt, pl: pl, inicial: inicial, cap: cap, inerte: inerte,
    bloqueado: bloqueado, trocar: trocar, fDia: fDia, fHora: fHora, isoDe: isoDe,
    fCurta: fCurta, req: req, msgErro: msgErro, bad: bad, pede: pede,
    quedaDeRede: quedaDeRede, limparToast: limparToast, toast: toast, dialogo: dialogo,
    st: st, tituloOcasiao: tituloOcasiao, pessoasDe: pessoasDe, vagasDe: vagasDe,
    ehGrupo: ehGrupo, primeiro: primeiro, sv: sv, opId: opId, abrirEvento: abrirEvento,
    pintarCapa: pintarCapa, estadoCapa: estadoCapa, homenageados: homenageados,
    crescer: crescer, incompleto: incompleto, focarIncompleto: focarIncompleto,
    fechou: fechou, seloDe: seloDe, pintarLista: pintarLista, ehHome: ehHome,
    temHome: temHome, homePrimeiro: homePrimeiro, linhaPessoa: linhaPessoa,
    ligarPresentear: ligarPresentear, pintarPresentes: pintarPresentes,
    ligarCurador: ligarCurador, semearCurador: semearCurador, fraseFaixa: fraseFaixa,
    juntar: juntar, destinoPadrao: destinoPadrao, soHome: soHome, euHome: euHome,
    perfil: perfil, oc: oc, rotuloPapel: rotuloPapel, marcaPapel: marcaPapel,
    unidade: unidade, rotuloEvento: rotuloEvento, podePresentear: podePresentear,
    listaVis: listaVis, faltaHome: faltaHome,
    modoLista: modoLista, exFeito: exFeito,
    irLista: irLista, autoriaDe: autoriaDe, tituloGrupo: tituloGrupo,
    faladoGrupo: faladoGrupo, termos: termos, temPalavra: temPalavra,
    marcarEm: marcarEm, compararNome: compararNome
  };
  /* A BARRA DA LISTA DO CONVIDADO (R31; plano 4.0 item 7 e adendo A3) mora em
     assets/mw-evento-lista.js, carregado com defer antes deste arquivo: ele
     recebe o mesmo X do modulo do organizador e os tres nomes da lista do
     convidado que o X nao leva. Nulo sem a tag (a section de antes da onda B):
     o listaDoConvidado e o ligarConvite seguem sem a barra. */
  var L = window.MWEvLista ? window.MWEvLista(X, pubFechou, passaConv, stPub) : null;
  var O = window.MWEvOrg ? window.MWEvOrg(X) : null;

  boot();
})();
